import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
};

export type AcceptInviteInput = {
  /** User avatar URL */
  avatarURL?: InputMaybe<Scalars['String']['input']>;
  /** Email of the user accepting the invite */
  email: Scalars['String']['input'];
  /** User family name */
  familyName: Scalars['String']['input'];
  /** User full name */
  fullName: Scalars['String']['input'];
  /** User given name */
  givenName: Scalars['String']['input'];
  /** Auth Provider identities */
  identities: Array<AuthorizationIdentities>;
  /** User nickname */
  nickname: Scalars['String']['input'];
  /** Organization Id (aka instanceId) */
  organizationId: Scalars['String']['input'];
  /** User Id */
  userId: Scalars['String']['input'];
};

export type AcknowledgedInput = {
  assigneeData: GetAssigneeDataForNotificationInput;
  instanceId: Scalars['String']['input'];
  reviewId: Scalars['String']['input'];
  reviewerUUID: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
  teamLeaderUid: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

/** Types of filters to show or not acknowledged reviews in the app. */
export enum AcknowledgmentTypeFilters {
  ShowAllReviews = 'showAllReviews',
  ShowOnlyAcknowledgedReviews = 'showOnlyAcknowledgedReviews',
  ShowOnlyUnAcknowledgedReviews = 'showOnlyUnAcknowledgedReviews'
}

export type AddEvaluatorInput = {
  calibrationStatus: Status;
  evaluatorEmail: Scalars['String']['input'];
  evaluatorName: Scalars['String']['input'];
  evaluatorUid: Scalars['String']['input'];
  isCalibrator: Scalars['Boolean']['input'];
};

export type AddWhiteListedDomainsInput = {
  instanceId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  whiteListedDomainsList: Array<Scalars['String']['input']>;
};

export type ArchiveOrRemoveReviewsInput = {
  instanceId: Scalars['String']['input'];
  rubricId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

export type AuthorizationIdentities = {
  /** Auth Provider user Id */
  authId: Scalars['String']['input'];
  /** Auth Provider */
  provider: Scalars['String']['input'];
};

export type BannerDowntimeAnnouncement = {
  __typename?: 'BannerDowntimeAnnouncement';
  /** Status of the application */
  active: Scalars['Boolean']['output'];
  /** Message for users */
  message: Scalars['String']['output'];
};

export type Bar = {
  __typename?: 'Bar';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BarChart = {
  __typename?: 'BarChart';
  data: Array<Bar>;
};

export type CsvContent = {
  __typename?: 'CSVContent';
  additional_feedback: Scalars['String']['output'];
  assignee: Scalars['String']['output'];
  assigneeEmail: Scalars['String']['output'];
  auto_fail: Scalars['String']['output'];
  categories: Array<CategoryCsv>;
  handleTime?: Maybe<Scalars['Int']['output']>;
  reviewCompletedAt?: Maybe<Scalars['Int']['output']>;
  reviewStartedAt: Scalars['Int']['output'];
  reviewUpdatedAt?: Maybe<Scalars['Int']['output']>;
  review_acknowledged: Scalars['String']['output'];
  reviewer: Scalars['String']['output'];
  reviewerEmail: Scalars['String']['output'];
  tags: Scalars['String']['output'];
  ticketNumber: Scalars['String']['output'];
  total: Scalars['String']['output'];
};

export type CsvData = {
  __typename?: 'CSVData';
  data: Array<CsvContent>;
  filename: Scalars['String']['output'];
  headers: Array<HeaderCsv>;
};

/** Represents from where we can get the reviews. */
export enum CsvType {
  /** An internal DAO class that gets archived reviews filtered by rubric Id. */
  ArchivedReviews = 'archivedReviews',
  /** Array of tickets from the dashboard. */
  Dashboard = 'dashboard'
}

export type Calibration = {
  __typename?: 'Calibration';
  alignmentByQuestion?: Maybe<Array<QuestionAlignment>>;
  calibrationEvaluators?: Maybe<Array<CalibrationEvaluator>>;
  calibrationId: Scalars['String']['output'];
  calibrationReviewId: Scalars['String']['output'];
  calibratorUid: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['Int']['output']>;
  evaluators?: Maybe<Array<Scalars['String']['output']>>;
  instanceId: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  leastAlignedQuestion?: Maybe<Scalars['String']['output']>;
  leastAlignedQuestionScore?: Maybe<Scalars['Float']['output']>;
  mostAlignedQuestion?: Maybe<Scalars['String']['output']>;
  mostAlignedQuestionScore?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  overallAlignmentScore?: Maybe<Scalars['Float']['output']>;
  rubricId: Scalars['String']['output'];
  startedAt: Scalars['Int']['output'];
  status: Status;
  teamId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CalibrationAnalyticsInput = {
  endTime: Scalars['Int']['input'];
  instanceId: Scalars['String']['input'];
  rubricId: Scalars['String']['input'];
  startTime: Scalars['Int']['input'];
  userEmail: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
};

export type CalibrationCsvContent = {
  __typename?: 'CalibrationCSVContent';
  assigneeName: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  individualAlignmentScore: Scalars['String']['output'];
  isAlignmentToTheAnswerKeyRecord: Scalars['Boolean']['output'];
  questions: Array<CalibrationQuestionCsv>;
  rubricName: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type CalibrationCsvData = {
  __typename?: 'CalibrationCSVData';
  allOrderedQuestionsFromOriginalRubric: Array<QuestionShapeForCalibration>;
  data: Array<CalibrationCsvContent>;
  filename: Scalars['String']['output'];
  headers: Array<HeaderCsv>;
};

export type CalibrationEvaluator = {
  __typename?: 'CalibrationEvaluator';
  alignmentByQuestion?: Maybe<Array<QuestionAlignment>>;
  calibrationCompletedAt?: Maybe<Scalars['Int']['output']>;
  calibrationId: Scalars['String']['output'];
  calibrationScoreID?: Maybe<Scalars['String']['output']>;
  calibrationStatus: Status;
  evaluatorEmail: Scalars['String']['output'];
  evaluatorName: Scalars['String']['output'];
  evaluatorPhotoURL?: Maybe<Scalars['String']['output']>;
  evaluatorUid: Scalars['String']['output'];
  isCalibrator: Scalars['Boolean']['output'];
  leastAlignedQuestion?: Maybe<Scalars['String']['output']>;
  leastAlignedQuestionScore?: Maybe<Scalars['Float']['output']>;
  mostAlignedQuestion?: Maybe<Scalars['String']['output']>;
  mostAlignedQuestionScore?: Maybe<Scalars['Float']['output']>;
  overallAlignmentScore?: Maybe<Scalars['Float']['output']>;
  rubricId: Scalars['String']['output'];
};

export type CalibrationHistory = {
  __typename?: 'CalibrationHistory';
  alignmentByQuestion?: Maybe<Array<QuestionAlignment>>;
  amountOfCalibrationEvaluated: Scalars['Int']['output'];
  arePendingCalibrations: Scalars['Boolean']['output'];
  calibrations: Array<Calibration>;
  leastAlignedQuestion?: Maybe<Scalars['String']['output']>;
  leastAlignedQuestionScore?: Maybe<Scalars['Float']['output']>;
  mostAlignedQuestion?: Maybe<Scalars['String']['output']>;
  mostAlignedQuestionScore?: Maybe<Scalars['Float']['output']>;
  overallAlignmentScore?: Maybe<Scalars['Float']['output']>;
};

export type CalibrationHistoryInput = {
  endTime: Scalars['Int']['input'];
  instanceId: Scalars['String']['input'];
  rubricsId: Array<Scalars['String']['input']>;
  startTime: Scalars['Int']['input'];
  userEmail: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
};

export type CalibrationInput = {
  calibratorUid: Scalars['String']['input'];
  evaluators: Array<EvaluatorDataForCreatingCalibration>;
  instanceId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  rubricId: Scalars['String']['input'];
  startedAt: Scalars['Int']['input'];
  status: Status;
  teamId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CalibrationInputForRemovedEvaluatorsEmail = {
  /** unique calibration id */
  calibrationId: Scalars['String']['input'];
  /** calibration's name */
  calibrationsName: Scalars['String']['input'];
  /** calibrator name */
  calibratorName: Scalars['String']['input'];
  calibratorsPhotoURL: Scalars['String']['input'];
  dateOfCalibrationCreated: Scalars['Int']['input'];
};

export type CalibrationQuestionCsv = {
  __typename?: 'CalibrationQuestionCSV';
  categoryId: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
  scoreGiven: Scalars['String']['output'];
};

export type CalibrationScore = {
  __typename?: 'CalibrationScore';
  /** Determines if the ticket is acknowledged by the assignee */
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the ticket is acknowledged by the assignee */
  acknowledgedAt?: Maybe<Scalars['Int']['output']>;
  /** Unique ID for the user receiving the ticket review */
  asigneeUid?: Maybe<Scalars['String']['output']>;
  /** User details */
  assigneeData?: Maybe<TicketUserData>;
  /** Determines if any sub-category has an autofail */
  autofailPresent?: Maybe<Scalars['Boolean']['output']>;
  calibrationId?: Maybe<Scalars['String']['output']>;
  /** It could be either Zendesk or Helpscout */
  engine?: Maybe<Scalars['String']['output']>;
  /** Represents the folder ID for the Helpscout engine for a ticket location */
  folderId?: Maybe<Scalars['String']['output']>;
  /** Partner unique ID that the ticket is reviewed for */
  instanceId?: Maybe<Scalars['String']['output']>;
  /** It tells if it's the evaluation created by the calibrator */
  isCalibrationKey?: Maybe<Scalars['Boolean']['output']>;
  /** Represents if the ticket was assigneed using the Aprikot Extension as a manual assignment */
  manualAssignment?: Maybe<Scalars['Boolean']['output']>;
  /** It should always be ticketScore */
  objectType: Scalars['String']['output'];
  /** A 13 digit timestamp representing the review time for the ticket */
  reviewDate: Scalars['Int']['output'];
  /** User details */
  reviewerData?: Maybe<TicketUserData>;
  /** The unique ID of the rubric used to review the ticket */
  rubricId: Scalars['String']['output'];
  /** Calculated fields for the Categories in the ticket */
  scoreByCategory?: Maybe<Array<TicketScoreByCategory>>;
  /** Calculated fields for the SubCategories in the ticket */
  scoreBySubCategory?: Maybe<Array<TicketScoreBySubCategory>>;
  /** Represents the status of the ticket, if it's being reviewed or if all the categories were reviewed already */
  status: ReviewStatus;
  /** Unique ID of the team that the review belongs to */
  teamId: Scalars['ID']['output'];
  /** This is shared by the CRM. NOTE: For helpscout this is a string */
  ticketId: Scalars['String']['output'];
  /** This is shared by the CRM. NOTE: For helpscout this is a string */
  totalScore: Scalars['Int']['output'];
  /** Unique ID for the user that reviewed the ticket */
  type: Scalars['String']['output'];
  /** user id */
  uid: Scalars['String']['output'];
  /** The URL where the ticket was reviewed from, regularly the CMR url with the ticket path */
  url: Scalars['String']['output'];
};

export type CalibrationScoreInput = {
  instanceId: Scalars['String']['input'];
  ticketId: Scalars['String']['input'];
  ticketScoreId: Scalars['String']['input'];
};

export type CalibrationWithCalibratorData = {
  __typename?: 'CalibrationWithCalibratorData';
  alignmentByQuestion?: Maybe<Array<QuestionAlignment>>;
  calibrationEvaluators?: Maybe<Array<CalibrationEvaluator>>;
  calibrationId: Scalars['String']['output'];
  calibrationReviewId: Scalars['String']['output'];
  calibratorName: Scalars['String']['output'];
  calibratorUid: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['Int']['output']>;
  evaluators?: Maybe<Array<Scalars['String']['output']>>;
  instanceId: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  leastAlignedQuestion?: Maybe<Scalars['String']['output']>;
  leastAlignedQuestionScore?: Maybe<Scalars['Float']['output']>;
  mostAlignedQuestion?: Maybe<Scalars['String']['output']>;
  mostAlignedQuestionScore?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  overallAlignmentScore?: Maybe<Scalars['Float']['output']>;
  rubricId: Scalars['String']['output'];
  startedAt: Scalars['Int']['output'];
  status: Status;
  teamId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CalibratorData = {
  calibratorName: Scalars['String']['input'];
  calibratorPhotoProfile: Scalars['String']['input'];
  calibratorUid: Scalars['String']['input'];
};

export type Categories = {
  __typename?: 'Categories';
  label: Scalars['String']['output'];
};

export type Category = {
  __typename?: 'Category';
  /** Verifies if the category was autofailed */
  autoFailEnabled: Scalars['Boolean']['output'];
  /** Category ID */
  id: Scalars['String']['output'];
  /** The options available for the question */
  measurementOptions?: Maybe<Array<MeasurementOption>>;
  /** Measurement type of the category */
  measurementType: MeasurementType;
  /** Name of this category */
  name: Scalars['String']['output'];
  /** Are these questions optional */
  notApplicable: Scalars['Boolean']['output'];
  /** Step order of the category */
  orderIndex: Scalars['Int']['output'];
  /** Name of this category */
  questions: Array<Question>;
  /** Checks if comments are required for this category */
  requiresComments: Scalars['Boolean']['output'];
  /** Weight of this category */
  weight: Scalars['Int']['output'];
};

export type CategoryCsv = {
  __typename?: 'CategoryCSV';
  maxScore: Scalars['String']['output'];
  name: Scalars['String']['output'];
  score: Scalars['String']['output'];
  scoreWeight: Scalars['String']['output'];
  subCategories: Array<SubCategoryCsv>;
};

export type CheckDuplicateRubricInput = {
  /** ID of the organization the rubric belongs to */
  instanceId: Scalars['String']['input'];
  /** Name of the rubric */
  nameLowerCase: Scalars['String']['input'];
  /** Status of the rubric */
  status: RubricsStatus;
};

export type ConnectionConfigInput = {
  auditData?: InputMaybe<Scalars['Boolean']['input']>;
  eventData?: InputMaybe<Scalars['Boolean']['input']>;
  ticketData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectionConfigType = {
  __typename?: 'ConnectionConfigType';
  auditData?: Maybe<Scalars['Boolean']['output']>;
  eventData?: Maybe<Scalars['Boolean']['output']>;
  ticketData?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields of connection that can be used for ordering */
export enum ConnectionField {
  Active = 'active',
  ConnectorInstanceId = 'connectorInstanceId',
  CredentialId = 'credentialId',
  InitTimestamp = 'initTimestamp',
  OrganizationId = 'organizationId',
  Subdomain = 'subdomain',
  System = 'system'
}

export type ConnectionInput = {
  active: Scalars['Boolean']['input'];
  configuration: ConnectionConfigInput;
  connectorInstanceId: Scalars['String']['input'];
  credentialId: Scalars['String']['input'];
  initTimestamp: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
  organizationId: Scalars['String']['input'];
  streams?: InputMaybe<Scalars['JSON']['input']>;
  subdomain: Scalars['String']['input'];
  system: ConnectionSystem;
};

export type ConnectionOrder = {
  /** Field the results should be ordered by */
  by?: InputMaybe<ConnectionField>;
  /** Direction in which the results should be ordered */
  direction?: InputMaybe<Scalars['String']['input']>;
};

export enum ConnectionSystem {
  /** Gorgias */
  Gorgias = 'Gorgias',
  /** Zendesk */
  Zendesk = 'Zendesk'
}

export type ConnectionType = {
  __typename?: 'ConnectionType';
  active: Scalars['Boolean']['output'];
  configuration: ConnectionConfigType;
  connectorInstanceId: Scalars['String']['output'];
  credentialId: Scalars['String']['output'];
  initTimestamp: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  organizationId: Scalars['String']['output'];
  streams?: Maybe<Scalars['JSON']['output']>;
  subdomain: Scalars['String']['output'];
  system: ConnectionSystem;
};

export type ConnectionWhere = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  connectorInstanceId?: InputMaybe<Scalars['String']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  initTimestamp?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  system?: InputMaybe<ConnectionSystem>;
};

export type CreateCategoryInput = {
  /** Verifies if the category was autofailed */
  autoFailEnabled: Scalars['Boolean']['input'];
  /** The options available for the question */
  measurementOptions?: InputMaybe<Array<MeasurementOptionInput>>;
  /** Measurement type of the category */
  measurementType: MeasurementType;
  /** Name of this category */
  name: Scalars['String']['input'];
  /** Are these questions optional */
  notApplicable: Scalars['Boolean']['input'];
  /** Step order of the category */
  orderIndex: Scalars['Int']['input'];
  /** Array of the questions */
  questions: Array<CreateQuestionsInput>;
  /** Checks if comments are required for this category */
  requiresComments: Scalars['Boolean']['input'];
  /** Weight of this category */
  weight: Scalars['Int']['input'];
};

export type CreateConnectionInput = {
  configuration: ConnectionConfigInput;
  /** Email of the admin user in the CRM */
  email: Scalars['String']['input'];
  /** Data fetching start date in epoch */
  initAt: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  /** Subdomain of the CRM */
  subdomain: Scalars['String']['input'];
  system: ConnectionSystem;
  /** Auth token of the CRM */
  token: Scalars['String']['input'];
  totalTimeLastUpdatedField?: InputMaybe<Scalars['String']['input']>;
  totalTimeSpentCustomField?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGoalsInput = {
  criticalErrorRate?: InputMaybe<Scalars['Float']['input']>;
  errorFreeRate?: InputMaybe<Scalars['Float']['input']>;
  instanceId: Scalars['String']['input'];
  qaScore?: InputMaybe<Scalars['Float']['input']>;
  sample?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOrganizationTeamInput = {
  instanceId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  teamLeaderUid: Scalars['String']['input'];
};

export type CreateQuestionsInput = {
  /** It represents the category's id */
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** Description of this question */
  description: Scalars['String']['input'];
  /** Name of the question */
  name: Scalars['String']['input'];
  /** Step order of the question */
  orderIndex: Scalars['Int']['input'];
  /** Verifies if this question require a comment */
  requiresComments: Scalars['Boolean']['input'];
  /** Weight of this question */
  weight: Scalars['Int']['input'];
};

export type CreateQueueConfigurationInput = {
  /** To determine the ticket selection criteria */
  countTicketsBy: QueueCountTicketsType;
  /** Exclude specific email addresses from the ticket selection */
  exclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ticket selection frequency */
  frequency: QueueFrequency;
  /** Organization ID the queue configuration is for */
  instanceId: Scalars['ID']['input'];
  /** Number of tickets to select based on the `frequency` */
  ticketAmount: Scalars['Float']['input'];
};

export type CreateRubricV2Input = {
  /** Array of the categories */
  categories: Array<CreateCategoryInput>;
  /** Id of the rubric's author */
  createdBy: Scalars['String']['input'];
  /** Timestamp of when the rubric was created */
  createdDate: Scalars['Int']['input'];
  /** Field that checks if this rubric was favorited */
  favorite: Scalars['Boolean']['input'];
  /** ID of the organization the rubric belongs to */
  instanceId: Scalars['String']['input'];
  /** Name of the rubric */
  name: Scalars['String']['input'];
  /** Status of the rubric */
  status: RubricsStatus;
  /** ID of the team the rubric belongs to */
  teamId: Scalars['String']['input'];
};

export type CreatorData = {
  __typename?: 'CreatorData';
  /** Preferred name */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Profile picture. */
  photoURL?: Maybe<Scalars['String']['output']>;
};

export type DashboardAnalyticsMetadata = {
  __typename?: 'DashboardAnalyticsMetadata';
  acknowledgedReviewsCounter: Scalars['Int']['output'];
  averageTicketsScore: Scalars['Float']['output'];
  completedReviewsCounter: Scalars['Int']['output'];
  currentStrength?: Maybe<Scalars['String']['output']>;
  needFocus?: Maybe<Scalars['String']['output']>;
};

export type DashboardReviews = {
  __typename?: 'DashboardReviews';
  metadata?: Maybe<DashboardAnalyticsMetadata>;
  reviews: Array<ReviewWithReviewerAndAssigneeData>;
};

export type Data = {
  __typename?: 'Data';
  value?: Maybe<Scalars['String']['output']>;
};

export type DataSet = {
  __typename?: 'DataSet';
  data: Array<Data>;
  seriesname: Scalars['String']['output'];
};

export type EvaluatorDataForCreatingCalibration = {
  calibrationStatus: Status;
  evaluatorUid: Scalars['String']['input'];
  isCalibrator: Scalars['Boolean']['input'];
};

export type EvaluatorToBeRemovedInput = {
  /** evaluator photo url */
  email: Scalars['String']['input'];
  /** evaluator name */
  name: Scalars['String']['input'];
};

/** Firestore OrderByDirection */
export enum FirestoreOrderByDirection {
  /** Ascending */
  Asc = 'asc',
  /** Descending */
  Desc = 'desc'
}

export type FirestoreUser = {
  __typename?: 'FirestoreUser';
  authIdentities: Array<FirestoreUserAuthIdentity>;
  createdAt?: Maybe<Scalars['Float']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Preferred name */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Email address */
  email: Scalars['String']['output'];
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  hasTakenTour: Scalars['Boolean']['output'];
  /** Document ID */
  id: Scalars['String']['output'];
  /**
   * Organization ID
   * @deprecated in favor of organizationId
   */
  instanceId: Scalars['String']['output'];
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Notification settings */
  notificationSettings: UserEmailNotificationSettings;
  /** Auth ID */
  organizationAuthId: Scalars['String']['output'];
  /** Organization ID */
  organizationId: Scalars['String']['output'];
  /** Profile picture. */
  photoURL?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  /** Roles of the user */
  roles: Array<FirestoreUserRole>;
  status: FirestoreUserStatus;
  /** Team ID the user belongs to */
  teamId: Scalars['String']['output'];
  /** User ID */
  uid: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** User completed all the onboarding steps for Waizen */
  waizenOnboarding?: Maybe<UserWaizenOnboarding>;
};

export type FirestoreUserAuthIdentity = {
  __typename?: 'FirestoreUserAuthIdentity';
  authId?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
};

export type FirestoreUserAuthIdentityInput = {
  authId?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
};

export type FirestoreUserCreateInput = {
  authIdentities: Array<FirestoreUserAuthIdentityInput>;
  createdAt?: InputMaybe<Scalars['Float']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Preferred name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Email address */
  email: Scalars['String']['input'];
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasTakenTour: Scalars['Boolean']['input'];
  /** Organization ID */
  instanceId: Scalars['String']['input'];
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Notification settings */
  notificationSettings: NotificationSettingsInput;
  /** Auth ID */
  organizationAuthId: Scalars['String']['input'];
  /** Organization ID */
  organizationId: Scalars['String']['input'];
  /** Profile picture. */
  photoURL?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  /** Roles of the user */
  roles: Array<FirestoreUserRole>;
  status: FirestoreUserStatus;
  /** Team ID the user belongs to */
  teamId: Scalars['String']['input'];
  /** User ID */
  uid: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Float']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** User completed all the onboarding steps for Waizen */
  waizenOnboarding?: InputMaybe<OnboardingSettingsInput>;
};

export type FirestoreUserInput = {
  authIdentities: Array<FirestoreUserAuthIdentityInput>;
  createdAt?: InputMaybe<Scalars['Float']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Preferred name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Email address */
  email: Scalars['String']['input'];
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasTakenTour: Scalars['Boolean']['input'];
  /** Document ID */
  id: Scalars['String']['input'];
  /** Organization ID */
  instanceId: Scalars['String']['input'];
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Notification settings */
  notificationSettings: NotificationSettingsInput;
  /** Auth ID */
  organizationAuthId: Scalars['String']['input'];
  /** Organization ID */
  organizationId: Scalars['String']['input'];
  /** Profile picture. */
  photoURL?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  /** Roles of the user */
  roles: Array<FirestoreUserRole>;
  status: FirestoreUserStatus;
  /** Team ID the user belongs to */
  teamId: Scalars['String']['input'];
  /** User ID */
  uid: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Float']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** User completed all the onboarding steps for Waizen */
  waizenOnboarding?: InputMaybe<OnboardingSettingsInput>;
};

export type FirestoreUserOrder = {
  by?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<FirestoreOrderByDirection>;
};

/** Types of users in the app */
export enum FirestoreUserRole {
  /** Org admin */
  OrganizationAdmin = 'ORGANIZATION_ADMIN',
  /** Team Leader user */
  TeamLeader = 'TEAM_LEADER',
  /** Regular user. */
  User = 'USER'
}

/** User status */
export enum FirestoreUserStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Archived / Deleted */
  Archived = 'ARCHIVED',
  /** Inactive */
  Inactive = 'INACTIVE',
  /** Pending */
  Pending = 'PENDING'
}

export type FirestoreUserUpdateInput = {
  authIdentities?: InputMaybe<Array<FirestoreUserAuthIdentityInput>>;
  createdAt?: InputMaybe<Scalars['Float']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Preferred name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasTakenTour?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization ID */
  instanceId?: InputMaybe<Scalars['String']['input']>;
  isTeamLeader?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Notification settings */
  notificationSettings?: InputMaybe<NotificationSettingsInput>;
  /** Auth ID */
  organizationAuthId?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Profile picture. */
  photoURL?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  /** Roles of the user */
  roles?: InputMaybe<Array<FirestoreUserRole>>;
  status?: InputMaybe<FirestoreUserStatus>;
  /** Team ID the user belongs to */
  teamId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Float']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** User completed all the onboarding steps for Waizen */
  waizenOnboarding?: InputMaybe<OnboardingSettingsInput>;
};

export type FirestoreUserWhere = {
  authIdentities?: InputMaybe<Array<FirestoreUserAuthIdentityInput>>;
  createdAt?: InputMaybe<Scalars['Float']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Preferred name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasTakenTour?: InputMaybe<Scalars['Boolean']['input']>;
  /** Document ID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID */
  instanceId?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Notification settings */
  notificationSettings?: InputMaybe<NotificationSettingsInput>;
  /** Auth ID */
  organizationAuthId?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Profile picture. */
  photoURL?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  /** Roles of the user */
  roles?: InputMaybe<Array<FirestoreUserRole>>;
  status?: InputMaybe<FirestoreUserStatus>;
  /** Team ID the user belongs to */
  teamId?: InputMaybe<Scalars['String']['input']>;
  /** User ID */
  uid?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Float']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** User completed all the onboarding steps for Waizen */
  waizenOnboarding?: InputMaybe<OnboardingSettingsInput>;
};

export type FirestoreUserWhereUnique = {
  /** Document ID */
  id: Scalars['String']['input'];
};

export type GetAssigneeDataForNotificationInput = {
  /** user name */
  name: Scalars['String']['input'];
  /** assignee photo url */
  photoURL: Scalars['String']['input'];
};

export type GetConnectionInput = {
  /** Conditions to find the connection */
  order?: InputMaybe<ConnectionOrder>;
  /** Conditions to find the connection */
  where: ConnectionWhere;
};

export type GetReviewsArgs = {
  /** Unique ID for the user receiving the ticket review */
  assigneeUUID?: InputMaybe<Scalars['ID']['input']>;
  /** End date of the reviews you wish to fetch */
  endDate: Scalars['Int']['input'];
  /** Id of the organization you wish to fetch the reviews from */
  instanceId: Scalars['String']['input'];
  /** It's true when the assignee has acknowledged the review. */
  isAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  /** It's true when the review has been archived. */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates reviewer UUID. */
  reviewerUUID?: InputMaybe<Scalars['ID']['input']>;
  /** The unique ID of the rubric used to create the review. */
  rubricId?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the reviews you wish to fetch */
  startDate: Scalars['Int']['input'];
  /** Unique ID of the team that the review belongs to. */
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetTicketQueuesInput = {
  /** The CRM ticket comes from */
  CRM?: InputMaybe<Scalars['String']['input']>;
  /** The assignee email from CRM */
  assigneeEmail?: InputMaybe<Scalars['String']['input']>;
  /** The assignee name from CRM */
  assigneeName?: InputMaybe<Scalars['String']['input']>;
  /** Flag to identify whether the ticket has been discarded in Waizen */
  discarded?: InputMaybe<Scalars['Boolean']['input']>;
  instanceId: Scalars['String']['input'];
  /** The Waizen user ID the ticket is assigned to */
  queueBatchInfoId?: InputMaybe<Scalars['String']['input']>;
  /** Flag to identify whether the ticket has been reviewed in Waizen */
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ticket channel */
  ticketChannel?: InputMaybe<Scalars['String']['input']>;
  /** Unix timestamp (seconds) value when ticket closed */
  ticketClosed?: InputMaybe<Scalars['Float']['input']>;
  /** The ticket ID from CRM */
  ticketId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the ticket queue, in the format `{instanceId}_{ticketId}` */
  ticketQueueId?: InputMaybe<Scalars['ID']['input']>;
  /** Unix timestamp (seconds) value when ticket started */
  ticketStarted?: InputMaybe<Scalars['Float']['input']>;
  /** The ticket URL from CRM */
  ticketURL?: InputMaybe<Scalars['String']['input']>;
  /** Total handle time (seconds) */
  totalHandleTime?: InputMaybe<Scalars['Float']['input']>;
  /** The Waizen user ID the ticket is assigned to */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalAdminSettings = {
  __typename?: 'GlobalAdminSettings';
  /** Global admin email */
  email: Scalars['String']['output'];
  /** Determines if user has access to support */
  supportAccess: Scalars['Boolean']['output'];
};

export type Goals = {
  __typename?: 'Goals';
  criticalErrorRate?: Maybe<Scalars['Float']['output']>;
  errorFreeRate?: Maybe<Scalars['Float']['output']>;
  instanceId: Scalars['String']['output'];
  qaScore?: Maybe<Scalars['Float']['output']>;
  sample?: Maybe<Scalars['Int']['output']>;
};

export type HeaderCsv = {
  __typename?: 'HeaderCSV';
  access: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type Headers = {
  __typename?: 'Headers';
  Header: Scalars['String']['output'];
  accessor: Scalars['String']['output'];
};

export type Insight = {
  __typename?: 'Insight';
  /** This chart tracks the performance of associates over time, / Week-over-Week (WoW) / Month-over-Month (MoM) / Quarter-over-Quarter (QoQ) data */
  associatesScores: TableChart;
  /** Represents the percentage of reviews that have a score of 0 */
  criticalErrorRate: Scalars['Float']['output'];
  /** This chart combines EFR (Error Free Rate) and CER (Critical Error Rate) scores over time. Returns data in the following order: EFR / CER */
  erfAndCre: MultiChart;
  /** Represents the percentage of reviews that have a perfect score (e.g., 100). */
  errorFreeRate: Scalars['Float']['output'];
  /** This chart depicts the count of unique associates who received scores less than 100% on individual tickets within specific tags */
  markedDownByTag?: Maybe<TableChart>;
  /** This chart displays scores for individual questions within a selected rubric */
  performanceByCategory?: Maybe<BarChart>;
  /** This chart displays scores for a selected rubric's categories */
  performanceByQuestion?: Maybe<BarChart>;
  /** This chart displays the average QA score for specific tags */
  performanceByTag?: Maybe<BarChart>;
  /** QA Score represents the quality assessment score */
  qaScore: Scalars['Float']['output'];
  /** This chart plots the QA score against the number of tickets (sample size) over a period of time. Returns data in the following order: Sample / QA Score */
  qaScoreVSample: MultiChart;
  /** This chart plots the scores for different rubrics over time */
  rubricsScores?: Maybe<MultiChart>;
  /** The total number of reviews considered for analysis */
  sample: Scalars['Int']['output'];
};

export type Invitation = {
  __typename?: 'Invitation';
  /** Unix of when the invitation was sent */
  createdAt: Scalars['Int']['output'];
  /** Invited email */
  email: Scalars['String']['output'];
  /** Unix of when the invitation will expire */
  expiresAt: Scalars['Int']['output'];
  /** ID of the invitation generated in Auth0 */
  id: Scalars['String']['output'];
  /** Id of the user who sent the invite */
  inviterId: Scalars['String']['output'];
  /** Auth0 organization Id */
  organizationAuthId: Scalars['String']['output'];
  /** ID of the organization this invitation belongs to */
  organizationId: Scalars['String']['output'];
  /** Role the invited user will fullfil */
  role: FirestoreUserRole;
  /** Status of the invitation */
  status: InvitationStatus;
  /** Team ID */
  teamId?: Maybe<Scalars['String']['output']>;
};

export type InvitationInput = {
  /** Unix of when the invitation was sent */
  createdAt: Scalars['Int']['input'];
  /** Invited email */
  email: Scalars['String']['input'];
  /** Unix of when the invitation will expire */
  expiresAt: Scalars['Int']['input'];
  /** ID of the invitation generated in Auth0 */
  id: Scalars['String']['input'];
  /** Id of the user who sent the invite */
  inviterId: Scalars['String']['input'];
  /** Auth0 organization Id */
  organizationAuthId: Scalars['String']['input'];
  /** ID of the organization this invitation belongs to */
  organizationId: Scalars['String']['input'];
  /** Role the invited user will fullfil */
  role: FirestoreUserRole;
  /** Status of the invitation */
  status: InvitationStatus;
  /** Team ID */
  teamId?: InputMaybe<Scalars['String']['input']>;
};

/** Fields of invitation that can be used for ordering */
export enum InvitationStatus {
  /** ACCEPTED */
  Accepted = 'ACCEPTED',
  /** CANCELED */
  Canceled = 'CANCELED',
  /** PENDING */
  Pending = 'PENDING'
}

export type InvitedUser = {
  /** Invited email */
  email: Scalars['String']['input'];
  /** Role the invited user will fullfil */
  role: FirestoreUserRole;
};

export type Maintenance = {
  __typename?: 'Maintenance';
  /** Status of the application */
  active: Scalars['Boolean']['output'];
  /** Time services will return */
  endTime: Scalars['Int']['output'];
  /** Message for users */
  message: Scalars['String']['output'];
  /** Time services will go down */
  startTime: Scalars['Int']['output'];
};

export type MeasurementOption = {
  __typename?: 'MeasurementOption';
  /** The label shown for the option */
  label: Scalars['String']['output'];
  /** The value assigned to the option */
  value: Scalars['Int']['output'];
};

export type MeasurementOptionInput = {
  /** The label shown for the option */
  label: Scalars['String']['input'];
  /** The value assigned to the option */
  value: Scalars['Int']['input'];
};

export enum MeasurementType {
  Binary = 'Binary',
  Range = 'Range'
}

export type Message = {
  __typename?: 'Message';
  /** Http code */
  code: Scalars['Float']['output'];
  key?: Maybe<Scalars['String']['output']>;
  /** Result of the process */
  message: Scalars['String']['output'];
};

export type ModifyOrganizationTeamInput = {
  instanceId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
  teamLeaderUid?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
};

export type ModifyOrganizationTeamResponse = {
  __typename?: 'ModifyOrganizationTeamResponse';
  /** Http code */
  code: Scalars['Float']['output'];
  key?: Maybe<Scalars['String']['output']>;
  /** Result of the process */
  message: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
  teamLeaderUid?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
};

export type MoveOrgUsersToAnotherTeamInput = {
  instanceId: Scalars['String']['input'];
  /** Team to move users to. */
  newTeamId: Scalars['String']['input'];
  /** Team to move users from. */
  oldTeamId: Scalars['String']['input'];
  usersIdList: Array<Scalars['String']['input']>;
};

export type MultiChart = {
  __typename?: 'MultiChart';
  category: Array<Categories>;
  dataset: Array<DataSet>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptEmailInvite: Invitation;
  acknowledgeAReviewAndSendNotifications: Message;
  addEvaluators: Message;
  addOrganizationTag: Scalars['String']['output'];
  addWhiteListedDomains: Message;
  archiveCalibrationsByRubricId: Message;
  archiveReviews: Message;
  archiveUser: Message;
  calibrateScores: Message;
  checkDuplicateRubric: Scalars['Boolean']['output'];
  clearTicketQueue: Scalars['Boolean']['output'];
  createCalibration: Message;
  createConnection: ConnectionType;
  createGoals: Goals;
  createOrganizationTeam: TeamData;
  createQueueConfiguration: QueueConfiguration;
  createRubricV2: RubricV2;
  deactivateConnection: ConnectionType;
  deleteEmailInvite: Invitation;
  deleteOrgTeamAndMoveReviewsAndUsersToTheNewTeam: Message;
  deleteOrganizationTeam: Message;
  duplicateRubric: RubricV2;
  firestoreCreateUser: Message;
  getGlobalAdminSettings: GlobalAdminSettings;
  modifyOrganizationTeam: ModifyOrganizationTeamResponse;
  moveOrganizationUsersToAnotherTeam: Message;
  pullTicketQueue: Scalars['Boolean']['output'];
  removeAllOrganizationTags: Message;
  removeCalibration: Message;
  removeEvaluators: Message;
  removeOrganizationTag: Message;
  removeReview: Message;
  removeWhiteListedDomains: Message;
  restoreCalibrationsByRubricId: Message;
  sendEmailInvite: Array<Invitation>;
  sendEmailNotificationsForRemovedEvaluators: Message;
  setCompleteEvaluatorStatusAndCalibrationScoreID: Message;
  signup?: Maybe<Organization>;
  toggleOrganizationPrivacyOption: Message;
  toggleUserAsTeamLeader: Message;
  updateCalibrationCompletedAt: Message;
  updateCalibrationsName: Message;
  updateConnection: ConnectionType;
  updateEvaluatorStatus: Message;
  updateFirestoreUser: FirestoreUser;
  updateGoals: Goals;
  updateKeyCalibrationId: Message;
  /** @deprecated in favor of "updateUser" */
  updateNotificationSettingsReviewAcknowledged: Message;
  updateNotificationSettingsReviewDeleted: Message;
  updateNotificationSettingsReviewReceived: Message;
  updateNotificationSettingsReviewWithAutofail: Message;
  updateOrganizationFields: Message;
  updateOrganizationZendeskCRMURL: Message;
  updateQueueConfiguration: QueueConfiguration;
  updateRubric: RubricV2;
  updateRubricCategories: Message;
  updateTicketQueue: TicketQueue;
  updateUser: FirestoreUser;
  updateUserRoles: FirestoreUser;
  /** @deprecated in favor of "updateUser" */
  updateUserTeamAndMoveTheirReviewsInFirestore: Message;
};


export type MutationAcceptEmailInviteArgs = {
  input: AcceptInviteInput;
};


export type MutationAcknowledgeAReviewAndSendNotificationsArgs = {
  input: AcknowledgedInput;
};


export type MutationAddEvaluatorsArgs = {
  calibrationId: Scalars['String']['input'];
  calibrationName: Scalars['String']['input'];
  calibrationStartedAt: Scalars['Int']['input'];
  calibratorData: CalibratorData;
  evaluators: Array<AddEvaluatorInput>;
  instanceId: Scalars['String']['input'];
  rubricId: Scalars['String']['input'];
};


export type MutationAddOrganizationTagArgs = {
  tagInput: OrganizationTagInput;
};


export type MutationAddWhiteListedDomainsArgs = {
  input: AddWhiteListedDomainsInput;
};


export type MutationArchiveCalibrationsByRubricIdArgs = {
  rubricId: Scalars['String']['input'];
};


export type MutationArchiveReviewsArgs = {
  input: ArchiveOrRemoveReviewsInput;
};


export type MutationArchiveUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationCalibrateScoresArgs = {
  calibrationId: Scalars['String']['input'];
};


export type MutationCheckDuplicateRubricArgs = {
  checkDuplicateRubricInput: CheckDuplicateRubricInput;
};


export type MutationClearTicketQueueArgs = {
  organization: Scalars['String']['input'];
};


export type MutationCreateCalibrationArgs = {
  input: CalibrationInput;
};


export type MutationCreateConnectionArgs = {
  input: CreateConnectionInput;
};


export type MutationCreateGoalsArgs = {
  createGoalsInput: CreateGoalsInput;
};


export type MutationCreateOrganizationTeamArgs = {
  team: CreateOrganizationTeamInput;
};


export type MutationCreateQueueConfigurationArgs = {
  createQueueConfigurationInput: CreateQueueConfigurationInput;
};


export type MutationCreateRubricV2Args = {
  createRubricInput: CreateRubricV2Input;
};


export type MutationDeactivateConnectionArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationDeleteEmailInviteArgs = {
  input: SelectEmailInviteInput;
};


export type MutationDeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamArgs = {
  input: MoveOrgUsersToAnotherTeamInput;
};


export type MutationDeleteOrganizationTeamArgs = {
  instanceId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationDuplicateRubricArgs = {
  rubricId: Scalars['String']['input'];
};


export type MutationFirestoreCreateUserArgs = {
  input: FirestoreUserInput;
};


export type MutationGetGlobalAdminSettingsArgs = {
  email: Scalars['String']['input'];
};


export type MutationModifyOrganizationTeamArgs = {
  input: ModifyOrganizationTeamInput;
};


export type MutationMoveOrganizationUsersToAnotherTeamArgs = {
  input: MoveOrgUsersToAnotherTeamInput;
};


export type MutationPullTicketQueueArgs = {
  organizations: Array<Scalars['String']['input']>;
};


export type MutationRemoveAllOrganizationTagsArgs = {
  orgName: Scalars['String']['input'];
};


export type MutationRemoveCalibrationArgs = {
  calibrationId: Scalars['String']['input'];
  notifyEvaluators: Scalars['Boolean']['input'];
};


export type MutationRemoveEvaluatorsArgs = {
  calibrationId: Scalars['String']['input'];
  evaluators: Array<Scalars['String']['input']>;
};


export type MutationRemoveOrganizationTagArgs = {
  instanceId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};


export type MutationRemoveReviewArgs = {
  input: RemoveReviewInput;
};


export type MutationRemoveWhiteListedDomainsArgs = {
  input: RemoveWhiteListedDomainsInput;
};


export type MutationRestoreCalibrationsByRubricIdArgs = {
  rubricId: Scalars['String']['input'];
};


export type MutationSendEmailInviteArgs = {
  input: SendEmailInviteInput;
};


export type MutationSendEmailNotificationsForRemovedEvaluatorsArgs = {
  calibrationData: CalibrationInputForRemovedEvaluatorsEmail;
  evaluatorsToBeRemoved: Array<EvaluatorToBeRemovedInput>;
  instanceId: Scalars['String']['input'];
};


export type MutationSetCompleteEvaluatorStatusAndCalibrationScoreIdArgs = {
  calibrationId: Scalars['String']['input'];
  calibrationReviewId: Scalars['String']['input'];
  calibrationStatus: Scalars['String']['input'];
  evaluatorId: Scalars['String']['input'];
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationToggleOrganizationPrivacyOptionArgs = {
  input: OrganizationPrivacyOptionInput;
};


export type MutationToggleUserAsTeamLeaderArgs = {
  input: FirestoreUserUpdateInput;
  where: FirestoreUserWhereUnique;
};


export type MutationUpdateCalibrationCompletedAtArgs = {
  calibrationId: Scalars['String']['input'];
  evaluatorId: Scalars['String']['input'];
};


export type MutationUpdateCalibrationsNameArgs = {
  calibrationId: Scalars['String']['input'];
  calibrationName: Scalars['String']['input'];
};


export type MutationUpdateConnectionArgs = {
  input: UpdateConnectionInput;
};


export type MutationUpdateEvaluatorStatusArgs = {
  calibrationId: Scalars['String']['input'];
  calibrationStatus: Scalars['String']['input'];
  evaluatorId: Scalars['String']['input'];
};


export type MutationUpdateFirestoreUserArgs = {
  input: FirestoreUserUpdateInput;
  where: FirestoreUserWhereUnique;
};


export type MutationUpdateGoalsArgs = {
  updateGoalsInput: UpdateGoalsInput;
};


export type MutationUpdateKeyCalibrationIdArgs = {
  calibrationId: Scalars['String']['input'];
  calibrationReviewId: Scalars['String']['input'];
  calibratorUid: Scalars['String']['input'];
};


export type MutationUpdateNotificationSettingsReviewAcknowledgedArgs = {
  instanceId: Scalars['String']['input'];
  reviewAcknowledged: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateNotificationSettingsReviewDeletedArgs = {
  instanceId: Scalars['String']['input'];
  reviewDeleted: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateNotificationSettingsReviewReceivedArgs = {
  instanceId: Scalars['String']['input'];
  reviewReceived: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateNotificationSettingsReviewWithAutofailArgs = {
  instanceId: Scalars['String']['input'];
  reviewWithAutofail: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateOrganizationFieldsArgs = {
  orgName: Scalars['String']['input'];
  updateOrganizationFields: UpdateOrganizationFieldsInput;
};


export type MutationUpdateOrganizationZendeskCrmurlArgs = {
  newCRMURL: Scalars['String']['input'];
  orgName: Scalars['String']['input'];
};


export type MutationUpdateQueueConfigurationArgs = {
  instanceId: Scalars['String']['input'];
  updateQueueConfigurationInput: UpdateQueueConfigurationInput;
};


export type MutationUpdateRubricArgs = {
  rubricId: Scalars['String']['input'];
  updateRubricInput: UpdateRubricInput;
};


export type MutationUpdateRubricCategoriesArgs = {
  categories: Array<CreateCategoryInput>;
  categoriesIdsToRemove: Array<Scalars['String']['input']>;
  currentRubricStatus: Scalars['String']['input'];
  questions: Array<CreateQuestionsInput>;
  removeQuestions: Array<RemoveQuestionInput>;
  rubricId: Scalars['String']['input'];
  updateCategories: Array<UpdateCategoryInput>;
  updateQuestions: Array<UpdateQuestionInput>;
};


export type MutationUpdateTicketQueueArgs = {
  updateTicketQueueInput: UpdateTicketQueueInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateFirestoreUserInput;
  instanceId: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type MutationUpdateUserRolesArgs = {
  input: FirestoreUserUpdateInput;
  where: FirestoreUserWhereUnique;
};


export type MutationUpdateUserTeamAndMoveTheirReviewsInFirestoreArgs = {
  assigneeUid: Scalars['String']['input'];
  currentUserEmail: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  newTeamId: Scalars['String']['input'];
  oldTeamId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

export type NewCategoryInput = {
  autoFailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The options available for the question */
  measurementOptions?: InputMaybe<Array<MeasurementOptionInput>>;
  measurementType?: InputMaybe<MeasurementType>;
  name?: InputMaybe<Scalars['String']['input']>;
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  requiresComments?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type NewQuestionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  requiresComments?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationSettingsInput = {
  reviewAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  reviewDeleted: Scalars['Boolean']['input'];
  reviewReceived: Scalars['Boolean']['input'];
  reviewWithAutofail: Scalars['Boolean']['input'];
};

export type OnboardingSettingsInput = {
  connectToApplication?: InputMaybe<Scalars['Boolean']['input']>;
  createRubrics?: InputMaybe<Scalars['Boolean']['input']>;
  setupExtension?: InputMaybe<Scalars['Boolean']['input']>;
  setupTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OrgBillingStatus {
  /** ACTIVE */
  Active = 'ACTIVE',
  /** DELINQUENT */
  Delinquent = 'DELINQUENT'
}

export enum OrgEngines {
  /** helpscout */
  Helpscout = 'helpscout',
  /** whitelisted */
  Whitelisted = 'whitelisted',
  /** zendesk */
  Zendesk = 'zendesk'
}

export enum OrgGroup {
  /** EXTERNAL */
  External = 'EXTERNAL',
  /** INTERNAL */
  Internal = 'INTERNAL',
  /** TESTING */
  Testing = 'TESTING'
}

export enum OrgStatus {
  /** ACTIVE */
  Active = 'ACTIVE',
  /** ARCHIVED */
  Archived = 'ARCHIVED'
}

export type Organization = {
  __typename?: 'Organization';
  /** CRM URL. */
  CRMURL?: Maybe<Scalars['String']['output']>;
  /** Admin email. */
  adminEmail: Scalars['String']['output'];
  /** user unique uid. */
  adminUid: Scalars['String']['output'];
  /** This is a list of tags available to be used in the organization. */
  approvedTags?: Maybe<Array<Tag>>;
  authId?: Maybe<Scalars['String']['output']>;
  billingStatus?: Maybe<OrgBillingStatus>;
  createdAt: Scalars['Float']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  /** First team that belong to the organization. */
  defaultTeamView: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  /** This save the engine that works for organization. */
  engine: OrgEngines;
  groups?: Maybe<Array<OrgGroup>>;
  id?: Maybe<Scalars['String']['output']>;
  /** This instance id is unique */
  instanceId: Scalars['String']['output'];
  /** This denotes if this organization is for an external partner */
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  /** This denotes if this organization is used for testing */
  isTesting?: Maybe<Scalars['Boolean']['output']>;
  /** It is organization name. */
  name: Scalars['String']['output'];
  /** This auth id is unique. */
  organizationAuthId: Scalars['String']['output'];
  /** This control which option is activated in private review feature. */
  privateReviews?: Maybe<Scalars['Boolean']['output']>;
  /** It is the first active rubric who belongs to the organization. */
  rubricId: Scalars['String']['output'];
  settings?: Maybe<OrganizationSettings>;
  status?: Maybe<OrgStatus>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  /** They are an array of teams that belongs to this organization. */
  teams: Array<Team>;
  tenantUrl?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Float']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  userAmount: Scalars['Float']['output'];
};

export type OrganizationExtensionSettings = {
  __typename?: 'OrganizationExtensionSettings';
  showScoreInput: Scalars['Boolean']['output'];
};

export type OrganizationExtensionSettingsInput = {
  showScoreInput: Scalars['Boolean']['input'];
};

/** Fields of Organization that can be used for ordering */
export enum OrganizationFieldsEnum {
  AdminEmail = 'ADMIN_EMAIL',
  AdminUid = 'ADMIN_UID',
  ApprovedTags = 'APPROVED_TAGS',
  AuthId = 'AUTH_ID',
  BillingStatus = 'BILLING_STATUS',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrmUrl = 'CRM_URL',
  CustomerId = 'CUSTOMER_ID',
  DefaultTeamView = 'DEFAULT_TEAM_VIEW',
  Description = 'DESCRIPTION',
  DisplayName = 'DISPLAY_NAME',
  DocumentId = 'DOCUMENT_ID',
  Engine = 'ENGINE',
  Groups = 'GROUPS',
  Id = 'ID',
  InstanceId = 'INSTANCE_ID',
  IsExternal = 'IS_EXTERNAL',
  IsTesting = 'IS_TESTING',
  Name = 'NAME',
  OrganizationAuthId = 'ORGANIZATION_AUTH_ID',
  PrivateReviews = 'PRIVATE_REVIEWS',
  RubricId = 'RUBRIC_ID',
  Status = 'STATUS',
  SubscriptionId = 'SUBSCRIPTION_ID',
  Teams = 'TEAMS',
  TenantUrl = 'TENANT_URL',
  Timezone = 'TIMEZONE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserAmount = 'USER_AMOUNT'
}

export type OrganizationInput = {
  /** CRM URL. */
  CRMURL?: InputMaybe<Scalars['String']['input']>;
  /** Admin email. */
  adminEmail: Scalars['String']['input'];
  /** user unique uid. */
  adminUid: Scalars['String']['input'];
  /** This is a list of tags available to be used in the organization. */
  approvedTags?: InputMaybe<Array<TagInput>>;
  authId?: InputMaybe<Scalars['String']['input']>;
  billingStatus?: InputMaybe<OrgBillingStatus>;
  createdAt: Scalars['Float']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  /** First team that belong to the organization. */
  defaultTeamView: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** This save the engine that works for organization. */
  engine: OrgEngines;
  groups?: InputMaybe<Array<OrgGroup>>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** This instance id is unique */
  instanceId: Scalars['String']['input'];
  /** This denotes if this organization is for an external partner */
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** This denotes if this organization is used for testing */
  isTesting?: InputMaybe<Scalars['Boolean']['input']>;
  /** It is organization name. */
  name: Scalars['String']['input'];
  /** This auth id is unique. */
  organizationAuthId: Scalars['String']['input'];
  /** This control which option is activated in private review feature. */
  privateReviews?: InputMaybe<Scalars['Boolean']['input']>;
  /** It is the first active rubric who belongs to the organization. */
  rubricId: Scalars['String']['input'];
  settings?: InputMaybe<OrganizationSettingsInput>;
  status?: InputMaybe<OrgStatus>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  /** They are an array of teams that belongs to this organization. */
  teams: Array<TeamInput>;
  tenantUrl?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['Float']['input'];
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  userAmount: Scalars['Float']['input'];
};

export type OrganizationOrder = {
  /** Field the results should be ordered by */
  by?: InputMaybe<OrganizationFieldsEnum>;
  /** Direction in which the results should be ordered */
  direction?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationOwnerInput = {
  authIdentity: Scalars['String']['input'];
  avatarImage?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  preferredName?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  surname: Scalars['String']['input'];
};

export type OrganizationPrivacyOptionInput = {
  enablePrivacyOption: Scalars['Boolean']['input'];
  instanceId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

export type OrganizationSettings = {
  __typename?: 'OrganizationSettings';
  extension: OrganizationExtensionSettings;
};

export type OrganizationSettingsInput = {
  extension: OrganizationExtensionSettingsInput;
};

export type OrganizationTagInput = {
  instanceId: Scalars['String']['input'];
  /** The value of a tag in the database. */
  tagValue: Scalars['String']['input'];
};

export type OrganizationTeamMember = {
  __typename?: 'OrganizationTeamMember';
  isCurrentUser: Scalars['Boolean']['output'];
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  isFixed?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  photoURL: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
  teamName: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OrganizationWhere = {
  /** CRM URL. */
  CRMURL?: InputMaybe<Scalars['String']['input']>;
  /** Admin email. */
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  /** user unique uid. */
  adminUid?: InputMaybe<Scalars['String']['input']>;
  authId?: InputMaybe<Scalars['String']['input']>;
  billingStatus?: InputMaybe<OrgBillingStatus>;
  createdAt?: InputMaybe<Scalars['Float']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  /** First team that belong to the organization. */
  defaultTeamView?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** This save the engine that works for organization. */
  engine?: InputMaybe<OrgEngines>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** This instance id is unique */
  instanceId?: InputMaybe<Scalars['String']['input']>;
  /** This denotes if this organization is for an external partner */
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** This denotes if this organization is used for testing */
  isTesting?: InputMaybe<Scalars['Boolean']['input']>;
  /** It is organization name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** This auth id is unique. */
  organizationAuthId?: InputMaybe<Scalars['String']['input']>;
  /** This control which option is activated in private review feature. */
  privateReviews?: InputMaybe<Scalars['Boolean']['input']>;
  /** It is the first active rubric who belongs to the organization. */
  rubricId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<OrganizationSettingsInput>;
  status?: InputMaybe<OrgStatus>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  tenantUrl?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Float']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  userAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type PartnerSubscription = {
  __typename?: 'PartnerSubscription';
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  instanceId: Scalars['String']['output'];
  isTrialing: Scalars['Boolean']['output'];
  stripePlanId: Scalars['String']['output'];
  subscriptionId?: Maybe<Scalars['String']['output']>;
  trialEnd: Scalars['Int']['output'];
  trialStart: Scalars['Int']['output'];
};

/** Types of users in the app. */
export enum PropertyToBeFiltered {
  /** assignee id. */
  AssigneeUuid = 'assigneeUUID',
  /** Reviewer id. */
  ReviewerUuid = 'reviewerUUID'
}

export type PublicOrganization = {
  __typename?: 'PublicOrganization';
  id?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  checkCalibrationsName: Scalars['Boolean']['output'];
  checkCalibrationsOnAdminLevel: Scalars['Boolean']['output'];
  checkCalibrationsOnPartnerLevel: Scalars['Boolean']['output'];
  checkDowntimeAnnouncementStatus: BannerDowntimeAnnouncement;
  checkIfACalibrationExistsUsingTicketURL: Scalars['Boolean']['output'];
  checkMaintenanceStatus: Maintenance;
  connection?: Maybe<ConnectionType>;
  connections?: Maybe<Array<ConnectionType>>;
  createCSVForArchivedReviews: CsvData;
  createCSVForReviewsFromFirestore: CsvData;
  createCalibrationCSV: CalibrationCsvData;
  createFirestoreUser: FirestoreUser;
  firestoreUser?: Maybe<FirestoreUser>;
  firestoreUsers: Array<FirestoreUser>;
  getAllOrganizations: Array<Organization>;
  getCalibration: Calibration;
  getCalibrationAnalyticsPerEvaluator: CalibrationHistory;
  getCalibrationHistoryCards: Array<CalibrationWithCalibratorData>;
  getCalibrationScoreById: CalibrationScore;
  getCalibrationScoreWithComments: CalibrationScore;
  getDashboardReviews: Array<ReviewDetails>;
  getDefaultRubricCategories: Array<Scalars['String']['output']>;
  getEvaluator: CalibrationEvaluator;
  /** Fetch reports to display on the insights page */
  getInsight: Insight;
  getOrganizationTeamMembersListGrouped: Array<OrganizationTeamMember>;
  getPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestore: DashboardReviews;
  getPendingCalibrationsPerEvaluator: Array<Calibration>;
  getRestrictedDomains: Array<Scalars['String']['output']>;
  getReviewWithComments: ReviewWithReviewerAndAssigneeData;
  getRubric: RubricV2;
  getRubrics: Array<RubricV2>;
  getRubricsStats: Array<RubricStats>;
  getSubscriptionByInstanceId: PartnerSubscription;
  getSubscriptionPlanById: SubscriptionPlan;
  getTeamRosterDetails: Array<TeamRoster>;
  getWhiteListedDomains: Array<Scalars['String']['output']>;
  goals: Goals;
  invitations: Array<Invitation>;
  isOrganizationRegisteredCRMURL: Scalars['Boolean']['output'];
  organization?: Maybe<Organization>;
  organizationByTenant?: Maybe<PublicOrganization>;
  queueConfiguration: QueueConfiguration;
  queueConfigurations: Array<QueueConfiguration>;
  reviewsCount: Array<ReviewCount>;
  sendRemainderForCalibrationRequest: Message;
  structuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestore: StructuredDashboardReviews;
  ticketQueue: TicketQueue;
  ticketQueues: Array<TicketQueue>;
  userByEmail?: Maybe<FirestoreUser>;
  userById?: Maybe<FirestoreUser>;
  userOrganizations: Array<Organization>;
  users: Array<FirestoreUser>;
};


export type QueryCheckCalibrationsNameArgs = {
  calibrationName: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
};


export type QueryCheckCalibrationsOnAdminLevelArgs = {
  calibratorUid: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
};


export type QueryCheckCalibrationsOnPartnerLevelArgs = {
  instanceId: Scalars['String']['input'];
};


export type QueryCheckIfACalibrationExistsUsingTicketUrlArgs = {
  instanceId: Scalars['String']['input'];
  ticketURL: Scalars['String']['input'];
};


export type QueryConnectionArgs = {
  input: GetConnectionInput;
};


export type QueryConnectionsArgs = {
  input: GetConnectionInput;
};


export type QueryCreateCsvForArchivedReviewsArgs = {
  instanceId: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
  rubricId: Scalars['String']['input'];
};


export type QueryCreateCsvForReviewsFromFirestoreArgs = {
  CSVType: CsvType;
  instanceId: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
  reviewsFilteredInTheDashboard?: InputMaybe<Array<ReviewsFilteredInTheDashboard>>;
  rubricId: Scalars['String']['input'];
};


export type QueryCreateCalibrationCsvArgs = {
  calibrationId: Scalars['String']['input'];
};


export type QueryCreateFirestoreUserArgs = {
  input: FirestoreUserCreateInput;
};


export type QueryFirestoreUserArgs = {
  order?: InputMaybe<FirestoreUserOrder>;
  where?: InputMaybe<FirestoreUserWhere>;
};


export type QueryFirestoreUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<FirestoreUserOrder>;
  where?: InputMaybe<FirestoreUserWhere>;
};


export type QueryGetCalibrationArgs = {
  calibrationId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};


export type QueryGetCalibrationAnalyticsPerEvaluatorArgs = {
  input: CalibrationAnalyticsInput;
};


export type QueryGetCalibrationHistoryCardsArgs = {
  input: CalibrationHistoryInput;
};


export type QueryGetCalibrationScoreByIdArgs = {
  calibrationScoreKey: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
};


export type QueryGetCalibrationScoreWithCommentsArgs = {
  input: CalibrationScoreInput;
};


export type QueryGetDashboardReviewsArgs = {
  getReviewsArgs: GetReviewsArgs;
};


export type QueryGetEvaluatorArgs = {
  calibrationId: Scalars['String']['input'];
  evaluatorId: Scalars['String']['input'];
};


export type QueryGetInsightArgs = {
  assignees?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate: Scalars['Int']['input'];
  instanceId: Scalars['String']['input'];
  reviewers?: InputMaybe<Array<Scalars['String']['input']>>;
  rubricId?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate: Scalars['Int']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  teamId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrganizationTeamMembersListGroupedArgs = {
  instanceId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};


export type QueryGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreArgs = {
  input: ReviewByTimeRangeInputFromFirestore;
};


export type QueryGetPendingCalibrationsPerEvaluatorArgs = {
  instanceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetReviewWithCommentsArgs = {
  input: ReviewWithCommentsInput;
};


export type QueryGetRubricArgs = {
  rubricId: Scalars['String']['input'];
};


export type QueryGetRubricsArgs = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['Int']['input']>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  instanceId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nameLowerCase?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RubricsStatus>;
  teamId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRubricsStatsArgs = {
  filterBy: FilterBy;
  instanceId: Scalars['String']['input'];
  status?: InputMaybe<RubricsStatus>;
};


export type QueryGetSubscriptionByInstanceIdArgs = {
  instanceId: Scalars['String']['input'];
};


export type QueryGetSubscriptionPlanByIdArgs = {
  stripePlanId: Scalars['String']['input'];
};


export type QueryGetTeamRosterDetailsArgs = {
  instanceId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
  teamLeaderId: Scalars['String']['input'];
};


export type QueryGetWhiteListedDomainsArgs = {
  instanceId: Scalars['String']['input'];
};


export type QueryGoalsArgs = {
  instanceId: Scalars['String']['input'];
};


export type QueryInvitationsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryIsOrganizationRegisteredCrmurlArgs = {
  crmURL: Scalars['String']['input'];
};


export type QueryOrganizationArgs = {
  order?: InputMaybe<OrganizationOrder>;
  where: OrganizationWhere;
};


export type QueryOrganizationByTenantArgs = {
  tenant: Scalars['String']['input'];
};


export type QueryQueueConfigurationArgs = {
  instanceId: Scalars['String']['input'];
};


export type QueryReviewsCountArgs = {
  rubricIds: Array<Scalars['String']['input']>;
};


export type QuerySendRemainderForCalibrationRequestArgs = {
  calibrationId: Scalars['String']['input'];
  calibrationName: Scalars['String']['input'];
  calibrationStartedAt: Scalars['Int']['input'];
  calibratorName: Scalars['String']['input'];
  calibratorPhotoURL: Scalars['String']['input'];
  evaluatorEmail: Scalars['String']['input'];
  evaluatorName: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
};


export type QueryStructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreArgs = {
  input: ReviewByTimeRangeInputFromFirestore;
};


export type QueryTicketQueueArgs = {
  instanceId: Scalars['String']['input'];
  ticketId: Scalars['String']['input'];
};


export type QueryTicketQueuesArgs = {
  filters: GetTicketQueuesInput;
};


export type QueryUserByEmailArgs = {
  email: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
};


export type QueryUserByIdArgs = {
  instanceId: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type QueryUserOrganizationsArgs = {
  email: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  hasTakenTour?: InputMaybe<Scalars['Boolean']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationAuthId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type Question = {
  __typename?: 'Question';
  /** Description of this question */
  description: Scalars['String']['output'];
  /** Question ID */
  id: Scalars['String']['output'];
  /** Name of the question */
  name: Scalars['String']['output'];
  /** Step order of the question */
  orderIndex: Scalars['Int']['output'];
  /** Verifies if this question require a comment */
  requiresComments: Scalars['Boolean']['output'];
  /** Weight of this question */
  weight: Scalars['Int']['output'];
};

export type QuestionAlignment = {
  __typename?: 'QuestionAlignment';
  alignmentScore: Scalars['Float']['output'];
  categoryId: Scalars['String']['output'];
  measurementType: MeasurementType;
  questionId: Scalars['String']['output'];
  questionName: Scalars['String']['output'];
  selectedScore: Scalars['Float']['output'];
};

export type QuestionShapeForCalibration = {
  __typename?: 'QuestionShapeForCalibration';
  /** Category's id */
  categoryId: Scalars['String']['output'];
  /** Description of this question */
  description: Scalars['String']['output'];
  /** Question ID */
  id: Scalars['String']['output'];
  /** Category's Measurement type */
  measurementType: MeasurementType;
  /** Name of the question */
  name: Scalars['String']['output'];
  /** Step order of the question */
  orderIndex: Scalars['Int']['output'];
  /** Unique identifier for the question */
  questionId: Scalars['String']['output'];
  /** Verifies if this question require a comment */
  requiresComments: Scalars['Boolean']['output'];
  /** Weight of this question */
  weight: Scalars['Int']['output'];
};

/** QueueConfiguration */
export type QueueConfiguration = {
  __typename?: 'QueueConfiguration';
  /** To determine the ticket selection criteria */
  countTicketsBy?: Maybe<QueueCountTicketsType>;
  /** To determine whether the data is connected to Operator or not */
  dataConnected: Scalars['Boolean']['output'];
  /** Exclude specific email addresses from the ticket selection */
  exclusions?: Maybe<Array<Scalars['String']['output']>>;
  /** Ticket selection frequency */
  frequency?: Maybe<QueueFrequency>;
  /** Organization ID the queue configuration is for */
  instanceId?: Maybe<Scalars['ID']['output']>;
  /** Date and time of the last data pull */
  lastPullDateTime?: Maybe<Scalars['Float']['output']>;
  /** Date and time of the next data pull */
  nextPullDateTime?: Maybe<Scalars['Float']['output']>;
  /** Number of tickets to select based on the `frequency` */
  ticketAmount?: Maybe<Scalars['Float']['output']>;
};

/** Queue configuration count tickets type */
export enum QueueCountTicketsType {
  /** Per agent tickets selection */
  Agent = 'agent',
  /** Per organization tickets selection. */
  Organization = 'organization'
}

/** Queue configuration frequency to fetch tickets */
export enum QueueFrequency {
  /** Fetch tickets daily */
  Daily = 'daily',
  /** Fetch tickets monthly */
  Monthly = 'monthly',
  /** Fetch tickets weekly (Monday - Sunday) */
  Weekly = 'weekly'
}

export type RemoveQuestionInput = {
  categoryId: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
};

export type RemoveReviewInput = {
  instanceId: Scalars['String']['input'];
  reviewId: Scalars['String']['input'];
  reviewerUUID: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

export type RemoveWhiteListedDomainsInput = {
  instanceId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  whiteListedDomainsListToRemove: Array<Scalars['String']['input']>;
};

export type ReviewByTimeRangeInputFromFirestore = {
  acknowledgmentFilter?: InputMaybe<AcknowledgmentTypeFilters>;
  endAt: Scalars['Int']['input'];
  instanceId: Scalars['String']['input'];
  reviewType?: InputMaybe<ReviewTypeFilterFirestore>;
  rubricsId: Array<Scalars['String']['input']>;
  startAt: Scalars['Int']['input'];
  teamsId: Array<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewComment = {
  __typename?: 'ReviewComment';
  /** Represents the Category ID that the comment belongs to. */
  categoryId: Scalars['String']['output'];
  /** Represents the comment made by the reviewer. */
  comment: Scalars['String']['output'];
  commentKeyId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  /** Represents the question ID that the comment belongs to. */
  questionId: Scalars['ID']['output'];
  /** It's the review Id that this comment belongs to. */
  reviewId: Scalars['ID']['output'];
  /** The URL of the ticket that is being reviewed. */
  reviewURL: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Int']['output']>;
};

export type ReviewCount = {
  __typename?: 'ReviewCount';
  /** The number of reviews that used the rubric */
  reviewCount: Scalars['Int']['output'];
  /** The ID of the rubric we wish to get the review count for */
  rubricId: Scalars['String']['output'];
};

export type ReviewDetails = {
  __typename?: 'ReviewDetails';
  /** The id of the assignee who made the review */
  assigneeId: Scalars['String']['output'];
  /** The name of the assignee who received the review */
  assigneeName: Scalars['String']['output'];
  /** Indicates the handle time from review started and first time completed. It's represented in seconds. */
  handleTime?: Maybe<Scalars['Int']['output']>;
  /** It's true when the assignee has acknowledged the review. */
  isAcknowledged: Scalars['Boolean']['output'];
  /** It's true when the review has been archived. */
  isArchived: Scalars['Boolean']['output'];
  /** It's true when a review has set an autofail on at least one sub category. */
  isAutofailed: Scalars['Boolean']['output'];
  /** Indicates when the review has been first time completed. */
  reviewCompletedAt?: Maybe<Scalars['Int']['output']>;
  /** This is part to identify a review along with reviewer UUID */
  reviewId: Scalars['String']['output'];
  /** Indicates when the review has been started. It's a timestamp. It can be represented by seconds or milliseconds. */
  reviewStartedAt: Scalars['Int']['output'];
  /** It's an URL where the ticket is. */
  reviewURL: Scalars['String']['output'];
  /** The id of the reviewer who made the review */
  reviewerId: Scalars['String']['output'];
  /** The name of the reviewer who made the review */
  reviewerName: Scalars['String']['output'];
  /** The profile photo of the reviewer */
  reviewerPhotoURL: Scalars['String']['output'];
  /** This is the current rubric's name */
  rubricName: Scalars['String']['output'];
  /** Indicates the review status, which can be viewed or opened. */
  status: ReviewStatus;
  /** Represent a list of tags. Tag is a label that gives more information about the review. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** The id of the team the assignee belongs to */
  teamId: Scalars['String']['output'];
  /** Indicates total points achieved during the review. */
  totalScore: Scalars['Float']['output'];
};

export enum ReviewStatus {
  /** review open */
  Open = 'open',
  /** review has been already viewed */
  View = 'view'
}

export type ReviewTypeFilterFirestore = {
  propertyToBeFiltered: PropertyToBeFiltered;
  userUIDToLookFor: Scalars['String']['input'];
};

export type ReviewUserData = {
  __typename?: 'ReviewUserData';
  /** User's email. */
  email: Scalars['String']['output'];
  /** User's name. */
  name: Scalars['String']['output'];
  /** User's photo URL. */
  photoURL: Scalars['String']['output'];
  /** User's secondary email. This exist when the user uses Zendesk. It is not used to log-in */
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  /** User's UUID. */
  uid: Scalars['String']['output'];
};

export type ReviewWithCommentsInput = {
  instanceId: Scalars['String']['input'];
  reviewId: Scalars['String']['input'];
  reviewerUUID: Scalars['String']['input'];
};

export type ReviewWithReviewerAndAssigneeData = {
  __typename?: 'ReviewWithReviewerAndAssigneeData';
  /** Feedback that the review left at the end of the review. */
  additionalFeedback: Scalars['String']['output'];
  /** Contains assignee user data. */
  assigneeData: ReviewUserData;
  /** Unique ID for the user receiving the ticket review */
  assigneeUUID: Scalars['ID']['output'];
  /** This is the collection id from firestore. */
  collectionId?: Maybe<Scalars['ID']['output']>;
  /** Indicates the handle time from review started and first time completed. It's represented in seconds. */
  handleTime?: Maybe<Scalars['Int']['output']>;
  /** Partner unique ID that the ticket is reviewed for */
  instanceId: Scalars['String']['output'];
  /** It's true when the assignee has acknowledged the review. */
  isAcknowledged: Scalars['Boolean']['output'];
  /** It's true when the review has been archived. */
  isArchived: Scalars['Boolean']['output'];
  /** It's true when a review has set an autofail on at least one sub category. */
  isAutofailed: Scalars['Boolean']['output'];
  /** Indicates if there is at least one comment left. */
  isCommentAvailable: Scalars['Boolean']['output'];
  /** Shows when an assignee has been selected through Aprikot interface. */
  isManuallyAssigned: Scalars['Boolean']['output'];
  /** Determines when the assignee has acknowledged the review. It's a timestamps. It can be in seconds or milliseconds. */
  reviewAcknowledgedAt: Scalars['Int']['output'];
  /** Indicates when the review has been first time completed. */
  reviewCompletedAt?: Maybe<Scalars['Int']['output']>;
  /** This is part to identify a review along with reviewer UUID */
  reviewId: Scalars['String']['output'];
  /** Indicates when the review has been started. It's a timestamp. It can be represented by seconds or milliseconds. */
  reviewStartedAt: Scalars['Int']['output'];
  /** It's an URL where the ticket is. */
  reviewURL: Scalars['String']['output'];
  /** Indicates when the review has been last updated */
  reviewUpdatedAt?: Maybe<Scalars['Int']['output']>;
  /** Contains reviewer user data. */
  reviewerData: ReviewUserData;
  /** Indicates reviewer UUID. */
  reviewerUUID: Scalars['ID']['output'];
  /** The unique ID of the rubric used to create the review. */
  rubricId: Scalars['String']['output'];
  /** This is the current rubric's name */
  rubricName: Scalars['String']['output'];
  /** Contains all the categories and their scores and analytics. */
  scoreByCategory: Array<ScoreByCategory>;
  /** Contains all the questions and their respective scores and analytics. */
  scoreByQuestion: Array<ScoreByQuestion>;
  /** Indicates the review status, which can be viewed or opened. */
  status: ReviewStatus;
  /** Represent a list of tags. Tag is a label that gives more information about the review. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Unique ID of the team that the review belongs to. */
  teamId: Scalars['ID']['output'];
  /** Indicates total points achieved during the review. */
  totalScore: Scalars['Float']['output'];
};

export type ReviewsFilteredInTheDashboard = {
  instanceId: Scalars['String']['input'];
  reviewId: Scalars['String']['input'];
  reviewerUUID: Scalars['String']['input'];
  status: ReviewStatus;
  teamId: Scalars['String']['input'];
};

export type RubricStats = {
  __typename?: 'RubricStats';
  /** Array of the categories */
  categories: Array<Category>;
  /** Id of the rubric's author */
  createdBy: Scalars['String']['output'];
  /** Timestamp of when the rubric was created */
  createdDate: Scalars['Int']['output'];
  /** It represents the creator Data */
  creatorData?: Maybe<CreatorData>;
  /** Field that checks if this rubric was favorited */
  favorite: Scalars['Boolean']['output'];
  /** Rubric ID */
  id: Scalars['String']['output'];
  /** ID of the organization the rubric belongs to */
  instanceId: Scalars['String']['output'];
  /** Name of the rubric */
  name: Scalars['String']['output'];
  /** Name of the rubric */
  nameLowerCase: Scalars['String']['output'];
  /** Status of the rubric */
  status: RubricsStatus;
  /** ID of the team the rubric belongs to */
  teamId: Scalars['String']['output'];
  /** It represents the total amount of reviews */
  totalReviewCount: Scalars['Int']['output'];
};

export type RubricV2 = {
  __typename?: 'RubricV2';
  /** Array of the categories */
  categories: Array<Category>;
  /** Id of the rubric's author */
  createdBy: Scalars['String']['output'];
  /** Timestamp of when the rubric was created */
  createdDate: Scalars['Int']['output'];
  /** Field that checks if this rubric was favorited */
  favorite: Scalars['Boolean']['output'];
  /** Rubric ID */
  id: Scalars['String']['output'];
  /** ID of the organization the rubric belongs to */
  instanceId: Scalars['String']['output'];
  /** Name of the rubric */
  name: Scalars['String']['output'];
  /** Name of the rubric */
  nameLowerCase: Scalars['String']['output'];
  /** Status of the rubric */
  status: RubricsStatus;
  /** ID of the team the rubric belongs to */
  teamId: Scalars['String']['output'];
};

export enum RubricsStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

export type ScoreByCategory = {
  __typename?: 'ScoreByCategory';
  /** Amount of points given for the category by the reviewer. */
  awardedCategoryPoints: Scalars['Float']['output'];
  /** Determines the label for the binary score: 'Yes No' or 'Good Bad' and by default 'BLANK'. Use string for this field */
  binaryLabel?: Maybe<Scalars['String']['output']>;
  /** Represents the Category ID in the rubric */
  categoryId: Scalars['ID']['output'];
  /** Category name */
  categoryName: Scalars['String']['output'];
  /** Represent percentage of the category score in the review. */
  categoryScore: Scalars['Float']['output'];
  /** Indicates if the comments that belongs to this category are required. */
  isRequiredComments: Scalars['Boolean']['output'];
  /** Key Autogenerated By Firestore to access to this category */
  keyAutogeneratedByFirestore?: Maybe<Scalars['String']['output']>;
  /** The options available for the question */
  measurementOptions?: Maybe<Array<MeasurementOption>>;
  /** Measurement type for the category based on the rubric. */
  measurementType: MeasurementType;
  /** Specifies the order that the category is shown while reviewing the ticket */
  orderIndex: Scalars['Int']['output'];
  /** Amount of points available for the category. */
  totalCategoryPoints: Scalars['Int']['output'];
};

export type ScoreByQuestion = {
  __typename?: 'ScoreByQuestion';
  /** Amount of points given for the question by the reviewer. */
  awardedQuestionPoints: Scalars['Float']['output'];
  /** Represents the Category ID in the rubric that the question belongs to. */
  categoryId: Scalars['String']['output'];
  /** Contains a comment and some other information */
  comment?: Maybe<ReviewComment>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  /** Determines if the question has been marked as auto fail. */
  isAutofailed: Scalars['Boolean']['output'];
  /** Determines whether the question needs comments from the reviewer or not. */
  isRequiredComments: Scalars['Boolean']['output'];
  /** Determines whether the question has been reviewed or not. */
  isReviewed: Scalars['Boolean']['output'];
  /** Key Autogenerated By Firestore to access to this question */
  keyAutogeneratedByFirestore?: Maybe<Scalars['String']['output']>;
  /** The id of the question, this is coming from the rubric */
  questionId: Scalars['ID']['output'];
  /** The name of the question, this is coming from the rubric. */
  questionName: Scalars['String']['output'];
  /** Calculation of the current score against the total available score for the question. */
  questionScore: Scalars['Float']['output'];
  /** Amount of points available for the question. */
  totalQuestionPoints: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Int']['output']>;
};

export type SelectEmailInviteInput = {
  /** ID of the invitation generated in Auth0 */
  id: Scalars['String']['input'];
};

export type SendEmailInviteInput = {
  /** This instance id is unique */
  instanceId: Scalars['String']['input'];
  invitations: Array<InvitedUser>;
  inviterId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};

export type SignupInput = {
  displayName: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  ownerData?: InputMaybe<OrganizationOwnerInput>;
  subDomain: Scalars['String']['input'];
};

export type StructuredDashboardReviews = {
  __typename?: 'StructuredDashboardReviews';
  metadata?: Maybe<DashboardAnalyticsMetadata>;
  reviews: Array<StructuredReviewWithReviewerAndAssigneeData>;
};

export type StructuredReviewWithReviewerAndAssigneeData = {
  __typename?: 'StructuredReviewWithReviewerAndAssigneeData';
  /** Contains assignee user data. */
  assigneeData: ReviewUserData;
  /** Unique ID for the user receiving the ticket review */
  assigneeUUID: Scalars['ID']['output'];
  /** This is the collection id from firestore. */
  collectionId?: Maybe<Scalars['ID']['output']>;
  /** Indicates the handle time from review started and first time completed. It's represented in seconds. */
  handleTime?: Maybe<Scalars['Int']['output']>;
  /** Partner unique ID that the ticket is reviewed for */
  instanceId: Scalars['String']['output'];
  /** It's true when the assignee has acknowledged the review. */
  isAcknowledged: Scalars['Boolean']['output'];
  /** It's true when the review has been archived. */
  isArchived: Scalars['Boolean']['output'];
  /** Indicates when the review has been first time completed */
  reviewCompletedAt?: Maybe<Scalars['Int']['output']>;
  /** This is part to identify a review along with reviewer UUID */
  reviewId: Scalars['String']['output'];
  /** Indicates when the review has been started. It's a timestamp. It can be represented by seconds or milliseconds. */
  reviewStartedAt: Scalars['Int']['output'];
  /** It's an URL where the ticket is. */
  reviewURL: Scalars['String']['output'];
  /** Indicates when the review has been last updated */
  reviewUpdatedAt?: Maybe<Scalars['Int']['output']>;
  /** Contains reviewer user data. */
  reviewerData: ReviewUserData;
  /** Indicates reviewer UUID. */
  reviewerUUID: Scalars['ID']['output'];
  /** The unique ID of the rubric used to create the review. */
  rubricId: Scalars['String']['output'];
  /** This is the current rubric's name */
  rubricName: Scalars['String']['output'];
  /** Indicates the review status, which can be viewed or opened. */
  status: ReviewStatus;
  /** Represent a list of tags. Tag is a label that gives more information about the review. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Unique ID of the team that the review belongs to. */
  teamId: Scalars['ID']['output'];
  /** Indicates total points achieved during the review. */
  totalScore: Scalars['Float']['output'];
};

export type SubCategoryCsv = {
  __typename?: 'SubCategoryCSV';
  comment?: Maybe<Scalars['String']['output']>;
  score: Scalars['String']['output'];
  weight: Scalars['String']['output'];
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions: SubscriptionPlanPermissions;
  price?: Maybe<Scalars['Int']['output']>;
  stripePlanId: Scalars['String']['output'];
};

export type SubscriptionPlanPermissions = {
  __typename?: 'SubscriptionPlanPermissions';
  advancedRubrics?: Maybe<Scalars['Boolean']['output']>;
  analytics?: Maybe<Scalars['Boolean']['output']>;
  expressSupport?: Maybe<Scalars['Boolean']['output']>;
  featureRequest?: Maybe<Scalars['Boolean']['output']>;
  maxUsers: Scalars['Int']['output'];
  reports?: Maybe<Scalars['Boolean']['output']>;
  subteams?: Maybe<Scalars['Boolean']['output']>;
  trialDays?: Maybe<Scalars['Int']['output']>;
};

export type TableChart = {
  __typename?: 'TableChart';
  data: Array<Scalars['String']['output']>;
  header: Array<Headers>;
};

export type Tag = {
  __typename?: 'Tag';
  tagId: Scalars['String']['output'];
  tagValue: Scalars['String']['output'];
};

export type TagInput = {
  tagId: Scalars['String']['input'];
  tagValue: Scalars['String']['input'];
};

export type Team = {
  __typename?: 'Team';
  /** It is the key that firebase provided */
  key: Scalars['ID']['output'];
  /** It is team name. */
  name: Scalars['String']['output'];
  teamLeaderUid: Scalars['String']['output'];
};

export type TeamData = {
  __typename?: 'TeamData';
  name: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
  teamLeaderUid: Scalars['String']['output'];
};

export type TeamInput = {
  /** It is the key that firebase provided */
  key: Scalars['ID']['input'];
  /** It is team name. */
  name: Scalars['String']['input'];
  teamLeaderUid: Scalars['String']['input'];
};

export type TeamRoster = {
  __typename?: 'TeamRoster';
  authIdentities: Array<FirestoreUserAuthIdentity>;
  createdAt?: Maybe<Scalars['Float']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Preferred name */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Email address */
  email: Scalars['String']['output'];
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  hasTakenTour: Scalars['Boolean']['output'];
  /** Document ID */
  id: Scalars['String']['output'];
  /**
   * Organization ID
   * @deprecated in favor of organizationId
   */
  instanceId: Scalars['String']['output'];
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Notification settings */
  notificationSettings: UserEmailNotificationSettings;
  /** Auth ID */
  organizationAuthId: Scalars['String']['output'];
  /** Organization ID */
  organizationId: Scalars['String']['output'];
  /** Profile picture. */
  photoURL?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  /** Roles of the user */
  roles: Array<FirestoreUserRole>;
  status: FirestoreUserStatus;
  /** Team ID the user belongs to */
  teamId: Scalars['String']['output'];
  totalReviewsGiven: Scalars['Int']['output'];
  totalReviewsReceived: Scalars['Int']['output'];
  /** User ID */
  uid: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** User completed all the onboarding steps for Waizen */
  waizenOnboarding?: Maybe<UserWaizenOnboarding>;
};

export type TicketCommentData = {
  __typename?: 'TicketCommentData';
  categoryId: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  index: Scalars['String']['output'];
  objectType: Scalars['String']['output'];
  subCategoryId: Scalars['String']['output'];
  ticketScoreId: Scalars['String']['output'];
};

export type TicketQueue = {
  __typename?: 'TicketQueue';
  /** The CRM ticket comes from */
  CRM: Scalars['String']['output'];
  /** The assignee email from CRM */
  assigneeEmail: Scalars['String']['output'];
  /** The assignee name from CRM */
  assigneeName: Scalars['String']['output'];
  /** Flag to identify whether the ticket has been discarded in Waizen */
  discarded: Scalars['Boolean']['output'];
  /** The organizations`s ID the ticket belongs to */
  instanceId: Scalars['String']['output'];
  /** The Waizen user ID the ticket is assigned to */
  queueBatchInfoId: Scalars['String']['output'];
  /** Flag to identify whether the ticket has been reviewed in Waizen */
  reviewed: Scalars['Boolean']['output'];
  /** The ticket channel */
  ticketChannel?: Maybe<Scalars['String']['output']>;
  /** Unix timestamp (seconds) value when ticket closed */
  ticketClosed?: Maybe<Scalars['Float']['output']>;
  /** The ticket ID from CRM */
  ticketId: Scalars['ID']['output'];
  /** The ID of the ticket queue, in the format `{instanceId}_{ticketId}` */
  ticketQueueId: Scalars['ID']['output'];
  /** Unix timestamp (seconds) value when ticket started */
  ticketStarted: Scalars['Float']['output'];
  /** The ticket URL from CRM */
  ticketURL: Scalars['String']['output'];
  /** Total handle time (seconds) */
  totalHandleTime?: Maybe<Scalars['Float']['output']>;
  /** The Waizen user ID the ticket is assigned to */
  userId?: Maybe<Scalars['String']['output']>;
};

export type TicketScore = {
  __typename?: 'TicketScore';
  /** Determines if the ticket is acknowledged by the assignee */
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the ticket is acknowledged by the assignee */
  acknowledgedAt?: Maybe<Scalars['Int']['output']>;
  /** Unique ID for the user receiving the ticket review */
  asigneeUid?: Maybe<Scalars['String']['output']>;
  /** User details */
  assigneeData?: Maybe<TicketUserData>;
  /** Determines if any sub-category has an autofail */
  autofailPresent?: Maybe<Scalars['Boolean']['output']>;
  /** It represent the collection id associated to this calibration in firestore */
  calibrationId?: Maybe<Scalars['String']['output']>;
  /** It could be either Zendesk or Helpscout */
  engine?: Maybe<Scalars['String']['output']>;
  /** Represents the folder ID for the Helpscout engine for a ticket location */
  folderId?: Maybe<Scalars['String']['output']>;
  /** Partner unique ID that the ticket is reviewed for */
  instanceId?: Maybe<Scalars['String']['output']>;
  /** It tells if it's the evaluation created by the calibrator */
  isCalibrationKey?: Maybe<Scalars['Boolean']['output']>;
  /** Represents if the ticket was assigneed using the Aprikot Extension as a manual assignment */
  manualAssignment?: Maybe<Scalars['Boolean']['output']>;
  /** It should always be ticketScore */
  objectType: Scalars['String']['output'];
  /** A 13 digit timestamp representing the review time for the ticket */
  reviewDate: Scalars['Int']['output'];
  /** User details */
  reviewerData?: Maybe<TicketUserData>;
  /** The unique ID of the rubric used to review the ticket */
  rubricId: Scalars['String']['output'];
  /** Calculated fields for the Categories in the ticket */
  scoreByCategory?: Maybe<Array<TicketScoreByCategory>>;
  /** Calculated fields for the SubCategories in the ticket */
  scoreBySubCategory?: Maybe<Array<TicketScoreBySubCategory>>;
  /** Represents the status of the ticket, if it's being reviewed or if all the categories were reviewed already */
  status: ReviewStatus;
  /** Unique ID of the team that the review belongs to */
  teamId: Scalars['ID']['output'];
  /** This is shared by the CRM. NOTE: For helpscout this is a string */
  ticketId: Scalars['String']['output'];
  /** This is shared by the CRM. NOTE: For helpscout this is a string */
  totalScore: Scalars['Int']['output'];
  /** Unique ID for the user that reviewed the ticket */
  type: Scalars['String']['output'];
  /** user id */
  uid: Scalars['String']['output'];
  /** The URL where the ticket was reviewed from, regularly the CMR url with the ticket path */
  url: Scalars['String']['output'];
};

export type TicketScoreByCategory = {
  __typename?: 'TicketScoreByCategory';
  /** Determines the label for the binary score: 'Yes No' or 'Good Bad' */
  binaryLabel?: Maybe<Scalars['String']['output']>;
  /** Represents the Category ID in the rubric */
  categoryId: Scalars['ID']['output'];
  /** The name of the current category */
  categoryName: Scalars['String']['output'];
  /** Amount of points available for the category */
  categoryPoints: Scalars['Int']['output'];
  /** Highest value of points avialable for the subcategories */
  highValue: Scalars['Int']['output'];
  /** Key ID for the database location in the ticket score */
  keyId?: Maybe<Scalars['ID']['output']>;
  /** Lowest value of points avialable for the subcategories */
  lowValue: Scalars['Int']['output'];
  /** Measurement type for the category based on the rubric */
  measurementOptions?: Maybe<Array<MeasurementOption>>;
  /** Measurement type for the category based on the rubric */
  measurementType: MeasurementType;
  /** Specifies the order that the category is shown while reviewing the ticket */
  orderIndex: Scalars['Int']['output'];
  /** Determines if the comments for this category are required or not. */
  requireComments: Scalars['Boolean']['output'];
  /** Amount of points given for the category by the reviewer */
  score: Scalars['Int']['output'];
  /** Represents the score in percentage by evaluating the score given to the ticket by the total amount of available points */
  scorePercentage: Scalars['Float']['output'];
};

export type TicketScoreBySubCategory = {
  __typename?: 'TicketScoreBySubCategory';
  /** Determines if the sub-category has been scored as auto-fail */
  autofail: Scalars['Boolean']['output'];
  /** Contains a comment and some other information */
  comment?: Maybe<TicketCommentData>;
  /** Key ID for the database location in the ticket score */
  keyId?: Maybe<Scalars['ID']['output']>;
  /** It should always be subCategoryScore */
  objectType: Scalars['String']['output'];
  /** Represents the Category ID in the rubric that the subcategory belongs to */
  parentCategoryId: Scalars['String']['output'];
  /** Determines if the sub-category's comment is required */
  requireComment: Scalars['Boolean']['output'];
  /** Determines if the category has been reviewed by the user or not */
  reviewed: Scalars['Boolean']['output'];
  /** The score set by the reviewer */
  score: Scalars['Int']['output'];
  /** Calculation of the current score against the total available score for the sub category */
  scorePercentage: Scalars['Float']['output'];
  /** ID for the sub category in the category that it's being reviewed */
  subCategoryId: Scalars['String']['output'];
  /** Name of the sub category being reviewed */
  subCategoryName: Scalars['String']['output'];
  /** Name of the sub category being reviewed */
  totalPoints: Scalars['Int']['output'];
};

export type TicketUserData = {
  __typename?: 'TicketUserData';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  photoURL?: Maybe<Scalars['String']['output']>;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
};

export type UpdateCategoryInput = {
  categoryId: Scalars['String']['input'];
  newValues: NewCategoryInput;
};

export type UpdateConnectionInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  streams?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateFirestoreUserInput = {
  authIdentities?: InputMaybe<Array<FirestoreUserAuthIdentityInput>>;
  createdAt?: InputMaybe<Scalars['Float']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Preferred name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasTakenTour?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization ID */
  instanceId?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Notification settings */
  notificationSettings?: InputMaybe<NotificationSettingsInput>;
  /** Auth ID */
  organizationAuthId?: InputMaybe<Scalars['String']['input']>;
  /** Profile picture. */
  photoURL?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  /** Roles of the user */
  roles?: InputMaybe<Array<FirestoreUserRole>>;
  status?: InputMaybe<FirestoreUserStatus>;
  /** Team ID the user belongs to */
  teamId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Float']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** User completed all the onboarding steps for Waizen */
  waizenOnboarding?: InputMaybe<OnboardingSettingsInput>;
};

export type UpdateGoalsInput = {
  criticalErrorRate?: InputMaybe<Scalars['Float']['input']>;
  errorFreeRate?: InputMaybe<Scalars['Float']['input']>;
  instanceId: Scalars['String']['input'];
  qaScore?: InputMaybe<Scalars['Float']['input']>;
  sample?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOrganizationFieldsInput = {
  /** CRM URL. */
  CRMURL?: InputMaybe<Scalars['String']['input']>;
  /** Admin email. */
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  /** user unique uid. */
  adminUid?: InputMaybe<Scalars['String']['input']>;
  authId?: InputMaybe<Scalars['String']['input']>;
  billingStatus?: InputMaybe<OrgBillingStatus>;
  createdAt?: InputMaybe<Scalars['Float']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  /** First team that belong to the organization. */
  defaultTeamView?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** This save the engine that works for organization. */
  engine?: InputMaybe<OrgEngines>;
  groups?: InputMaybe<Array<OrgGroup>>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** This denotes if this organization is for an external partner */
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** This denotes if this organization is used for testing */
  isTesting?: InputMaybe<Scalars['Boolean']['input']>;
  /** This control which option is activated in private review feature. */
  privateReviews?: InputMaybe<Scalars['Boolean']['input']>;
  /** It is the first active rubric who belongs to the organization. */
  rubricId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<OrganizationSettingsInput>;
  status?: InputMaybe<OrgStatus>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  tenantUrl?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Float']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  userAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateQuestionInput = {
  categoryId: Scalars['String']['input'];
  newValues: NewQuestionInput;
  questionId: Scalars['String']['input'];
};

export type UpdateQueueConfigurationInput = {
  /** To determine the ticket selection criteria */
  countTicketsBy?: InputMaybe<QueueCountTicketsType>;
  /** Exclude specific email addresses from the ticket selection */
  exclusions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ticket selection frequency */
  frequency?: InputMaybe<QueueFrequency>;
  /** Number of tickets to select based on the `frequency` */
  ticketAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateRubricInput = {
  /** Id of the rubric's author */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp of when the rubric was created */
  createdDate?: InputMaybe<Scalars['Int']['input']>;
  /** Field that checks if this rubric was favorited */
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the rubric */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Status of the rubric */
  status?: InputMaybe<RubricsStatus>;
};

export type UpdateTicketQueueInput = {
  /** Flag to identify whether the ticket has been discarded in Waizen */
  discarded?: InputMaybe<Scalars['Boolean']['input']>;
  instanceId: Scalars['String']['input'];
  /** Flag to identify whether the ticket has been reviewed in Waizen */
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  ticketId: Scalars['String']['input'];
  /** The ticket URL from CRM */
  ticketURL?: InputMaybe<Scalars['String']['input']>;
};

export type UserEmailNotificationSettings = {
  __typename?: 'UserEmailNotificationSettings';
  reviewAcknowledged?: Maybe<Scalars['Boolean']['output']>;
  reviewDeleted: Scalars['Boolean']['output'];
  reviewReceived: Scalars['Boolean']['output'];
  reviewWithAutofail: Scalars['Boolean']['output'];
};

export type UserWaizenOnboarding = {
  __typename?: 'UserWaizenOnboarding';
  connectToApplication?: Maybe<Scalars['Boolean']['output']>;
  createRubrics?: Maybe<Scalars['Boolean']['output']>;
  setupExtension?: Maybe<Scalars['Boolean']['output']>;
  setupTeam?: Maybe<Scalars['Boolean']['output']>;
};

/** Filters the data. */
export enum FilterBy {
  /** It returns favorite and unfavorite data */
  All = 'All',
  /** It returns just favorite data. */
  Favorites = 'favorites'
}

export enum Status {
  Closed = 'closed',
  Completed = 'completed',
  Inprogress = 'inprogress',
  Pending = 'pending'
}

export type AcknowledgeAReviewAndSendNotificationsMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
  reviewerUUID: Scalars['String']['input'];
  assigneeData: GetAssigneeDataForNotificationInput;
  reviewId: Scalars['String']['input'];
  teamLeaderUid: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
}>;


export type AcknowledgeAReviewAndSendNotificationsMutation = { __typename?: 'Mutation', acknowledgeAReviewAndSendNotifications: { __typename?: 'Message', code: number, message: string } };

export type AddEvaluatorsMutationVariables = Exact<{
  evaluators: Array<AddEvaluatorInput> | AddEvaluatorInput;
  rubricId: Scalars['String']['input'];
  calibrationId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  calibratorData: CalibratorData;
  calibrationName: Scalars['String']['input'];
  calibrationStartedAt: Scalars['Int']['input'];
}>;


export type AddEvaluatorsMutation = { __typename?: 'Mutation', addEvaluators: { __typename?: 'Message', code: number, message: string } };

export type AddOrganizationTagMutationVariables = Exact<{
  tagInput: OrganizationTagInput;
}>;


export type AddOrganizationTagMutation = { __typename?: 'Mutation', addOrganizationTag: string };

export type ArchiveUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ArchiveUserMutation = { __typename?: 'Mutation', archiveUser: { __typename?: 'Message', code: number, key?: string | null, message: string } };

export type ArchiveCalibrationsByRubricIdMutationVariables = Exact<{
  rubricId: Scalars['String']['input'];
}>;


export type ArchiveCalibrationsByRubricIdMutation = { __typename?: 'Mutation', archiveCalibrationsByRubricId: { __typename?: 'Message', code: number, message: string } };

export type ArchiveReviewsMutationVariables = Exact<{
  rubricId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
}>;


export type ArchiveReviewsMutation = { __typename?: 'Mutation', archiveReviews: { __typename?: 'Message', code: number, message: string } };

export type CalibrateScoresMutationVariables = Exact<{
  calibrationId: Scalars['String']['input'];
}>;


export type CalibrateScoresMutation = { __typename?: 'Mutation', calibrateScores: { __typename?: 'Message', code: number, message: string } };

export type CreateCalibrationMutationVariables = Exact<{
  newCalibration: CalibrationInput;
}>;


export type CreateCalibrationMutation = { __typename?: 'Mutation', createCalibration: { __typename?: 'Message', code: number, message: string, key?: string | null } };

export type CheckDuplicateRubricMutationVariables = Exact<{
  checkDuplicateRubricInput: CheckDuplicateRubricInput;
}>;


export type CheckDuplicateRubricMutation = { __typename?: 'Mutation', checkDuplicateRubric: boolean };

export type CreateConnectionMutationVariables = Exact<{
  createConnectionInput: CreateConnectionInput;
}>;


export type CreateConnectionMutation = { __typename?: 'Mutation', createConnection: { __typename?: 'ConnectionType', active: boolean, connectorInstanceId: string, credentialId: string, initTimestamp: string, metadata: any, organizationId: string, streams?: any | null, subdomain: string, system: ConnectionSystem, configuration: { __typename?: 'ConnectionConfigType', auditData?: boolean | null, eventData?: boolean | null, ticketData?: boolean | null } } };

export type CreateGoalsMutationVariables = Exact<{
  createGoalsInput: CreateGoalsInput;
}>;


export type CreateGoalsMutation = { __typename?: 'Mutation', createGoals: { __typename?: 'Goals', instanceId: string, sample?: number | null, qaScore?: number | null, errorFreeRate?: number | null, criticalErrorRate?: number | null } };

export type CreateOrganizationTeamMutationVariables = Exact<{
  name: Scalars['String']['input'];
  teamLeaderUid: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type CreateOrganizationTeamMutation = { __typename?: 'Mutation', createOrganizationTeam: { __typename?: 'TeamData', name: string, teamLeaderUid: string, teamId: string } };

export type CreateQueueConfigurationMutationVariables = Exact<{
  createQueueConfigurationInput: CreateQueueConfigurationInput;
}>;


export type CreateQueueConfigurationMutation = { __typename?: 'Mutation', createQueueConfiguration: { __typename?: 'QueueConfiguration', instanceId?: string | null, dataConnected: boolean, frequency?: QueueFrequency | null, ticketAmount?: number | null, countTicketsBy?: QueueCountTicketsType | null, exclusions?: Array<string> | null, lastPullDateTime?: number | null, nextPullDateTime?: number | null } };

export type CreateRubricV2MutationVariables = Exact<{
  createRubricInput: CreateRubricV2Input;
}>;


export type CreateRubricV2Mutation = { __typename?: 'Mutation', createRubricV2: { __typename?: 'RubricV2', id: string, createdDate: number, instanceId: string, status: RubricsStatus, name: string, nameLowerCase: string, teamId: string, favorite: boolean, createdBy: string, categories: Array<{ __typename?: 'Category', id: string, requiresComments: boolean, orderIndex: number, measurementType: MeasurementType, weight: number, name: string, notApplicable: boolean, autoFailEnabled: boolean, questions: Array<{ __typename?: 'Question', id: string, name: string, weight: number, description: string, requiresComments: boolean, orderIndex: number }>, measurementOptions?: Array<{ __typename?: 'MeasurementOption', label: string, value: number }> | null }> } };

export type CreateUserMutationVariables = Exact<{
  input: FirestoreUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', firestoreCreateUser: { __typename?: 'Message', code: number, message: string } };

export type AddWhiteListedDomainsMutationVariables = Exact<{
  input: AddWhiteListedDomainsInput;
}>;


export type AddWhiteListedDomainsMutation = { __typename?: 'Mutation', addWhiteListedDomains: { __typename?: 'Message', code: number, message: string } };

export type DeactivateConnectionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type DeactivateConnectionMutation = { __typename?: 'Mutation', deactivateConnection: { __typename?: 'ConnectionType', active: boolean } };

export type DeleteEmailInviteMutationVariables = Exact<{
  input: SelectEmailInviteInput;
}>;


export type DeleteEmailInviteMutation = { __typename?: 'Mutation', deleteEmailInvite: { __typename?: 'Invitation', id: string, organizationId: string, organizationAuthId: string, email: string, inviterId: string, createdAt: number, expiresAt: number, role: FirestoreUserRole, status: InvitationStatus } };

export type DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutationVariables = Exact<{
  usersIdList: Array<Scalars['String']['input']> | Scalars['String']['input'];
  oldTeamId: Scalars['String']['input'];
  newTeamId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutation = { __typename?: 'Mutation', deleteOrgTeamAndMoveReviewsAndUsersToTheNewTeam: { __typename?: 'Message', code: number, message: string } };

export type DuplicateRubricMutationVariables = Exact<{
  rubricId: Scalars['String']['input'];
}>;


export type DuplicateRubricMutation = { __typename?: 'Mutation', duplicateRubric: { __typename?: 'RubricV2', id: string, createdDate: number, instanceId: string, status: RubricsStatus, name: string, nameLowerCase: string, teamId: string, favorite: boolean, createdBy: string, categories: Array<{ __typename?: 'Category', id: string, requiresComments: boolean, orderIndex: number, measurementType: MeasurementType, weight: number, name: string, notApplicable: boolean, autoFailEnabled: boolean, questions: Array<{ __typename?: 'Question', id: string, name: string, weight: number, description: string, requiresComments: boolean, orderIndex: number }> }> } };

export type CreateCalibrationCsvQueryVariables = Exact<{
  calibrationId: Scalars['String']['input'];
}>;


export type CreateCalibrationCsvQuery = { __typename?: 'Query', createCalibrationCSV: { __typename?: 'CalibrationCSVData', filename: string, data: Array<{ __typename?: 'CalibrationCSVContent', assigneeName: string, startDate: string, endDate: string, individualAlignmentScore: string, rubricName: string, isAlignmentToTheAnswerKeyRecord: boolean, questions: Array<{ __typename?: 'CalibrationQuestionCSV', questionId: string, scoreGiven: string, categoryId: string }> }>, allOrderedQuestionsFromOriginalRubric: Array<{ __typename?: 'QuestionShapeForCalibration', categoryId: string, measurementType: MeasurementType, questionId: string, description: string, id: string, name: string, orderIndex: number, requiresComments: boolean, weight: number }>, headers: Array<{ __typename?: 'HeaderCSV', label: string, key: string, access: string }> } };

export type ModifyOrganizationTeamMutationVariables = Exact<{
  teamId: Scalars['String']['input'];
  teamName?: InputMaybe<Scalars['String']['input']>;
  teamLeaderUid?: InputMaybe<Scalars['String']['input']>;
  instanceId: Scalars['String']['input'];
}>;


export type ModifyOrganizationTeamMutation = { __typename?: 'Mutation', modifyOrganizationTeam: { __typename?: 'ModifyOrganizationTeamResponse', teamId: string } };

export type MoveOrganizationUsersToAnotherTeamMutationVariables = Exact<{
  usersIdList: Array<Scalars['String']['input']> | Scalars['String']['input'];
  oldTeamId: Scalars['String']['input'];
  newTeamId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type MoveOrganizationUsersToAnotherTeamMutation = { __typename?: 'Mutation', moveOrganizationUsersToAnotherTeam: { __typename?: 'Message', code: number, message: string } };

export type RemoveAllOrganizationTagsMutationVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type RemoveAllOrganizationTagsMutation = { __typename?: 'Mutation', removeAllOrganizationTags: { __typename?: 'Message', code: number, message: string } };

export type RemoveCalibrationMutationVariables = Exact<{
  calibrationId: Scalars['String']['input'];
  notifyEvaluators: Scalars['Boolean']['input'];
}>;


export type RemoveCalibrationMutation = { __typename?: 'Mutation', removeCalibration: { __typename?: 'Message', code: number, message: string } };

export type RemoveEvaluatorsMutationVariables = Exact<{
  calibrationId: Scalars['String']['input'];
  evaluators: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RemoveEvaluatorsMutation = { __typename?: 'Mutation', removeEvaluators: { __typename?: 'Message', code: number, message: string } };

export type RemoveOrganizationTagMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
}>;


export type RemoveOrganizationTagMutation = { __typename?: 'Mutation', removeOrganizationTag: { __typename?: 'Message', code: number, message: string } };

export type RemoveReviewMutationVariables = Exact<{
  input: RemoveReviewInput;
}>;


export type RemoveReviewMutation = { __typename?: 'Mutation', removeReview: { __typename?: 'Message', code: number, message: string } };

export type RemoveWhiteListedDomainsMutationVariables = Exact<{
  whiteListedDomainsListToRemove: Array<Scalars['String']['input']> | Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type RemoveWhiteListedDomainsMutation = { __typename?: 'Mutation', removeWhiteListedDomains: { __typename?: 'Message', code: number, message: string } };

export type SendEmailInviteMutationVariables = Exact<{
  input: SendEmailInviteInput;
}>;


export type SendEmailInviteMutation = { __typename?: 'Mutation', sendEmailInvite: Array<{ __typename?: 'Invitation', id: string, organizationId: string, organizationAuthId: string, email: string, inviterId: string, createdAt: number, expiresAt: number, role: FirestoreUserRole, status: InvitationStatus }> };

export type SendEmailNotificationsForRemovedEvaluatorsMutationVariables = Exact<{
  evaluatorsToBeRemoved: Array<EvaluatorToBeRemovedInput> | EvaluatorToBeRemovedInput;
  calibrationData: CalibrationInputForRemovedEvaluatorsEmail;
  instanceId: Scalars['String']['input'];
}>;


export type SendEmailNotificationsForRemovedEvaluatorsMutation = { __typename?: 'Mutation', sendEmailNotificationsForRemovedEvaluators: { __typename?: 'Message', code: number, message: string } };

export type SignupMutationVariables = Exact<{
  input: SignupInput;
}>;


export type SignupMutation = { __typename?: 'Mutation', signup?: { __typename?: 'Organization', tenantUrl?: string | null, displayName?: string | null } | null };

export type ClearTicketQueueMutationVariables = Exact<{
  organization: Scalars['String']['input'];
}>;


export type ClearTicketQueueMutation = { __typename?: 'Mutation', clearTicketQueue: boolean };

export type PullTicketQueueMutationVariables = Exact<{
  organization: Scalars['String']['input'];
}>;


export type PullTicketQueueMutation = { __typename?: 'Mutation', pullTicketQueue: boolean };

export type ToggleOrganizationPrivacyOptionMutationVariables = Exact<{
  enablePrivacyOption: Scalars['Boolean']['input'];
  userEmail: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type ToggleOrganizationPrivacyOptionMutation = { __typename?: 'Mutation', toggleOrganizationPrivacyOption: { __typename?: 'Message', code: number, message: string } };

export type ToggleUserAsTeamLeaderMutationVariables = Exact<{
  where: FirestoreUserWhereUnique;
  input: FirestoreUserUpdateInput;
}>;


export type ToggleUserAsTeamLeaderMutation = { __typename?: 'Mutation', toggleUserAsTeamLeader: { __typename?: 'Message', code: number, message: string } };

export type UpdateFirestoreUserMutationVariables = Exact<{
  where: FirestoreUserWhereUnique;
  input: FirestoreUserUpdateInput;
}>;


export type UpdateFirestoreUserMutation = { __typename?: 'Mutation', updateFirestoreUser: { __typename?: 'FirestoreUser', id: string, uid: string, organizationAuthId: string, instanceId: string, organizationId: string, email: string, status: FirestoreUserStatus, firstName?: string | null, lastName?: string | null, displayName?: string | null, pronouns?: string | null, hasTakenTour: boolean, photoURL?: string | null, teamId: string, roles: Array<FirestoreUserRole> } };

export type UpdateCalibrationsNameMutationVariables = Exact<{
  calibrationId: Scalars['String']['input'];
  calibrationName: Scalars['String']['input'];
}>;


export type UpdateCalibrationsNameMutation = { __typename?: 'Mutation', updateCalibrationsName: { __typename?: 'Message', code: number, message: string } };

export type UpdateGoalsMutationVariables = Exact<{
  updateGoalsInput: UpdateGoalsInput;
}>;


export type UpdateGoalsMutation = { __typename?: 'Mutation', updateGoals: { __typename?: 'Goals', instanceId: string, sample?: number | null, qaScore?: number | null, errorFreeRate?: number | null, criticalErrorRate?: number | null } };

export type UpdateNotificationSettingsReviewAcknowledgedMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  reviewAcknowledged: Scalars['Boolean']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type UpdateNotificationSettingsReviewAcknowledgedMutation = { __typename?: 'Mutation', updateNotificationSettingsReviewAcknowledged: { __typename?: 'Message', code: number, message: string } };

export type UpdateNotificationSettingsReviewDeletedMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  reviewDeleted: Scalars['Boolean']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type UpdateNotificationSettingsReviewDeletedMutation = { __typename?: 'Mutation', updateNotificationSettingsReviewDeleted: { __typename?: 'Message', code: number, message: string } };

export type UpdateNotificationSettingsReviewReceivedMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  reviewReceived: Scalars['Boolean']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type UpdateNotificationSettingsReviewReceivedMutation = { __typename?: 'Mutation', updateNotificationSettingsReviewReceived: { __typename?: 'Message', code: number, message: string } };

export type UpdateNotificationSettingsReviewWithAutofailMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  reviewWithAutofail: Scalars['Boolean']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type UpdateNotificationSettingsReviewWithAutofailMutation = { __typename?: 'Mutation', updateNotificationSettingsReviewWithAutofail: { __typename?: 'Message', code: number, message: string } };

export type UpdateOrganizationFieldsMutationVariables = Exact<{
  orgName: Scalars['String']['input'];
  updateOrganizationFields: UpdateOrganizationFieldsInput;
}>;


export type UpdateOrganizationFieldsMutation = { __typename?: 'Mutation', updateOrganizationFields: { __typename?: 'Message', code: number } };

export type UpdateOrganizationZendeskCrmurlMutationVariables = Exact<{
  orgName: Scalars['String']['input'];
  newCRMURL: Scalars['String']['input'];
}>;


export type UpdateOrganizationZendeskCrmurlMutation = { __typename?: 'Mutation', updateOrganizationZendeskCRMURL: { __typename?: 'Message', code: number, message: string } };

export type UpdateQueueConfigurationMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  updateQueueConfigurationInput: UpdateQueueConfigurationInput;
}>;


export type UpdateQueueConfigurationMutation = { __typename?: 'Mutation', updateQueueConfiguration: { __typename?: 'QueueConfiguration', instanceId?: string | null, dataConnected: boolean, frequency?: QueueFrequency | null, ticketAmount?: number | null, countTicketsBy?: QueueCountTicketsType | null, exclusions?: Array<string> | null, lastPullDateTime?: number | null, nextPullDateTime?: number | null } };

export type UpdateRubricMutationVariables = Exact<{
  rubricId: Scalars['String']['input'];
  updateRubricInput: UpdateRubricInput;
}>;


export type UpdateRubricMutation = { __typename?: 'Mutation', updateRubric: { __typename?: 'RubricV2', id: string, createdDate: number, instanceId: string, status: RubricsStatus, name: string, nameLowerCase: string, teamId: string, favorite: boolean, createdBy: string, categories: Array<{ __typename?: 'Category', id: string, requiresComments: boolean, orderIndex: number, measurementType: MeasurementType, weight: number, name: string, notApplicable: boolean, autoFailEnabled: boolean, questions: Array<{ __typename?: 'Question', id: string, name: string, weight: number, description: string, requiresComments: boolean, orderIndex: number }> }> } };

export type UpdateRubricCategoriesMutationVariables = Exact<{
  rubricId: Scalars['String']['input'];
  categories: Array<CreateCategoryInput> | CreateCategoryInput;
  questions: Array<CreateQuestionsInput> | CreateQuestionsInput;
  categoriesIdsToRemove: Array<Scalars['String']['input']> | Scalars['String']['input'];
  removeQuestions: Array<RemoveQuestionInput> | RemoveQuestionInput;
  updateCategories: Array<UpdateCategoryInput> | UpdateCategoryInput;
  updateQuestions: Array<UpdateQuestionInput> | UpdateQuestionInput;
  currentRubricStatus: Scalars['String']['input'];
}>;


export type UpdateRubricCategoriesMutation = { __typename?: 'Mutation', updateRubricCategories: { __typename?: 'Message', code: number, message: string } };

export type UpdateTicketQueueMutationVariables = Exact<{
  updateTicketQueueInput: UpdateTicketQueueInput;
}>;


export type UpdateTicketQueueMutation = { __typename?: 'Mutation', updateTicketQueue: { __typename?: 'TicketQueue', ticketId: string, ticketURL: string, assigneeEmail: string, assigneeName: string, ticketStarted: number, ticketClosed?: number | null, totalHandleTime?: number | null, reviewed: boolean, discarded: boolean, instanceId: string } };

export type UpdateUserMutationVariables = Exact<{
  uid: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  input: UpdateFirestoreUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'FirestoreUser', email: string } };

export type UpdateUserRolesMutationVariables = Exact<{
  where: FirestoreUserWhereUnique;
  input: FirestoreUserUpdateInput;
}>;


export type UpdateUserRolesMutation = { __typename?: 'Mutation', updateUserRoles: { __typename?: 'FirestoreUser', id: string, uid: string, organizationAuthId: string, instanceId: string, organizationId: string, email: string, status: FirestoreUserStatus, firstName?: string | null, lastName?: string | null, displayName?: string | null, pronouns?: string | null, hasTakenTour: boolean, photoURL?: string | null, teamId: string, roles: Array<FirestoreUserRole>, createdAt?: number | null, createdBy?: string | null, updatedAt?: number | null, updatedBy?: string | null } };

export type UpdateUserTeamAndMoveTheirReviewsInFirestoreMutationVariables = Exact<{
  newTeamId: Scalars['String']['input'];
  oldTeamId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  assigneeUid: Scalars['String']['input'];
  currentUserEmail: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type UpdateUserTeamAndMoveTheirReviewsInFirestoreMutation = { __typename?: 'Mutation', updateUserTeamAndMoveTheirReviewsInFirestore: { __typename?: 'Message', code: number, message: string } };

export type IsOrganizationRegisteredCrmurlQueryVariables = Exact<{
  crmURL: Scalars['String']['input'];
}>;


export type IsOrganizationRegisteredCrmurlQuery = { __typename?: 'Query', isOrganizationRegisteredCRMURL: boolean };

export type CheckCalibrationsNameQueryVariables = Exact<{
  calibrationName: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type CheckCalibrationsNameQuery = { __typename?: 'Query', checkCalibrationsName: boolean };

export type CheckCalibrationsOnAdminLevelQueryVariables = Exact<{
  calibratorUid: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type CheckCalibrationsOnAdminLevelQuery = { __typename?: 'Query', checkCalibrationsOnAdminLevel: boolean };

export type CheckCalibrationsOnPartnerLevelQueryVariables = Exact<{
  instanceId: Scalars['String']['input'];
}>;


export type CheckCalibrationsOnPartnerLevelQuery = { __typename?: 'Query', checkCalibrationsOnPartnerLevel: boolean };

export type CheckDowntimeAnnouncementStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckDowntimeAnnouncementStatusQuery = { __typename?: 'Query', checkDowntimeAnnouncementStatus: { __typename?: 'BannerDowntimeAnnouncement', active: boolean, message: string } };

export type CheckIfACalibrationExistsUsingTicketUrlQueryVariables = Exact<{
  ticketURL: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type CheckIfACalibrationExistsUsingTicketUrlQuery = { __typename?: 'Query', checkIfACalibrationExistsUsingTicketURL: boolean };

export type CheckMaintenanceStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckMaintenanceStatusQuery = { __typename?: 'Query', checkMaintenanceStatus: { __typename?: 'Maintenance', active: boolean, endTime: number, startTime: number, message: string } };

export type CreateCsvForReviewsFromFirestoreQueryVariables = Exact<{
  instanceId: Scalars['String']['input'];
  rubricId: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
  CSVType: CsvType;
  reviewsFilteredInTheDashboard?: InputMaybe<Array<ReviewsFilteredInTheDashboard> | ReviewsFilteredInTheDashboard>;
}>;


export type CreateCsvForReviewsFromFirestoreQuery = { __typename?: 'Query', createCSVForReviewsFromFirestore: { __typename?: 'CSVData', filename: string, data: Array<{ __typename?: 'CSVContent', assignee: string, assigneeEmail: string, reviewer: string, reviewerEmail: string, ticketNumber: string, reviewStartedAt: number, reviewCompletedAt?: number | null, handleTime?: number | null, reviewUpdatedAt?: number | null, additional_feedback: string, auto_fail: string, review_acknowledged: string, total: string, tags: string, categories: Array<{ __typename?: 'CategoryCSV', name: string, maxScore: string, score: string, scoreWeight: string, subCategories: Array<{ __typename?: 'SubCategoryCSV', score: string, comment?: string | null, weight: string }> }> }>, headers: Array<{ __typename?: 'HeaderCSV', label: string, key: string, access: string }> } };

export type FirestoreUserQueryVariables = Exact<{
  where?: InputMaybe<FirestoreUserWhere>;
  order?: InputMaybe<FirestoreUserOrder>;
}>;


export type FirestoreUserQuery = { __typename?: 'Query', firestoreUser?: { __typename?: 'FirestoreUser', id: string, uid: string, organizationAuthId: string, instanceId: string, organizationId: string, email: string, status: FirestoreUserStatus, firstName?: string | null, lastName?: string | null, displayName?: string | null, pronouns?: string | null, hasTakenTour: boolean, photoURL?: string | null, teamId: string, roles: Array<FirestoreUserRole>, createdAt?: number | null, createdBy?: string | null, updatedAt?: number | null, updatedBy?: string | null, notificationSettings: { __typename?: 'UserEmailNotificationSettings', reviewDeleted: boolean, reviewReceived: boolean, reviewWithAutofail: boolean, reviewAcknowledged?: boolean | null }, waizenOnboarding?: { __typename?: 'UserWaizenOnboarding', connectToApplication?: boolean | null, createRubrics?: boolean | null, setupExtension?: boolean | null, setupTeam?: boolean | null } | null, authIdentities: Array<{ __typename?: 'FirestoreUserAuthIdentity', provider: string, authId?: string | null }> } | null };

export type FirestoreUsersQueryVariables = Exact<{
  where?: InputMaybe<FirestoreUserWhere>;
  order?: InputMaybe<FirestoreUserOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FirestoreUsersQuery = { __typename?: 'Query', firestoreUsers: Array<{ __typename?: 'FirestoreUser', id: string, uid: string, organizationAuthId: string, instanceId: string, organizationId: string, email: string, status: FirestoreUserStatus, firstName?: string | null, lastName?: string | null, displayName?: string | null, pronouns?: string | null, hasTakenTour: boolean, photoURL?: string | null, teamId: string, roles: Array<FirestoreUserRole>, createdAt?: number | null, createdBy?: string | null, updatedAt?: number | null, updatedBy?: string | null, notificationSettings: { __typename?: 'UserEmailNotificationSettings', reviewDeleted: boolean, reviewReceived: boolean, reviewWithAutofail: boolean, reviewAcknowledged?: boolean | null }, waizenOnboarding?: { __typename?: 'UserWaizenOnboarding', connectToApplication?: boolean | null, createRubrics?: boolean | null, setupExtension?: boolean | null, setupTeam?: boolean | null } | null, authIdentities: Array<{ __typename?: 'FirestoreUserAuthIdentity', provider: string, authId?: string | null }> }> };

export type CreateCsvForArchivedReviewsQueryVariables = Exact<{
  instanceId: Scalars['String']['input'];
  rubricId: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
}>;


export type CreateCsvForArchivedReviewsQuery = { __typename?: 'Query', createCSVForArchivedReviews: { __typename?: 'CSVData', filename: string, data: Array<{ __typename?: 'CSVContent', assignee: string, assigneeEmail: string, reviewer: string, reviewerEmail: string, ticketNumber: string, reviewStartedAt: number, reviewCompletedAt?: number | null, handleTime?: number | null, additional_feedback: string, total: string, auto_fail: string, review_acknowledged: string, categories: Array<{ __typename?: 'CategoryCSV', name: string, maxScore: string, score: string, scoreWeight: string, subCategories: Array<{ __typename?: 'SubCategoryCSV', score: string, comment?: string | null, weight: string }> }> }>, headers: Array<{ __typename?: 'HeaderCSV', label: string, key: string, access: string }> } };

export type GetCalibrationQueryVariables = Exact<{
  calibrationId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type GetCalibrationQuery = { __typename?: 'Query', getCalibration: { __typename?: 'Calibration', calibratorUid: string, calibrationId: string, calibrationReviewId: string, mostAlignedQuestion?: string | null, overallAlignmentScore?: number | null, leastAlignedQuestion?: string | null, instanceId: string, name: string, rubricId: string, startedAt: number, completedAt?: number | null, status: Status, teamId: string, url: string, alignmentByQuestion?: Array<{ __typename?: 'QuestionAlignment', selectedScore: number, alignmentScore: number, questionName: string, measurementType: MeasurementType, categoryId: string, questionId: string }> | null, calibrationEvaluators?: Array<{ __typename?: 'CalibrationEvaluator', evaluatorName: string, evaluatorUid: string, evaluatorEmail: string, evaluatorPhotoURL?: string | null, calibrationId: string, calibrationStatus: Status, calibrationScoreID?: string | null, isCalibrator: boolean, mostAlignedQuestion?: string | null, leastAlignedQuestion?: string | null, overallAlignmentScore?: number | null, alignmentByQuestion?: Array<{ __typename?: 'QuestionAlignment', selectedScore: number, alignmentScore: number, questionName: string, measurementType: MeasurementType, categoryId: string, questionId: string }> | null }> | null } };

export type GetCalibrationAnalyticsPerEvaluatorQueryVariables = Exact<{
  startTime: Scalars['Int']['input'];
  endTime: Scalars['Int']['input'];
  rubricId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type GetCalibrationAnalyticsPerEvaluatorQuery = { __typename?: 'Query', getCalibrationAnalyticsPerEvaluator: { __typename?: 'CalibrationHistory', mostAlignedQuestion?: string | null, overallAlignmentScore?: number | null, leastAlignedQuestion?: string | null, amountOfCalibrationEvaluated: number, arePendingCalibrations: boolean, alignmentByQuestion?: Array<{ __typename?: 'QuestionAlignment', alignmentScore: number, questionName: string, categoryId: string, questionId: string }> | null, calibrations: Array<{ __typename?: 'Calibration', calibrationId: string, name: string, url: string }> } };

export type GetCalibrationHistoryCardsQueryVariables = Exact<{
  startTime: Scalars['Int']['input'];
  endTime: Scalars['Int']['input'];
  userIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  rubricsId: Array<Scalars['String']['input']> | Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
}>;


export type GetCalibrationHistoryCardsQuery = { __typename?: 'Query', getCalibrationHistoryCards: Array<{ __typename?: 'CalibrationWithCalibratorData', name: string, calibrationId: string, startedAt: number, status: Status, rubricId: string, mostAlignedQuestion?: string | null, leastAlignedQuestion?: string | null, overallAlignmentScore?: number | null, completedAt?: number | null, url: string, calibratorUid: string, calibratorName: string }> };

export type GetCalibrationScoreByIdQueryVariables = Exact<{
  instanceId: Scalars['String']['input'];
  calibrationScoreKey: Scalars['String']['input'];
}>;


export type GetCalibrationScoreByIdQuery = { __typename?: 'Query', getCalibrationScoreById: { __typename?: 'CalibrationScore', asigneeUid?: string | null, engine?: string | null, folderId?: string | null, instanceId?: string | null, manualAssignment?: boolean | null, objectType: string, reviewDate: number, rubricId: string, status: ReviewStatus, teamId: string, ticketId: string, totalScore: number, type: string, uid: string, url: string, autofailPresent?: boolean | null, acknowledged?: boolean | null, acknowledgedAt?: number | null, calibrationId?: string | null, scoreByCategory?: Array<{ __typename?: 'TicketScoreByCategory', keyId?: string | null, binaryLabel?: string | null, categoryId: string, categoryName: string, categoryPoints: number, highValue: number, lowValue: number, measurementType: MeasurementType, orderIndex: number, score: number, scorePercentage: number, requireComments: boolean }> | null, scoreBySubCategory?: Array<{ __typename?: 'TicketScoreBySubCategory', keyId?: string | null, objectType: string, parentCategoryId: string, reviewed: boolean, score: number, scorePercentage: number, subCategoryId: string, subCategoryName: string, totalPoints: number, autofail: boolean, requireComment: boolean, comment?: { __typename?: 'TicketCommentData', categoryId: string, comment: string, index: string, objectType: string, subCategoryId: string, ticketScoreId: string } | null }> | null, assigneeData?: { __typename?: 'TicketUserData', name: string, photoURL?: string | null, email: string, secondaryEmail?: string | null } | null, reviewerData?: { __typename?: 'TicketUserData', name: string, photoURL?: string | null, email: string, secondaryEmail?: string | null } | null } };

export type GetCalibrationScoreWithCommentsQueryVariables = Exact<{
  input: CalibrationScoreInput;
}>;


export type GetCalibrationScoreWithCommentsQuery = { __typename?: 'Query', getCalibrationScoreWithComments: { __typename?: 'CalibrationScore', asigneeUid?: string | null, engine?: string | null, folderId?: string | null, instanceId?: string | null, manualAssignment?: boolean | null, objectType: string, reviewDate: number, rubricId: string, status: ReviewStatus, teamId: string, ticketId: string, totalScore: number, type: string, uid: string, url: string, autofailPresent?: boolean | null, acknowledged?: boolean | null, acknowledgedAt?: number | null, calibrationId?: string | null, isCalibrationKey?: boolean | null, scoreByCategory?: Array<{ __typename?: 'TicketScoreByCategory', keyId?: string | null, binaryLabel?: string | null, categoryId: string, categoryName: string, categoryPoints: number, highValue: number, lowValue: number, measurementType: MeasurementType, orderIndex: number, score: number, scorePercentage: number, requireComments: boolean, measurementOptions?: Array<{ __typename?: 'MeasurementOption', label: string, value: number }> | null }> | null, scoreBySubCategory?: Array<{ __typename?: 'TicketScoreBySubCategory', keyId?: string | null, objectType: string, parentCategoryId: string, reviewed: boolean, score: number, scorePercentage: number, subCategoryId: string, subCategoryName: string, totalPoints: number, autofail: boolean, requireComment: boolean, comment?: { __typename?: 'TicketCommentData', categoryId: string, comment: string, index: string, objectType: string, subCategoryId: string, ticketScoreId: string } | null }> | null, assigneeData?: { __typename?: 'TicketUserData', name: string, photoURL?: string | null, email: string, secondaryEmail?: string | null } | null, reviewerData?: { __typename?: 'TicketUserData', name: string, photoURL?: string | null, email: string, secondaryEmail?: string | null } | null } };

export type GetConnectionQueryVariables = Exact<{
  getConnectionInput: GetConnectionInput;
}>;


export type GetConnectionQuery = { __typename?: 'Query', connection?: { __typename?: 'ConnectionType', active: boolean, connectorInstanceId: string, credentialId: string, initTimestamp: string, organizationId: string, streams?: any | null, subdomain: string, system: ConnectionSystem, metadata: any, configuration: { __typename?: 'ConnectionConfigType', auditData?: boolean | null, eventData?: boolean | null, ticketData?: boolean | null } } | null };

export type GetConnectionsQueryVariables = Exact<{
  getConnectionInput: GetConnectionInput;
}>;


export type GetConnectionsQuery = { __typename?: 'Query', connections?: Array<{ __typename?: 'ConnectionType', active: boolean, connectorInstanceId: string, credentialId: string, initTimestamp: string, metadata: any, organizationId: string, streams?: any | null, subdomain: string, system: ConnectionSystem, configuration: { __typename?: 'ConnectionConfigType', auditData?: boolean | null, eventData?: boolean | null, ticketData?: boolean | null } }> | null };

export type GetDashboardReviewsQueryVariables = Exact<{
  getReviewsArgs: GetReviewsArgs;
}>;


export type GetDashboardReviewsQuery = { __typename?: 'Query', getDashboardReviews: Array<{ __typename?: 'ReviewDetails', isAcknowledged: boolean, isArchived: boolean, isAutofailed: boolean, reviewId: string, assigneeId: string, reviewStartedAt: number, reviewURL: string, totalScore: number, tags?: Array<string> | null, reviewerPhotoURL: string, reviewerName: string, reviewerId: string, teamId: string, assigneeName: string, rubricName: string, reviewCompletedAt?: number | null, handleTime?: number | null, status: ReviewStatus }> };

export type GetDefaultRubricCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultRubricCategoriesQuery = { __typename?: 'Query', getDefaultRubricCategories: Array<string> };

export type GetInvitesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetInvitesQuery = { __typename?: 'Query', invitations: Array<{ __typename?: 'Invitation', id: string, organizationId: string, organizationAuthId: string, email: string, inviterId: string, createdAt: number, expiresAt: number, role: FirestoreUserRole, status: InvitationStatus }> };

export type GetInsightQueryVariables = Exact<{
  instanceId: Scalars['String']['input'];
  startDate: Scalars['Int']['input'];
  endDate: Scalars['Int']['input'];
  teamId?: InputMaybe<Scalars['String']['input']>;
  reviewers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  assignees?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  rubricId?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetInsightQuery = { __typename?: 'Query', getInsight: { __typename?: 'Insight', sample: number, qaScore: number, errorFreeRate: number, criticalErrorRate: number, qaScoreVSample: { __typename?: 'MultiChart', category: Array<{ __typename?: 'Categories', label: string }>, dataset: Array<{ __typename?: 'DataSet', seriesname: string, data: Array<{ __typename?: 'Data', value?: string | null }> }> }, performanceByTag?: { __typename?: 'BarChart', data: Array<{ __typename?: 'Bar', label: string, value: string }> } | null, erfAndCre: { __typename?: 'MultiChart', category: Array<{ __typename?: 'Categories', label: string }>, dataset: Array<{ __typename?: 'DataSet', seriesname: string, data: Array<{ __typename?: 'Data', value?: string | null }> }> }, rubricsScores?: { __typename?: 'MultiChart', dataset: Array<{ __typename?: 'DataSet', seriesname: string, data: Array<{ __typename?: 'Data', value?: string | null }> }>, category: Array<{ __typename?: 'Categories', label: string }> } | null, performanceByCategory?: { __typename?: 'BarChart', data: Array<{ __typename?: 'Bar', label: string, value: string }> } | null, performanceByQuestion?: { __typename?: 'BarChart', data: Array<{ __typename?: 'Bar', label: string, value: string }> } | null, associatesScores: { __typename?: 'TableChart', data: Array<string>, header: Array<{ __typename?: 'Headers', Header: string, accessor: string }> }, markedDownByTag?: { __typename?: 'TableChart', data: Array<string>, header: Array<{ __typename?: 'Headers', accessor: string, Header: string }> } | null } };

export type GetOrganizationQueryVariables = Exact<{
  where: OrganizationWhere;
}>;


export type GetOrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', instanceId: string, organizationAuthId: string, name: string, CRMURL?: string | null, adminEmail: string, adminUid: string, defaultTeamView: string, engine: OrgEngines, rubricId: string, privateReviews?: boolean | null, isExternal?: boolean | null, isTesting?: boolean | null, tenantUrl?: string | null, id?: string | null, authId?: string | null, documentId?: string | null, displayName?: string | null, description?: string | null, timezone?: string | null, groups?: Array<OrgGroup> | null, status?: OrgStatus | null, billingStatus?: OrgBillingStatus | null, userAmount: number, createdAt: number, createdBy?: string | null, updatedAt: number, updatedBy?: string | null, customerId?: string | null, subscriptionId?: string | null, teams: Array<{ __typename?: 'Team', key: string, name: string, teamLeaderUid: string }>, approvedTags?: Array<{ __typename?: 'Tag', tagValue: string, tagId: string }> | null, settings?: { __typename?: 'OrganizationSettings', extension: { __typename?: 'OrganizationExtensionSettings', showScoreInput: boolean } } | null } | null };

export type GetOrganizationByInstanceIdQueryVariables = Exact<{
  instanceId: Scalars['String']['input'];
}>;


export type GetOrganizationByInstanceIdQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', adminEmail: string, adminUid: string, CRMURL?: string | null, defaultTeamView: string, engine: OrgEngines, instanceId: string, name: string, rubricId: string, privateReviews?: boolean | null, organizationAuthId: string, createdAt: number, createdBy?: string | null, updatedAt: number, updatedBy?: string | null, userAmount: number, teams: Array<{ __typename?: 'Team', key: string, name: string, teamLeaderUid: string }>, approvedTags?: Array<{ __typename?: 'Tag', tagValue: string, tagId: string }> | null, settings?: { __typename?: 'OrganizationSettings', extension: { __typename?: 'OrganizationExtensionSettings', showScoreInput: boolean } } | null } | null };

export type GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables = Exact<{
  startAt: Scalars['Int']['input'];
  endAt: Scalars['Int']['input'];
  instanceId: Scalars['String']['input'];
  rubricsId: Array<Scalars['String']['input']> | Scalars['String']['input'];
  teamsId: Array<Scalars['String']['input']> | Scalars['String']['input'];
  reviewType?: InputMaybe<ReviewTypeFilterFirestore>;
  userId?: InputMaybe<Scalars['String']['input']>;
  acknowledgmentFilter?: InputMaybe<AcknowledgmentTypeFilters>;
}>;


export type GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery = { __typename?: 'Query', getPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestore: { __typename?: 'DashboardReviews', reviews: Array<{ __typename?: 'ReviewWithReviewerAndAssigneeData', reviewId: string, reviewStartedAt: number, reviewCompletedAt?: number | null, handleTime?: number | null, reviewerUUID: string, teamId: string, reviewURL: string, isAutofailed: boolean, assigneeUUID: string, rubricName: string, isAcknowledged: boolean, totalScore: number, tags?: Array<string> | null, assigneeData: { __typename?: 'ReviewUserData', name: string }, reviewerData: { __typename?: 'ReviewUserData', name: string, photoURL: string } }>, metadata?: { __typename?: 'DashboardAnalyticsMetadata', needFocus?: string | null, currentStrength?: string | null, completedReviewsCounter: number, averageTicketsScore: number, acknowledgedReviewsCounter: number } | null } };

export type GetPendingCalibrationsPerEvaluatorQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type GetPendingCalibrationsPerEvaluatorQuery = { __typename?: 'Query', getPendingCalibrationsPerEvaluator: Array<{ __typename?: 'Calibration', name: string, url: string, calibrationId: string }> };

export type GetRestrictedDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRestrictedDomainsQuery = { __typename?: 'Query', getRestrictedDomains: Array<string> };

export type GetRubricQueryVariables = Exact<{
  rubricId: Scalars['String']['input'];
}>;


export type GetRubricQuery = { __typename?: 'Query', getRubric: { __typename?: 'RubricV2', id: string, createdDate: number, instanceId: string, status: RubricsStatus, name: string, nameLowerCase: string, teamId: string, favorite: boolean, createdBy: string, categories: Array<{ __typename?: 'Category', id: string, requiresComments: boolean, orderIndex: number, measurementType: MeasurementType, weight: number, name: string, notApplicable: boolean, autoFailEnabled: boolean, questions: Array<{ __typename?: 'Question', id: string, name: string, weight: number, description: string, requiresComments: boolean, orderIndex: number }>, measurementOptions?: Array<{ __typename?: 'MeasurementOption', label: string, value: number }> | null }> } };

export type GetRubricsQueryVariables = Exact<{
  instanceId: Scalars['String']['input'];
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<RubricsStatus>;
  nameLowerCase?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRubricsQuery = { __typename?: 'Query', getRubrics: Array<{ __typename?: 'RubricV2', id: string, createdDate: number, instanceId: string, status: RubricsStatus, name: string, nameLowerCase: string, teamId: string, favorite: boolean, createdBy: string, categories: Array<{ __typename?: 'Category', id: string, requiresComments: boolean, orderIndex: number, measurementType: MeasurementType, weight: number, name: string, notApplicable: boolean, autoFailEnabled: boolean, questions: Array<{ __typename?: 'Question', id: string, name: string, weight: number, description: string, requiresComments: boolean, orderIndex: number }>, measurementOptions?: Array<{ __typename?: 'MeasurementOption', label: string, value: number }> | null }> }> };

export type GetRubricsStatsQueryVariables = Exact<{
  instanceId: Scalars['String']['input'];
  filterBy: FilterBy;
  status?: InputMaybe<RubricsStatus>;
}>;


export type GetRubricsStatsQuery = { __typename?: 'Query', getRubricsStats: Array<{ __typename?: 'RubricStats', id: string, createdDate: number, instanceId: string, status: RubricsStatus, name: string, nameLowerCase: string, teamId: string, favorite: boolean, createdBy: string, totalReviewCount: number, categories: Array<{ __typename?: 'Category', id: string, requiresComments: boolean, orderIndex: number, measurementType: MeasurementType, weight: number, name: string, notApplicable: boolean, autoFailEnabled: boolean, questions: Array<{ __typename?: 'Question', id: string, name: string, weight: number, description: string, requiresComments: boolean, orderIndex: number }> }>, creatorData?: { __typename?: 'CreatorData', displayName?: string | null, photoURL?: string | null } | null }> };

export type GetSubscriptionByInstanceIdQueryVariables = Exact<{
  instanceId: Scalars['String']['input'];
}>;


export type GetSubscriptionByInstanceIdQuery = { __typename?: 'Query', getSubscriptionByInstanceId: { __typename?: 'PartnerSubscription', customerId: string, customerName: string, instanceId: string, isTrialing: boolean, stripePlanId: string, trialEnd: number, trialStart: number, subscriptionId?: string | null } };

export type GetSubscriptionPlanByIdQueryVariables = Exact<{
  stripePlanId: Scalars['String']['input'];
}>;


export type GetSubscriptionPlanByIdQuery = { __typename?: 'Query', getSubscriptionPlanById: { __typename?: 'SubscriptionPlan', id?: string | null, name: string, price?: number | null, stripePlanId: string, permissions: { __typename?: 'SubscriptionPlanPermissions', advancedRubrics?: boolean | null, analytics?: boolean | null, expressSupport?: boolean | null, featureRequest?: boolean | null, maxUsers: number, reports?: boolean | null, subteams?: boolean | null, trialDays?: number | null } } };

export type GetTeamMembersQueryVariables = Exact<{
  instanceId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTeamMembersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'FirestoreUser', displayName?: string | null, roles: Array<FirestoreUserRole>, email: string, id: string, uid: string, teamId: string, status: FirestoreUserStatus, photoURL?: string | null }> };

export type GetUserOrgsQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetUserOrgsQuery = { __typename?: 'Query', userOrganizations: Array<{ __typename?: 'Organization', name: string, displayName?: string | null, tenantUrl?: string | null, instanceId: string }> };

export type GetUsersQueryVariables = Exact<{
  instanceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'FirestoreUser', firstName?: string | null, lastName?: string | null, roles: Array<FirestoreUserRole>, email: string, id: string, displayName?: string | null, uid: string, teamId: string }> };

export type GetWhiteListedDomainsQueryVariables = Exact<{
  instanceId: Scalars['String']['input'];
}>;


export type GetWhiteListedDomainsQuery = { __typename?: 'Query', getWhiteListedDomains: Array<string> };

export type GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables = Exact<{
  startAt: Scalars['Int']['input'];
  endAt: Scalars['Int']['input'];
  instanceId: Scalars['String']['input'];
  rubricsId: Array<Scalars['String']['input']> | Scalars['String']['input'];
  teamsId: Array<Scalars['String']['input']> | Scalars['String']['input'];
  reviewType?: InputMaybe<ReviewTypeFilterFirestore>;
  userId?: InputMaybe<Scalars['String']['input']>;
  acknowledgmentFilter?: InputMaybe<AcknowledgmentTypeFilters>;
}>;


export type GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery = { __typename?: 'Query', structuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestore: { __typename?: 'StructuredDashboardReviews', reviews: Array<{ __typename?: 'StructuredReviewWithReviewerAndAssigneeData', reviewId: string, reviewStartedAt: number, reviewCompletedAt?: number | null, handleTime?: number | null, reviewUpdatedAt?: number | null, reviewerUUID: string, teamId: string, reviewURL: string, assigneeUUID: string, rubricName: string, isAcknowledged: boolean, totalScore: number, tags?: Array<string> | null, assigneeData: { __typename?: 'ReviewUserData', name: string }, reviewerData: { __typename?: 'ReviewUserData', name: string, photoURL: string } }>, metadata?: { __typename?: 'DashboardAnalyticsMetadata', needFocus?: string | null, currentStrength?: string | null, completedReviewsCounter: number, averageTicketsScore: number, acknowledgedReviewsCounter: number } | null } };

export type GoalsQueryVariables = Exact<{
  instanceId: Scalars['String']['input'];
}>;


export type GoalsQuery = { __typename?: 'Query', goals: { __typename?: 'Goals', sample?: number | null, qaScore?: number | null, errorFreeRate?: number | null, criticalErrorRate?: number | null, instanceId: string } };

export type OrganizationByTenantQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
}>;


export type OrganizationByTenantQuery = { __typename?: 'Query', organizationByTenant?: { __typename?: 'PublicOrganization', id?: string | null } | null };

export type QueueConfigurationQueryVariables = Exact<{
  instanceId: Scalars['String']['input'];
}>;


export type QueueConfigurationQuery = { __typename?: 'Query', queueConfiguration: { __typename?: 'QueueConfiguration', instanceId?: string | null, dataConnected: boolean, frequency?: QueueFrequency | null, ticketAmount?: number | null, countTicketsBy?: QueueCountTicketsType | null, exclusions?: Array<string> | null, lastPullDateTime?: number | null, nextPullDateTime?: number | null } };

export type GetReviewWithCommentsQueryVariables = Exact<{
  instanceId: Scalars['String']['input'];
  reviewId: Scalars['String']['input'];
  reviewerUUID: Scalars['String']['input'];
}>;


export type GetReviewWithCommentsQuery = { __typename?: 'Query', getReviewWithComments: { __typename?: 'ReviewWithReviewerAndAssigneeData', reviewId: string, additionalFeedback: string, assigneeUUID: string, instanceId: string, isAcknowledged: boolean, isArchived: boolean, isAutofailed: boolean, isManuallyAssigned: boolean, isCommentAvailable: boolean, reviewAcknowledgedAt: number, reviewStartedAt: number, reviewCompletedAt?: number | null, handleTime?: number | null, reviewUpdatedAt?: number | null, reviewURL: string, reviewerUUID: string, rubricId: string, rubricName: string, status: ReviewStatus, tags?: Array<string> | null, teamId: string, totalScore: number, scoreByQuestion: Array<{ __typename?: 'ScoreByQuestion', awardedQuestionPoints: number, categoryId: string, isAutofailed: boolean, isRequiredComments: boolean, isReviewed: boolean, questionId: string, questionName: string, questionScore: number, totalQuestionPoints: number, createdAt?: number | null, updatedAt?: number | null, comment?: { __typename?: 'ReviewComment', categoryId: string, questionId: string, comment: string, createdAt?: number | null, updatedAt?: number | null } | null }>, scoreByCategory: Array<{ __typename?: 'ScoreByCategory', awardedCategoryPoints: number, binaryLabel?: string | null, categoryId: string, categoryName: string, categoryScore: number, isRequiredComments: boolean, measurementType: MeasurementType, orderIndex: number, totalCategoryPoints: number, measurementOptions?: Array<{ __typename?: 'MeasurementOption', label: string, value: number }> | null }>, assigneeData: { __typename?: 'ReviewUserData', uid: string, email: string, name: string, photoURL: string }, reviewerData: { __typename?: 'ReviewUserData', uid: string, email: string, name: string, photoURL: string } } };

export type SendRemainderForCalibrationRequestQueryVariables = Exact<{
  evaluatorName: Scalars['String']['input'];
  evaluatorEmail: Scalars['String']['input'];
  calibratorName: Scalars['String']['input'];
  calibrationName: Scalars['String']['input'];
  calibrationStartedAt: Scalars['Int']['input'];
  calibratorPhotoURL: Scalars['String']['input'];
  calibrationId: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
}>;


export type SendRemainderForCalibrationRequestQuery = { __typename?: 'Query', sendRemainderForCalibrationRequest: { __typename?: 'Message', code: number, message: string } };

export type GetTeamRosterDetailsQueryVariables = Exact<{
  instanceId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
  teamLeaderId: Scalars['String']['input'];
}>;


export type GetTeamRosterDetailsQuery = { __typename?: 'Query', getTeamRosterDetails: Array<{ __typename?: 'TeamRoster', uid: string, email: string, totalReviewsGiven: number, totalReviewsReceived: number, firstName?: string | null, lastName?: string | null, displayName?: string | null, photoURL?: string | null, instanceId: string, teamId: string, roles: Array<FirestoreUserRole> }> };

export type TicketQueuesQueryVariables = Exact<{
  filters: GetTicketQueuesInput;
}>;


export type TicketQueuesQuery = { __typename?: 'Query', ticketQueues: Array<{ __typename?: 'TicketQueue', ticketQueueId: string, instanceId: string, ticketId: string, ticketURL: string, ticketChannel?: string | null, assigneeEmail: string, assigneeName: string, ticketStarted: number, ticketClosed?: number | null, totalHandleTime?: number | null, reviewed: boolean, discarded: boolean, CRM: string, userId?: string | null, queueBatchInfoId: string }> };


export const AcknowledgeAReviewAndSendNotificationsDocument = gql`
    mutation acknowledgeAReviewAndSendNotifications($instanceId: String!, $teamId: String!, $reviewerUUID: String!, $assigneeData: GetAssigneeDataForNotificationInput!, $reviewId: String!, $teamLeaderUid: String!, $userEmail: String!) {
  acknowledgeAReviewAndSendNotifications(
    input: {instanceId: $instanceId, teamId: $teamId, reviewerUUID: $reviewerUUID, assigneeData: $assigneeData, reviewId: $reviewId, teamLeaderUid: $teamLeaderUid, userEmail: $userEmail}
  ) {
    code
    message
  }
}
    `;
export type AcknowledgeAReviewAndSendNotificationsMutationFn = Apollo.MutationFunction<AcknowledgeAReviewAndSendNotificationsMutation, AcknowledgeAReviewAndSendNotificationsMutationVariables>;

/**
 * __useAcknowledgeAReviewAndSendNotificationsMutation__
 *
 * To run a mutation, you first call `useAcknowledgeAReviewAndSendNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeAReviewAndSendNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeAReviewAndSendNotificationsMutation, { data, loading, error }] = useAcknowledgeAReviewAndSendNotificationsMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      teamId: // value for 'teamId'
 *      reviewerUUID: // value for 'reviewerUUID'
 *      assigneeData: // value for 'assigneeData'
 *      reviewId: // value for 'reviewId'
 *      teamLeaderUid: // value for 'teamLeaderUid'
 *      userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function useAcknowledgeAReviewAndSendNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeAReviewAndSendNotificationsMutation, AcknowledgeAReviewAndSendNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeAReviewAndSendNotificationsMutation, AcknowledgeAReviewAndSendNotificationsMutationVariables>(AcknowledgeAReviewAndSendNotificationsDocument, options);
      }
export type AcknowledgeAReviewAndSendNotificationsMutationHookResult = ReturnType<typeof useAcknowledgeAReviewAndSendNotificationsMutation>;
export type AcknowledgeAReviewAndSendNotificationsMutationResult = Apollo.MutationResult<AcknowledgeAReviewAndSendNotificationsMutation>;
export type AcknowledgeAReviewAndSendNotificationsMutationOptions = Apollo.BaseMutationOptions<AcknowledgeAReviewAndSendNotificationsMutation, AcknowledgeAReviewAndSendNotificationsMutationVariables>;
export const AddEvaluatorsDocument = gql`
    mutation addEvaluators($evaluators: [AddEvaluatorInput!]!, $rubricId: String!, $calibrationId: String!, $instanceId: String!, $calibratorData: CalibratorData!, $calibrationName: String!, $calibrationStartedAt: Int!) {
  addEvaluators(
    evaluators: $evaluators
    rubricId: $rubricId
    calibrationId: $calibrationId
    instanceId: $instanceId
    calibratorData: $calibratorData
    calibrationName: $calibrationName
    calibrationStartedAt: $calibrationStartedAt
  ) {
    code
    message
  }
}
    `;
export type AddEvaluatorsMutationFn = Apollo.MutationFunction<AddEvaluatorsMutation, AddEvaluatorsMutationVariables>;

/**
 * __useAddEvaluatorsMutation__
 *
 * To run a mutation, you first call `useAddEvaluatorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEvaluatorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEvaluatorsMutation, { data, loading, error }] = useAddEvaluatorsMutation({
 *   variables: {
 *      evaluators: // value for 'evaluators'
 *      rubricId: // value for 'rubricId'
 *      calibrationId: // value for 'calibrationId'
 *      instanceId: // value for 'instanceId'
 *      calibratorData: // value for 'calibratorData'
 *      calibrationName: // value for 'calibrationName'
 *      calibrationStartedAt: // value for 'calibrationStartedAt'
 *   },
 * });
 */
export function useAddEvaluatorsMutation(baseOptions?: Apollo.MutationHookOptions<AddEvaluatorsMutation, AddEvaluatorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEvaluatorsMutation, AddEvaluatorsMutationVariables>(AddEvaluatorsDocument, options);
      }
export type AddEvaluatorsMutationHookResult = ReturnType<typeof useAddEvaluatorsMutation>;
export type AddEvaluatorsMutationResult = Apollo.MutationResult<AddEvaluatorsMutation>;
export type AddEvaluatorsMutationOptions = Apollo.BaseMutationOptions<AddEvaluatorsMutation, AddEvaluatorsMutationVariables>;
export const AddOrganizationTagDocument = gql`
    mutation addOrganizationTag($tagInput: OrganizationTagInput!) {
  addOrganizationTag(tagInput: $tagInput)
}
    `;
export type AddOrganizationTagMutationFn = Apollo.MutationFunction<AddOrganizationTagMutation, AddOrganizationTagMutationVariables>;

/**
 * __useAddOrganizationTagMutation__
 *
 * To run a mutation, you first call `useAddOrganizationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationTagMutation, { data, loading, error }] = useAddOrganizationTagMutation({
 *   variables: {
 *      tagInput: // value for 'tagInput'
 *   },
 * });
 */
export function useAddOrganizationTagMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganizationTagMutation, AddOrganizationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganizationTagMutation, AddOrganizationTagMutationVariables>(AddOrganizationTagDocument, options);
      }
export type AddOrganizationTagMutationHookResult = ReturnType<typeof useAddOrganizationTagMutation>;
export type AddOrganizationTagMutationResult = Apollo.MutationResult<AddOrganizationTagMutation>;
export type AddOrganizationTagMutationOptions = Apollo.BaseMutationOptions<AddOrganizationTagMutation, AddOrganizationTagMutationVariables>;
export const ArchiveUserDocument = gql`
    mutation ArchiveUser($userId: String!) {
  archiveUser(userId: $userId) {
    code
    key
    message
  }
}
    `;
export type ArchiveUserMutationFn = Apollo.MutationFunction<ArchiveUserMutation, ArchiveUserMutationVariables>;

/**
 * __useArchiveUserMutation__
 *
 * To run a mutation, you first call `useArchiveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveUserMutation, { data, loading, error }] = useArchiveUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useArchiveUserMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveUserMutation, ArchiveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveUserMutation, ArchiveUserMutationVariables>(ArchiveUserDocument, options);
      }
export type ArchiveUserMutationHookResult = ReturnType<typeof useArchiveUserMutation>;
export type ArchiveUserMutationResult = Apollo.MutationResult<ArchiveUserMutation>;
export type ArchiveUserMutationOptions = Apollo.BaseMutationOptions<ArchiveUserMutation, ArchiveUserMutationVariables>;
export const ArchiveCalibrationsByRubricIdDocument = gql`
    mutation archiveCalibrationsByRubricId($rubricId: String!) {
  archiveCalibrationsByRubricId(rubricId: $rubricId) {
    code
    message
  }
}
    `;
export type ArchiveCalibrationsByRubricIdMutationFn = Apollo.MutationFunction<ArchiveCalibrationsByRubricIdMutation, ArchiveCalibrationsByRubricIdMutationVariables>;

/**
 * __useArchiveCalibrationsByRubricIdMutation__
 *
 * To run a mutation, you first call `useArchiveCalibrationsByRubricIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCalibrationsByRubricIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCalibrationsByRubricIdMutation, { data, loading, error }] = useArchiveCalibrationsByRubricIdMutation({
 *   variables: {
 *      rubricId: // value for 'rubricId'
 *   },
 * });
 */
export function useArchiveCalibrationsByRubricIdMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCalibrationsByRubricIdMutation, ArchiveCalibrationsByRubricIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCalibrationsByRubricIdMutation, ArchiveCalibrationsByRubricIdMutationVariables>(ArchiveCalibrationsByRubricIdDocument, options);
      }
export type ArchiveCalibrationsByRubricIdMutationHookResult = ReturnType<typeof useArchiveCalibrationsByRubricIdMutation>;
export type ArchiveCalibrationsByRubricIdMutationResult = Apollo.MutationResult<ArchiveCalibrationsByRubricIdMutation>;
export type ArchiveCalibrationsByRubricIdMutationOptions = Apollo.BaseMutationOptions<ArchiveCalibrationsByRubricIdMutation, ArchiveCalibrationsByRubricIdMutationVariables>;
export const ArchiveReviewsDocument = gql`
    mutation archiveReviews($rubricId: String!, $instanceId: String!, $userEmail: String!) {
  archiveReviews(
    input: {instanceId: $instanceId, rubricId: $rubricId, userEmail: $userEmail}
  ) {
    code
    message
  }
}
    `;
export type ArchiveReviewsMutationFn = Apollo.MutationFunction<ArchiveReviewsMutation, ArchiveReviewsMutationVariables>;

/**
 * __useArchiveReviewsMutation__
 *
 * To run a mutation, you first call `useArchiveReviewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveReviewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveReviewsMutation, { data, loading, error }] = useArchiveReviewsMutation({
 *   variables: {
 *      rubricId: // value for 'rubricId'
 *      instanceId: // value for 'instanceId'
 *      userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function useArchiveReviewsMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveReviewsMutation, ArchiveReviewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveReviewsMutation, ArchiveReviewsMutationVariables>(ArchiveReviewsDocument, options);
      }
export type ArchiveReviewsMutationHookResult = ReturnType<typeof useArchiveReviewsMutation>;
export type ArchiveReviewsMutationResult = Apollo.MutationResult<ArchiveReviewsMutation>;
export type ArchiveReviewsMutationOptions = Apollo.BaseMutationOptions<ArchiveReviewsMutation, ArchiveReviewsMutationVariables>;
export const CalibrateScoresDocument = gql`
    mutation calibrateScores($calibrationId: String!) {
  calibrateScores(calibrationId: $calibrationId) {
    code
    message
  }
}
    `;
export type CalibrateScoresMutationFn = Apollo.MutationFunction<CalibrateScoresMutation, CalibrateScoresMutationVariables>;

/**
 * __useCalibrateScoresMutation__
 *
 * To run a mutation, you first call `useCalibrateScoresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalibrateScoresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calibrateScoresMutation, { data, loading, error }] = useCalibrateScoresMutation({
 *   variables: {
 *      calibrationId: // value for 'calibrationId'
 *   },
 * });
 */
export function useCalibrateScoresMutation(baseOptions?: Apollo.MutationHookOptions<CalibrateScoresMutation, CalibrateScoresMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalibrateScoresMutation, CalibrateScoresMutationVariables>(CalibrateScoresDocument, options);
      }
export type CalibrateScoresMutationHookResult = ReturnType<typeof useCalibrateScoresMutation>;
export type CalibrateScoresMutationResult = Apollo.MutationResult<CalibrateScoresMutation>;
export type CalibrateScoresMutationOptions = Apollo.BaseMutationOptions<CalibrateScoresMutation, CalibrateScoresMutationVariables>;
export const CreateCalibrationDocument = gql`
    mutation createCalibration($newCalibration: CalibrationInput!) {
  createCalibration(input: $newCalibration) {
    code
    message
    key
  }
}
    `;
export type CreateCalibrationMutationFn = Apollo.MutationFunction<CreateCalibrationMutation, CreateCalibrationMutationVariables>;

/**
 * __useCreateCalibrationMutation__
 *
 * To run a mutation, you first call `useCreateCalibrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalibrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalibrationMutation, { data, loading, error }] = useCreateCalibrationMutation({
 *   variables: {
 *      newCalibration: // value for 'newCalibration'
 *   },
 * });
 */
export function useCreateCalibrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCalibrationMutation, CreateCalibrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCalibrationMutation, CreateCalibrationMutationVariables>(CreateCalibrationDocument, options);
      }
export type CreateCalibrationMutationHookResult = ReturnType<typeof useCreateCalibrationMutation>;
export type CreateCalibrationMutationResult = Apollo.MutationResult<CreateCalibrationMutation>;
export type CreateCalibrationMutationOptions = Apollo.BaseMutationOptions<CreateCalibrationMutation, CreateCalibrationMutationVariables>;
export const CheckDuplicateRubricDocument = gql`
    mutation CheckDuplicateRubric($checkDuplicateRubricInput: CheckDuplicateRubricInput!) {
  checkDuplicateRubric(checkDuplicateRubricInput: $checkDuplicateRubricInput)
}
    `;
export type CheckDuplicateRubricMutationFn = Apollo.MutationFunction<CheckDuplicateRubricMutation, CheckDuplicateRubricMutationVariables>;

/**
 * __useCheckDuplicateRubricMutation__
 *
 * To run a mutation, you first call `useCheckDuplicateRubricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckDuplicateRubricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkDuplicateRubricMutation, { data, loading, error }] = useCheckDuplicateRubricMutation({
 *   variables: {
 *      checkDuplicateRubricInput: // value for 'checkDuplicateRubricInput'
 *   },
 * });
 */
export function useCheckDuplicateRubricMutation(baseOptions?: Apollo.MutationHookOptions<CheckDuplicateRubricMutation, CheckDuplicateRubricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckDuplicateRubricMutation, CheckDuplicateRubricMutationVariables>(CheckDuplicateRubricDocument, options);
      }
export type CheckDuplicateRubricMutationHookResult = ReturnType<typeof useCheckDuplicateRubricMutation>;
export type CheckDuplicateRubricMutationResult = Apollo.MutationResult<CheckDuplicateRubricMutation>;
export type CheckDuplicateRubricMutationOptions = Apollo.BaseMutationOptions<CheckDuplicateRubricMutation, CheckDuplicateRubricMutationVariables>;
export const CreateConnectionDocument = gql`
    mutation createConnection($createConnectionInput: CreateConnectionInput!) {
  createConnection(input: $createConnectionInput) {
    active
    configuration {
      auditData
      eventData
      ticketData
    }
    connectorInstanceId
    credentialId
    initTimestamp
    metadata
    organizationId
    streams
    subdomain
    system
  }
}
    `;
export type CreateConnectionMutationFn = Apollo.MutationFunction<CreateConnectionMutation, CreateConnectionMutationVariables>;

/**
 * __useCreateConnectionMutation__
 *
 * To run a mutation, you first call `useCreateConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectionMutation, { data, loading, error }] = useCreateConnectionMutation({
 *   variables: {
 *      createConnectionInput: // value for 'createConnectionInput'
 *   },
 * });
 */
export function useCreateConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateConnectionMutation, CreateConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConnectionMutation, CreateConnectionMutationVariables>(CreateConnectionDocument, options);
      }
export type CreateConnectionMutationHookResult = ReturnType<typeof useCreateConnectionMutation>;
export type CreateConnectionMutationResult = Apollo.MutationResult<CreateConnectionMutation>;
export type CreateConnectionMutationOptions = Apollo.BaseMutationOptions<CreateConnectionMutation, CreateConnectionMutationVariables>;
export const CreateGoalsDocument = gql`
    mutation CreateGoals($createGoalsInput: CreateGoalsInput!) {
  createGoals(createGoalsInput: $createGoalsInput) {
    instanceId
    sample
    qaScore
    errorFreeRate
    criticalErrorRate
  }
}
    `;
export type CreateGoalsMutationFn = Apollo.MutationFunction<CreateGoalsMutation, CreateGoalsMutationVariables>;

/**
 * __useCreateGoalsMutation__
 *
 * To run a mutation, you first call `useCreateGoalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoalsMutation, { data, loading, error }] = useCreateGoalsMutation({
 *   variables: {
 *      createGoalsInput: // value for 'createGoalsInput'
 *   },
 * });
 */
export function useCreateGoalsMutation(baseOptions?: Apollo.MutationHookOptions<CreateGoalsMutation, CreateGoalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGoalsMutation, CreateGoalsMutationVariables>(CreateGoalsDocument, options);
      }
export type CreateGoalsMutationHookResult = ReturnType<typeof useCreateGoalsMutation>;
export type CreateGoalsMutationResult = Apollo.MutationResult<CreateGoalsMutation>;
export type CreateGoalsMutationOptions = Apollo.BaseMutationOptions<CreateGoalsMutation, CreateGoalsMutationVariables>;
export const CreateOrganizationTeamDocument = gql`
    mutation createOrganizationTeam($name: String!, $teamLeaderUid: String!, $instanceId: String!) {
  createOrganizationTeam(
    team: {name: $name, teamLeaderUid: $teamLeaderUid, instanceId: $instanceId}
  ) {
    name
    teamLeaderUid
    teamId
  }
}
    `;
export type CreateOrganizationTeamMutationFn = Apollo.MutationFunction<CreateOrganizationTeamMutation, CreateOrganizationTeamMutationVariables>;

/**
 * __useCreateOrganizationTeamMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationTeamMutation, { data, loading, error }] = useCreateOrganizationTeamMutation({
 *   variables: {
 *      name: // value for 'name'
 *      teamLeaderUid: // value for 'teamLeaderUid'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useCreateOrganizationTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationTeamMutation, CreateOrganizationTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationTeamMutation, CreateOrganizationTeamMutationVariables>(CreateOrganizationTeamDocument, options);
      }
export type CreateOrganizationTeamMutationHookResult = ReturnType<typeof useCreateOrganizationTeamMutation>;
export type CreateOrganizationTeamMutationResult = Apollo.MutationResult<CreateOrganizationTeamMutation>;
export type CreateOrganizationTeamMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationTeamMutation, CreateOrganizationTeamMutationVariables>;
export const CreateQueueConfigurationDocument = gql`
    mutation CreateQueueConfiguration($createQueueConfigurationInput: CreateQueueConfigurationInput!) {
  createQueueConfiguration(
    createQueueConfigurationInput: $createQueueConfigurationInput
  ) {
    instanceId
    dataConnected
    frequency
    ticketAmount
    countTicketsBy
    exclusions
    lastPullDateTime
    nextPullDateTime
  }
}
    `;
export type CreateQueueConfigurationMutationFn = Apollo.MutationFunction<CreateQueueConfigurationMutation, CreateQueueConfigurationMutationVariables>;

/**
 * __useCreateQueueConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateQueueConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQueueConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQueueConfigurationMutation, { data, loading, error }] = useCreateQueueConfigurationMutation({
 *   variables: {
 *      createQueueConfigurationInput: // value for 'createQueueConfigurationInput'
 *   },
 * });
 */
export function useCreateQueueConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<CreateQueueConfigurationMutation, CreateQueueConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQueueConfigurationMutation, CreateQueueConfigurationMutationVariables>(CreateQueueConfigurationDocument, options);
      }
export type CreateQueueConfigurationMutationHookResult = ReturnType<typeof useCreateQueueConfigurationMutation>;
export type CreateQueueConfigurationMutationResult = Apollo.MutationResult<CreateQueueConfigurationMutation>;
export type CreateQueueConfigurationMutationOptions = Apollo.BaseMutationOptions<CreateQueueConfigurationMutation, CreateQueueConfigurationMutationVariables>;
export const CreateRubricV2Document = gql`
    mutation CreateRubricV2($createRubricInput: CreateRubricV2Input!) {
  createRubricV2(createRubricInput: $createRubricInput) {
    id
    createdDate
    instanceId
    status
    name
    nameLowerCase
    categories {
      id
      requiresComments
      orderIndex
      measurementType
      weight
      name
      questions {
        id
        name
        weight
        description
        requiresComments
        orderIndex
      }
      measurementOptions {
        label
        value
      }
      notApplicable
      autoFailEnabled
    }
    teamId
    favorite
    createdBy
  }
}
    `;
export type CreateRubricV2MutationFn = Apollo.MutationFunction<CreateRubricV2Mutation, CreateRubricV2MutationVariables>;

/**
 * __useCreateRubricV2Mutation__
 *
 * To run a mutation, you first call `useCreateRubricV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRubricV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRubricV2Mutation, { data, loading, error }] = useCreateRubricV2Mutation({
 *   variables: {
 *      createRubricInput: // value for 'createRubricInput'
 *   },
 * });
 */
export function useCreateRubricV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateRubricV2Mutation, CreateRubricV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRubricV2Mutation, CreateRubricV2MutationVariables>(CreateRubricV2Document, options);
      }
export type CreateRubricV2MutationHookResult = ReturnType<typeof useCreateRubricV2Mutation>;
export type CreateRubricV2MutationResult = Apollo.MutationResult<CreateRubricV2Mutation>;
export type CreateRubricV2MutationOptions = Apollo.BaseMutationOptions<CreateRubricV2Mutation, CreateRubricV2MutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: FirestoreUserInput!) {
  firestoreCreateUser(input: $input) {
    code
    message
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const AddWhiteListedDomainsDocument = gql`
    mutation AddWhiteListedDomains($input: AddWhiteListedDomainsInput!) {
  addWhiteListedDomains(input: $input) {
    code
    message
  }
}
    `;
export type AddWhiteListedDomainsMutationFn = Apollo.MutationFunction<AddWhiteListedDomainsMutation, AddWhiteListedDomainsMutationVariables>;

/**
 * __useAddWhiteListedDomainsMutation__
 *
 * To run a mutation, you first call `useAddWhiteListedDomainsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWhiteListedDomainsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWhiteListedDomainsMutation, { data, loading, error }] = useAddWhiteListedDomainsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddWhiteListedDomainsMutation(baseOptions?: Apollo.MutationHookOptions<AddWhiteListedDomainsMutation, AddWhiteListedDomainsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWhiteListedDomainsMutation, AddWhiteListedDomainsMutationVariables>(AddWhiteListedDomainsDocument, options);
      }
export type AddWhiteListedDomainsMutationHookResult = ReturnType<typeof useAddWhiteListedDomainsMutation>;
export type AddWhiteListedDomainsMutationResult = Apollo.MutationResult<AddWhiteListedDomainsMutation>;
export type AddWhiteListedDomainsMutationOptions = Apollo.BaseMutationOptions<AddWhiteListedDomainsMutation, AddWhiteListedDomainsMutationVariables>;
export const DeactivateConnectionDocument = gql`
    mutation deactivateConnection($organizationId: String!) {
  deactivateConnection(organizationId: $organizationId) {
    active
  }
}
    `;
export type DeactivateConnectionMutationFn = Apollo.MutationFunction<DeactivateConnectionMutation, DeactivateConnectionMutationVariables>;

/**
 * __useDeactivateConnectionMutation__
 *
 * To run a mutation, you first call `useDeactivateConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateConnectionMutation, { data, loading, error }] = useDeactivateConnectionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeactivateConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateConnectionMutation, DeactivateConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateConnectionMutation, DeactivateConnectionMutationVariables>(DeactivateConnectionDocument, options);
      }
export type DeactivateConnectionMutationHookResult = ReturnType<typeof useDeactivateConnectionMutation>;
export type DeactivateConnectionMutationResult = Apollo.MutationResult<DeactivateConnectionMutation>;
export type DeactivateConnectionMutationOptions = Apollo.BaseMutationOptions<DeactivateConnectionMutation, DeactivateConnectionMutationVariables>;
export const DeleteEmailInviteDocument = gql`
    mutation DeleteEmailInvite($input: SelectEmailInviteInput!) {
  deleteEmailInvite(input: $input) {
    id
    organizationId
    organizationAuthId
    email
    inviterId
    createdAt
    expiresAt
    role
    status
  }
}
    `;
export type DeleteEmailInviteMutationFn = Apollo.MutationFunction<DeleteEmailInviteMutation, DeleteEmailInviteMutationVariables>;

/**
 * __useDeleteEmailInviteMutation__
 *
 * To run a mutation, you first call `useDeleteEmailInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailInviteMutation, { data, loading, error }] = useDeleteEmailInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEmailInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailInviteMutation, DeleteEmailInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailInviteMutation, DeleteEmailInviteMutationVariables>(DeleteEmailInviteDocument, options);
      }
export type DeleteEmailInviteMutationHookResult = ReturnType<typeof useDeleteEmailInviteMutation>;
export type DeleteEmailInviteMutationResult = Apollo.MutationResult<DeleteEmailInviteMutation>;
export type DeleteEmailInviteMutationOptions = Apollo.BaseMutationOptions<DeleteEmailInviteMutation, DeleteEmailInviteMutationVariables>;
export const DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamDocument = gql`
    mutation deleteOrgTeamAndMoveReviewsAndUsersToTheNewTeam($usersIdList: [String!]!, $oldTeamId: String!, $newTeamId: String!, $instanceId: String!) {
  deleteOrgTeamAndMoveReviewsAndUsersToTheNewTeam(
    input: {usersIdList: $usersIdList, oldTeamId: $oldTeamId, newTeamId: $newTeamId, instanceId: $instanceId}
  ) {
    code
    message
  }
}
    `;
export type DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutationFn = Apollo.MutationFunction<DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutation, DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutationVariables>;

/**
 * __useDeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutation__
 *
 * To run a mutation, you first call `useDeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutation, { data, loading, error }] = useDeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutation({
 *   variables: {
 *      usersIdList: // value for 'usersIdList'
 *      oldTeamId: // value for 'oldTeamId'
 *      newTeamId: // value for 'newTeamId'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useDeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutation, DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutation, DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutationVariables>(DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamDocument, options);
      }
export type DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutationHookResult = ReturnType<typeof useDeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutation>;
export type DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutationResult = Apollo.MutationResult<DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutation>;
export type DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutationOptions = Apollo.BaseMutationOptions<DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutation, DeleteOrgTeamAndMoveReviewsAndUsersToTheNewTeamMutationVariables>;
export const DuplicateRubricDocument = gql`
    mutation DuplicateRubric($rubricId: String!) {
  duplicateRubric(rubricId: $rubricId) {
    id
    createdDate
    instanceId
    status
    name
    nameLowerCase
    categories {
      id
      requiresComments
      orderIndex
      measurementType
      weight
      name
      questions {
        id
        name
        weight
        description
        requiresComments
        orderIndex
      }
      notApplicable
      autoFailEnabled
    }
    teamId
    favorite
    createdBy
  }
}
    `;
export type DuplicateRubricMutationFn = Apollo.MutationFunction<DuplicateRubricMutation, DuplicateRubricMutationVariables>;

/**
 * __useDuplicateRubricMutation__
 *
 * To run a mutation, you first call `useDuplicateRubricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateRubricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateRubricMutation, { data, loading, error }] = useDuplicateRubricMutation({
 *   variables: {
 *      rubricId: // value for 'rubricId'
 *   },
 * });
 */
export function useDuplicateRubricMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateRubricMutation, DuplicateRubricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateRubricMutation, DuplicateRubricMutationVariables>(DuplicateRubricDocument, options);
      }
export type DuplicateRubricMutationHookResult = ReturnType<typeof useDuplicateRubricMutation>;
export type DuplicateRubricMutationResult = Apollo.MutationResult<DuplicateRubricMutation>;
export type DuplicateRubricMutationOptions = Apollo.BaseMutationOptions<DuplicateRubricMutation, DuplicateRubricMutationVariables>;
export const CreateCalibrationCsvDocument = gql`
    query createCalibrationCSV($calibrationId: String!) {
  createCalibrationCSV(calibrationId: $calibrationId) {
    data {
      questions {
        questionId
        scoreGiven
        categoryId
      }
      assigneeName
      startDate
      endDate
      individualAlignmentScore
      rubricName
      isAlignmentToTheAnswerKeyRecord
    }
    allOrderedQuestionsFromOriginalRubric {
      categoryId
      measurementType
      questionId
      description
      id
      name
      orderIndex
      requiresComments
      weight
    }
    headers {
      label
      key
      access
    }
    filename
  }
}
    `;

/**
 * __useCreateCalibrationCsvQuery__
 *
 * To run a query within a React component, call `useCreateCalibrationCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateCalibrationCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateCalibrationCsvQuery({
 *   variables: {
 *      calibrationId: // value for 'calibrationId'
 *   },
 * });
 */
export function useCreateCalibrationCsvQuery(baseOptions: Apollo.QueryHookOptions<CreateCalibrationCsvQuery, CreateCalibrationCsvQueryVariables> & ({ variables: CreateCalibrationCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateCalibrationCsvQuery, CreateCalibrationCsvQueryVariables>(CreateCalibrationCsvDocument, options);
      }
export function useCreateCalibrationCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateCalibrationCsvQuery, CreateCalibrationCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateCalibrationCsvQuery, CreateCalibrationCsvQueryVariables>(CreateCalibrationCsvDocument, options);
        }
export function useCreateCalibrationCsvSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateCalibrationCsvQuery, CreateCalibrationCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateCalibrationCsvQuery, CreateCalibrationCsvQueryVariables>(CreateCalibrationCsvDocument, options);
        }
export type CreateCalibrationCsvQueryHookResult = ReturnType<typeof useCreateCalibrationCsvQuery>;
export type CreateCalibrationCsvLazyQueryHookResult = ReturnType<typeof useCreateCalibrationCsvLazyQuery>;
export type CreateCalibrationCsvSuspenseQueryHookResult = ReturnType<typeof useCreateCalibrationCsvSuspenseQuery>;
export type CreateCalibrationCsvQueryResult = Apollo.QueryResult<CreateCalibrationCsvQuery, CreateCalibrationCsvQueryVariables>;
export const ModifyOrganizationTeamDocument = gql`
    mutation modifyOrganizationTeam($teamId: String!, $teamName: String, $teamLeaderUid: String, $instanceId: String!) {
  modifyOrganizationTeam(
    input: {teamId: $teamId, teamName: $teamName, teamLeaderUid: $teamLeaderUid, instanceId: $instanceId}
  ) {
    teamId
  }
}
    `;
export type ModifyOrganizationTeamMutationFn = Apollo.MutationFunction<ModifyOrganizationTeamMutation, ModifyOrganizationTeamMutationVariables>;

/**
 * __useModifyOrganizationTeamMutation__
 *
 * To run a mutation, you first call `useModifyOrganizationTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyOrganizationTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyOrganizationTeamMutation, { data, loading, error }] = useModifyOrganizationTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      teamName: // value for 'teamName'
 *      teamLeaderUid: // value for 'teamLeaderUid'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useModifyOrganizationTeamMutation(baseOptions?: Apollo.MutationHookOptions<ModifyOrganizationTeamMutation, ModifyOrganizationTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyOrganizationTeamMutation, ModifyOrganizationTeamMutationVariables>(ModifyOrganizationTeamDocument, options);
      }
export type ModifyOrganizationTeamMutationHookResult = ReturnType<typeof useModifyOrganizationTeamMutation>;
export type ModifyOrganizationTeamMutationResult = Apollo.MutationResult<ModifyOrganizationTeamMutation>;
export type ModifyOrganizationTeamMutationOptions = Apollo.BaseMutationOptions<ModifyOrganizationTeamMutation, ModifyOrganizationTeamMutationVariables>;
export const MoveOrganizationUsersToAnotherTeamDocument = gql`
    mutation moveOrganizationUsersToAnotherTeam($usersIdList: [String!]!, $oldTeamId: String!, $newTeamId: String!, $instanceId: String!) {
  moveOrganizationUsersToAnotherTeam(
    input: {usersIdList: $usersIdList, oldTeamId: $oldTeamId, newTeamId: $newTeamId, instanceId: $instanceId}
  ) {
    code
    message
  }
}
    `;
export type MoveOrganizationUsersToAnotherTeamMutationFn = Apollo.MutationFunction<MoveOrganizationUsersToAnotherTeamMutation, MoveOrganizationUsersToAnotherTeamMutationVariables>;

/**
 * __useMoveOrganizationUsersToAnotherTeamMutation__
 *
 * To run a mutation, you first call `useMoveOrganizationUsersToAnotherTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveOrganizationUsersToAnotherTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveOrganizationUsersToAnotherTeamMutation, { data, loading, error }] = useMoveOrganizationUsersToAnotherTeamMutation({
 *   variables: {
 *      usersIdList: // value for 'usersIdList'
 *      oldTeamId: // value for 'oldTeamId'
 *      newTeamId: // value for 'newTeamId'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useMoveOrganizationUsersToAnotherTeamMutation(baseOptions?: Apollo.MutationHookOptions<MoveOrganizationUsersToAnotherTeamMutation, MoveOrganizationUsersToAnotherTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveOrganizationUsersToAnotherTeamMutation, MoveOrganizationUsersToAnotherTeamMutationVariables>(MoveOrganizationUsersToAnotherTeamDocument, options);
      }
export type MoveOrganizationUsersToAnotherTeamMutationHookResult = ReturnType<typeof useMoveOrganizationUsersToAnotherTeamMutation>;
export type MoveOrganizationUsersToAnotherTeamMutationResult = Apollo.MutationResult<MoveOrganizationUsersToAnotherTeamMutation>;
export type MoveOrganizationUsersToAnotherTeamMutationOptions = Apollo.BaseMutationOptions<MoveOrganizationUsersToAnotherTeamMutation, MoveOrganizationUsersToAnotherTeamMutationVariables>;
export const RemoveAllOrganizationTagsDocument = gql`
    mutation removeAllOrganizationTags($orgName: String!) {
  removeAllOrganizationTags(orgName: $orgName) {
    code
    message
  }
}
    `;
export type RemoveAllOrganizationTagsMutationFn = Apollo.MutationFunction<RemoveAllOrganizationTagsMutation, RemoveAllOrganizationTagsMutationVariables>;

/**
 * __useRemoveAllOrganizationTagsMutation__
 *
 * To run a mutation, you first call `useRemoveAllOrganizationTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllOrganizationTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllOrganizationTagsMutation, { data, loading, error }] = useRemoveAllOrganizationTagsMutation({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useRemoveAllOrganizationTagsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAllOrganizationTagsMutation, RemoveAllOrganizationTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAllOrganizationTagsMutation, RemoveAllOrganizationTagsMutationVariables>(RemoveAllOrganizationTagsDocument, options);
      }
export type RemoveAllOrganizationTagsMutationHookResult = ReturnType<typeof useRemoveAllOrganizationTagsMutation>;
export type RemoveAllOrganizationTagsMutationResult = Apollo.MutationResult<RemoveAllOrganizationTagsMutation>;
export type RemoveAllOrganizationTagsMutationOptions = Apollo.BaseMutationOptions<RemoveAllOrganizationTagsMutation, RemoveAllOrganizationTagsMutationVariables>;
export const RemoveCalibrationDocument = gql`
    mutation removeCalibration($calibrationId: String!, $notifyEvaluators: Boolean!) {
  removeCalibration(
    calibrationId: $calibrationId
    notifyEvaluators: $notifyEvaluators
  ) {
    code
    message
  }
}
    `;
export type RemoveCalibrationMutationFn = Apollo.MutationFunction<RemoveCalibrationMutation, RemoveCalibrationMutationVariables>;

/**
 * __useRemoveCalibrationMutation__
 *
 * To run a mutation, you first call `useRemoveCalibrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCalibrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCalibrationMutation, { data, loading, error }] = useRemoveCalibrationMutation({
 *   variables: {
 *      calibrationId: // value for 'calibrationId'
 *      notifyEvaluators: // value for 'notifyEvaluators'
 *   },
 * });
 */
export function useRemoveCalibrationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCalibrationMutation, RemoveCalibrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCalibrationMutation, RemoveCalibrationMutationVariables>(RemoveCalibrationDocument, options);
      }
export type RemoveCalibrationMutationHookResult = ReturnType<typeof useRemoveCalibrationMutation>;
export type RemoveCalibrationMutationResult = Apollo.MutationResult<RemoveCalibrationMutation>;
export type RemoveCalibrationMutationOptions = Apollo.BaseMutationOptions<RemoveCalibrationMutation, RemoveCalibrationMutationVariables>;
export const RemoveEvaluatorsDocument = gql`
    mutation removeEvaluators($calibrationId: String!, $evaluators: [String!]!) {
  removeEvaluators(evaluators: $evaluators, calibrationId: $calibrationId) {
    code
    message
  }
}
    `;
export type RemoveEvaluatorsMutationFn = Apollo.MutationFunction<RemoveEvaluatorsMutation, RemoveEvaluatorsMutationVariables>;

/**
 * __useRemoveEvaluatorsMutation__
 *
 * To run a mutation, you first call `useRemoveEvaluatorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEvaluatorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEvaluatorsMutation, { data, loading, error }] = useRemoveEvaluatorsMutation({
 *   variables: {
 *      calibrationId: // value for 'calibrationId'
 *      evaluators: // value for 'evaluators'
 *   },
 * });
 */
export function useRemoveEvaluatorsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEvaluatorsMutation, RemoveEvaluatorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEvaluatorsMutation, RemoveEvaluatorsMutationVariables>(RemoveEvaluatorsDocument, options);
      }
export type RemoveEvaluatorsMutationHookResult = ReturnType<typeof useRemoveEvaluatorsMutation>;
export type RemoveEvaluatorsMutationResult = Apollo.MutationResult<RemoveEvaluatorsMutation>;
export type RemoveEvaluatorsMutationOptions = Apollo.BaseMutationOptions<RemoveEvaluatorsMutation, RemoveEvaluatorsMutationVariables>;
export const RemoveOrganizationTagDocument = gql`
    mutation removeOrganizationTag($instanceId: String!, $tagId: String!) {
  removeOrganizationTag(instanceId: $instanceId, tagId: $tagId) {
    code
    message
  }
}
    `;
export type RemoveOrganizationTagMutationFn = Apollo.MutationFunction<RemoveOrganizationTagMutation, RemoveOrganizationTagMutationVariables>;

/**
 * __useRemoveOrganizationTagMutation__
 *
 * To run a mutation, you first call `useRemoveOrganizationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganizationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganizationTagMutation, { data, loading, error }] = useRemoveOrganizationTagMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useRemoveOrganizationTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrganizationTagMutation, RemoveOrganizationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrganizationTagMutation, RemoveOrganizationTagMutationVariables>(RemoveOrganizationTagDocument, options);
      }
export type RemoveOrganizationTagMutationHookResult = ReturnType<typeof useRemoveOrganizationTagMutation>;
export type RemoveOrganizationTagMutationResult = Apollo.MutationResult<RemoveOrganizationTagMutation>;
export type RemoveOrganizationTagMutationOptions = Apollo.BaseMutationOptions<RemoveOrganizationTagMutation, RemoveOrganizationTagMutationVariables>;
export const RemoveReviewDocument = gql`
    mutation RemoveReview($input: RemoveReviewInput!) {
  removeReview(input: $input) {
    code
    message
  }
}
    `;
export type RemoveReviewMutationFn = Apollo.MutationFunction<RemoveReviewMutation, RemoveReviewMutationVariables>;

/**
 * __useRemoveReviewMutation__
 *
 * To run a mutation, you first call `useRemoveReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeReviewMutation, { data, loading, error }] = useRemoveReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveReviewMutation(baseOptions?: Apollo.MutationHookOptions<RemoveReviewMutation, RemoveReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveReviewMutation, RemoveReviewMutationVariables>(RemoveReviewDocument, options);
      }
export type RemoveReviewMutationHookResult = ReturnType<typeof useRemoveReviewMutation>;
export type RemoveReviewMutationResult = Apollo.MutationResult<RemoveReviewMutation>;
export type RemoveReviewMutationOptions = Apollo.BaseMutationOptions<RemoveReviewMutation, RemoveReviewMutationVariables>;
export const RemoveWhiteListedDomainsDocument = gql`
    mutation removeWhiteListedDomains($whiteListedDomainsListToRemove: [String!]!, $userEmail: String!, $instanceId: String!) {
  removeWhiteListedDomains(
    input: {whiteListedDomainsListToRemove: $whiteListedDomainsListToRemove, userEmail: $userEmail, instanceId: $instanceId}
  ) {
    code
    message
  }
}
    `;
export type RemoveWhiteListedDomainsMutationFn = Apollo.MutationFunction<RemoveWhiteListedDomainsMutation, RemoveWhiteListedDomainsMutationVariables>;

/**
 * __useRemoveWhiteListedDomainsMutation__
 *
 * To run a mutation, you first call `useRemoveWhiteListedDomainsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWhiteListedDomainsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWhiteListedDomainsMutation, { data, loading, error }] = useRemoveWhiteListedDomainsMutation({
 *   variables: {
 *      whiteListedDomainsListToRemove: // value for 'whiteListedDomainsListToRemove'
 *      userEmail: // value for 'userEmail'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useRemoveWhiteListedDomainsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWhiteListedDomainsMutation, RemoveWhiteListedDomainsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWhiteListedDomainsMutation, RemoveWhiteListedDomainsMutationVariables>(RemoveWhiteListedDomainsDocument, options);
      }
export type RemoveWhiteListedDomainsMutationHookResult = ReturnType<typeof useRemoveWhiteListedDomainsMutation>;
export type RemoveWhiteListedDomainsMutationResult = Apollo.MutationResult<RemoveWhiteListedDomainsMutation>;
export type RemoveWhiteListedDomainsMutationOptions = Apollo.BaseMutationOptions<RemoveWhiteListedDomainsMutation, RemoveWhiteListedDomainsMutationVariables>;
export const SendEmailInviteDocument = gql`
    mutation SendEmailInvite($input: SendEmailInviteInput!) {
  sendEmailInvite(input: $input) {
    id
    organizationId
    organizationAuthId
    email
    inviterId
    createdAt
    expiresAt
    role
    status
  }
}
    `;
export type SendEmailInviteMutationFn = Apollo.MutationFunction<SendEmailInviteMutation, SendEmailInviteMutationVariables>;

/**
 * __useSendEmailInviteMutation__
 *
 * To run a mutation, you first call `useSendEmailInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailInviteMutation, { data, loading, error }] = useSendEmailInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendEmailInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailInviteMutation, SendEmailInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailInviteMutation, SendEmailInviteMutationVariables>(SendEmailInviteDocument, options);
      }
export type SendEmailInviteMutationHookResult = ReturnType<typeof useSendEmailInviteMutation>;
export type SendEmailInviteMutationResult = Apollo.MutationResult<SendEmailInviteMutation>;
export type SendEmailInviteMutationOptions = Apollo.BaseMutationOptions<SendEmailInviteMutation, SendEmailInviteMutationVariables>;
export const SendEmailNotificationsForRemovedEvaluatorsDocument = gql`
    mutation sendEmailNotificationsForRemovedEvaluators($evaluatorsToBeRemoved: [EvaluatorToBeRemovedInput!]!, $calibrationData: CalibrationInputForRemovedEvaluatorsEmail!, $instanceId: String!) {
  sendEmailNotificationsForRemovedEvaluators(
    evaluatorsToBeRemoved: $evaluatorsToBeRemoved
    calibrationData: $calibrationData
    instanceId: $instanceId
  ) {
    code
    message
  }
}
    `;
export type SendEmailNotificationsForRemovedEvaluatorsMutationFn = Apollo.MutationFunction<SendEmailNotificationsForRemovedEvaluatorsMutation, SendEmailNotificationsForRemovedEvaluatorsMutationVariables>;

/**
 * __useSendEmailNotificationsForRemovedEvaluatorsMutation__
 *
 * To run a mutation, you first call `useSendEmailNotificationsForRemovedEvaluatorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailNotificationsForRemovedEvaluatorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailNotificationsForRemovedEvaluatorsMutation, { data, loading, error }] = useSendEmailNotificationsForRemovedEvaluatorsMutation({
 *   variables: {
 *      evaluatorsToBeRemoved: // value for 'evaluatorsToBeRemoved'
 *      calibrationData: // value for 'calibrationData'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useSendEmailNotificationsForRemovedEvaluatorsMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailNotificationsForRemovedEvaluatorsMutation, SendEmailNotificationsForRemovedEvaluatorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailNotificationsForRemovedEvaluatorsMutation, SendEmailNotificationsForRemovedEvaluatorsMutationVariables>(SendEmailNotificationsForRemovedEvaluatorsDocument, options);
      }
export type SendEmailNotificationsForRemovedEvaluatorsMutationHookResult = ReturnType<typeof useSendEmailNotificationsForRemovedEvaluatorsMutation>;
export type SendEmailNotificationsForRemovedEvaluatorsMutationResult = Apollo.MutationResult<SendEmailNotificationsForRemovedEvaluatorsMutation>;
export type SendEmailNotificationsForRemovedEvaluatorsMutationOptions = Apollo.BaseMutationOptions<SendEmailNotificationsForRemovedEvaluatorsMutation, SendEmailNotificationsForRemovedEvaluatorsMutationVariables>;
export const SignupDocument = gql`
    mutation Signup($input: SignupInput!) {
  signup(input: $input) {
    tenantUrl
    displayName
  }
}
    `;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, options);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const ClearTicketQueueDocument = gql`
    mutation ClearTicketQueue($organization: String!) {
  clearTicketQueue(organization: $organization)
}
    `;
export type ClearTicketQueueMutationFn = Apollo.MutationFunction<ClearTicketQueueMutation, ClearTicketQueueMutationVariables>;

/**
 * __useClearTicketQueueMutation__
 *
 * To run a mutation, you first call `useClearTicketQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearTicketQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearTicketQueueMutation, { data, loading, error }] = useClearTicketQueueMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useClearTicketQueueMutation(baseOptions?: Apollo.MutationHookOptions<ClearTicketQueueMutation, ClearTicketQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearTicketQueueMutation, ClearTicketQueueMutationVariables>(ClearTicketQueueDocument, options);
      }
export type ClearTicketQueueMutationHookResult = ReturnType<typeof useClearTicketQueueMutation>;
export type ClearTicketQueueMutationResult = Apollo.MutationResult<ClearTicketQueueMutation>;
export type ClearTicketQueueMutationOptions = Apollo.BaseMutationOptions<ClearTicketQueueMutation, ClearTicketQueueMutationVariables>;
export const PullTicketQueueDocument = gql`
    mutation PullTicketQueue($organization: String!) {
  pullTicketQueue(organizations: [$organization])
}
    `;
export type PullTicketQueueMutationFn = Apollo.MutationFunction<PullTicketQueueMutation, PullTicketQueueMutationVariables>;

/**
 * __usePullTicketQueueMutation__
 *
 * To run a mutation, you first call `usePullTicketQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePullTicketQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pullTicketQueueMutation, { data, loading, error }] = usePullTicketQueueMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function usePullTicketQueueMutation(baseOptions?: Apollo.MutationHookOptions<PullTicketQueueMutation, PullTicketQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PullTicketQueueMutation, PullTicketQueueMutationVariables>(PullTicketQueueDocument, options);
      }
export type PullTicketQueueMutationHookResult = ReturnType<typeof usePullTicketQueueMutation>;
export type PullTicketQueueMutationResult = Apollo.MutationResult<PullTicketQueueMutation>;
export type PullTicketQueueMutationOptions = Apollo.BaseMutationOptions<PullTicketQueueMutation, PullTicketQueueMutationVariables>;
export const ToggleOrganizationPrivacyOptionDocument = gql`
    mutation toggleOrganizationPrivacyOption($enablePrivacyOption: Boolean!, $userEmail: String!, $instanceId: String!) {
  toggleOrganizationPrivacyOption(
    input: {enablePrivacyOption: $enablePrivacyOption, userEmail: $userEmail, instanceId: $instanceId}
  ) {
    code
    message
  }
}
    `;
export type ToggleOrganizationPrivacyOptionMutationFn = Apollo.MutationFunction<ToggleOrganizationPrivacyOptionMutation, ToggleOrganizationPrivacyOptionMutationVariables>;

/**
 * __useToggleOrganizationPrivacyOptionMutation__
 *
 * To run a mutation, you first call `useToggleOrganizationPrivacyOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleOrganizationPrivacyOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleOrganizationPrivacyOptionMutation, { data, loading, error }] = useToggleOrganizationPrivacyOptionMutation({
 *   variables: {
 *      enablePrivacyOption: // value for 'enablePrivacyOption'
 *      userEmail: // value for 'userEmail'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useToggleOrganizationPrivacyOptionMutation(baseOptions?: Apollo.MutationHookOptions<ToggleOrganizationPrivacyOptionMutation, ToggleOrganizationPrivacyOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleOrganizationPrivacyOptionMutation, ToggleOrganizationPrivacyOptionMutationVariables>(ToggleOrganizationPrivacyOptionDocument, options);
      }
export type ToggleOrganizationPrivacyOptionMutationHookResult = ReturnType<typeof useToggleOrganizationPrivacyOptionMutation>;
export type ToggleOrganizationPrivacyOptionMutationResult = Apollo.MutationResult<ToggleOrganizationPrivacyOptionMutation>;
export type ToggleOrganizationPrivacyOptionMutationOptions = Apollo.BaseMutationOptions<ToggleOrganizationPrivacyOptionMutation, ToggleOrganizationPrivacyOptionMutationVariables>;
export const ToggleUserAsTeamLeaderDocument = gql`
    mutation toggleUserAsTeamLeader($where: FirestoreUserWhereUnique!, $input: FirestoreUserUpdateInput!) {
  toggleUserAsTeamLeader(where: $where, input: $input) {
    code
    message
  }
}
    `;
export type ToggleUserAsTeamLeaderMutationFn = Apollo.MutationFunction<ToggleUserAsTeamLeaderMutation, ToggleUserAsTeamLeaderMutationVariables>;

/**
 * __useToggleUserAsTeamLeaderMutation__
 *
 * To run a mutation, you first call `useToggleUserAsTeamLeaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUserAsTeamLeaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUserAsTeamLeaderMutation, { data, loading, error }] = useToggleUserAsTeamLeaderMutation({
 *   variables: {
 *      where: // value for 'where'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleUserAsTeamLeaderMutation(baseOptions?: Apollo.MutationHookOptions<ToggleUserAsTeamLeaderMutation, ToggleUserAsTeamLeaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleUserAsTeamLeaderMutation, ToggleUserAsTeamLeaderMutationVariables>(ToggleUserAsTeamLeaderDocument, options);
      }
export type ToggleUserAsTeamLeaderMutationHookResult = ReturnType<typeof useToggleUserAsTeamLeaderMutation>;
export type ToggleUserAsTeamLeaderMutationResult = Apollo.MutationResult<ToggleUserAsTeamLeaderMutation>;
export type ToggleUserAsTeamLeaderMutationOptions = Apollo.BaseMutationOptions<ToggleUserAsTeamLeaderMutation, ToggleUserAsTeamLeaderMutationVariables>;
export const UpdateFirestoreUserDocument = gql`
    mutation UpdateFirestoreUser($where: FirestoreUserWhereUnique!, $input: FirestoreUserUpdateInput!) {
  updateFirestoreUser(where: $where, input: $input) {
    id
    uid
    organizationAuthId
    instanceId
    organizationId
    email
    status
    firstName
    lastName
    displayName
    pronouns
    hasTakenTour
    photoURL
    teamId
    roles
  }
}
    `;
export type UpdateFirestoreUserMutationFn = Apollo.MutationFunction<UpdateFirestoreUserMutation, UpdateFirestoreUserMutationVariables>;

/**
 * __useUpdateFirestoreUserMutation__
 *
 * To run a mutation, you first call `useUpdateFirestoreUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFirestoreUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFirestoreUserMutation, { data, loading, error }] = useUpdateFirestoreUserMutation({
 *   variables: {
 *      where: // value for 'where'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFirestoreUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFirestoreUserMutation, UpdateFirestoreUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFirestoreUserMutation, UpdateFirestoreUserMutationVariables>(UpdateFirestoreUserDocument, options);
      }
export type UpdateFirestoreUserMutationHookResult = ReturnType<typeof useUpdateFirestoreUserMutation>;
export type UpdateFirestoreUserMutationResult = Apollo.MutationResult<UpdateFirestoreUserMutation>;
export type UpdateFirestoreUserMutationOptions = Apollo.BaseMutationOptions<UpdateFirestoreUserMutation, UpdateFirestoreUserMutationVariables>;
export const UpdateCalibrationsNameDocument = gql`
    mutation updateCalibrationsName($calibrationId: String!, $calibrationName: String!) {
  updateCalibrationsName(
    calibrationId: $calibrationId
    calibrationName: $calibrationName
  ) {
    code
    message
  }
}
    `;
export type UpdateCalibrationsNameMutationFn = Apollo.MutationFunction<UpdateCalibrationsNameMutation, UpdateCalibrationsNameMutationVariables>;

/**
 * __useUpdateCalibrationsNameMutation__
 *
 * To run a mutation, you first call `useUpdateCalibrationsNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalibrationsNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalibrationsNameMutation, { data, loading, error }] = useUpdateCalibrationsNameMutation({
 *   variables: {
 *      calibrationId: // value for 'calibrationId'
 *      calibrationName: // value for 'calibrationName'
 *   },
 * });
 */
export function useUpdateCalibrationsNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalibrationsNameMutation, UpdateCalibrationsNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalibrationsNameMutation, UpdateCalibrationsNameMutationVariables>(UpdateCalibrationsNameDocument, options);
      }
export type UpdateCalibrationsNameMutationHookResult = ReturnType<typeof useUpdateCalibrationsNameMutation>;
export type UpdateCalibrationsNameMutationResult = Apollo.MutationResult<UpdateCalibrationsNameMutation>;
export type UpdateCalibrationsNameMutationOptions = Apollo.BaseMutationOptions<UpdateCalibrationsNameMutation, UpdateCalibrationsNameMutationVariables>;
export const UpdateGoalsDocument = gql`
    mutation UpdateGoals($updateGoalsInput: UpdateGoalsInput!) {
  updateGoals(updateGoalsInput: $updateGoalsInput) {
    instanceId
    sample
    qaScore
    errorFreeRate
    criticalErrorRate
  }
}
    `;
export type UpdateGoalsMutationFn = Apollo.MutationFunction<UpdateGoalsMutation, UpdateGoalsMutationVariables>;

/**
 * __useUpdateGoalsMutation__
 *
 * To run a mutation, you first call `useUpdateGoalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGoalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGoalsMutation, { data, loading, error }] = useUpdateGoalsMutation({
 *   variables: {
 *      updateGoalsInput: // value for 'updateGoalsInput'
 *   },
 * });
 */
export function useUpdateGoalsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGoalsMutation, UpdateGoalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGoalsMutation, UpdateGoalsMutationVariables>(UpdateGoalsDocument, options);
      }
export type UpdateGoalsMutationHookResult = ReturnType<typeof useUpdateGoalsMutation>;
export type UpdateGoalsMutationResult = Apollo.MutationResult<UpdateGoalsMutation>;
export type UpdateGoalsMutationOptions = Apollo.BaseMutationOptions<UpdateGoalsMutation, UpdateGoalsMutationVariables>;
export const UpdateNotificationSettingsReviewAcknowledgedDocument = gql`
    mutation updateNotificationSettingsReviewAcknowledged($userId: String!, $reviewAcknowledged: Boolean!, $instanceId: String!) {
  updateNotificationSettingsReviewAcknowledged(
    userId: $userId
    reviewAcknowledged: $reviewAcknowledged
    instanceId: $instanceId
  ) {
    code
    message
  }
}
    `;
export type UpdateNotificationSettingsReviewAcknowledgedMutationFn = Apollo.MutationFunction<UpdateNotificationSettingsReviewAcknowledgedMutation, UpdateNotificationSettingsReviewAcknowledgedMutationVariables>;

/**
 * __useUpdateNotificationSettingsReviewAcknowledgedMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationSettingsReviewAcknowledgedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationSettingsReviewAcknowledgedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationSettingsReviewAcknowledgedMutation, { data, loading, error }] = useUpdateNotificationSettingsReviewAcknowledgedMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      reviewAcknowledged: // value for 'reviewAcknowledged'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useUpdateNotificationSettingsReviewAcknowledgedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationSettingsReviewAcknowledgedMutation, UpdateNotificationSettingsReviewAcknowledgedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationSettingsReviewAcknowledgedMutation, UpdateNotificationSettingsReviewAcknowledgedMutationVariables>(UpdateNotificationSettingsReviewAcknowledgedDocument, options);
      }
export type UpdateNotificationSettingsReviewAcknowledgedMutationHookResult = ReturnType<typeof useUpdateNotificationSettingsReviewAcknowledgedMutation>;
export type UpdateNotificationSettingsReviewAcknowledgedMutationResult = Apollo.MutationResult<UpdateNotificationSettingsReviewAcknowledgedMutation>;
export type UpdateNotificationSettingsReviewAcknowledgedMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationSettingsReviewAcknowledgedMutation, UpdateNotificationSettingsReviewAcknowledgedMutationVariables>;
export const UpdateNotificationSettingsReviewDeletedDocument = gql`
    mutation updateNotificationSettingsReviewDeleted($userId: String!, $reviewDeleted: Boolean!, $instanceId: String!) {
  updateNotificationSettingsReviewDeleted(
    userId: $userId
    reviewDeleted: $reviewDeleted
    instanceId: $instanceId
  ) {
    code
    message
  }
}
    `;
export type UpdateNotificationSettingsReviewDeletedMutationFn = Apollo.MutationFunction<UpdateNotificationSettingsReviewDeletedMutation, UpdateNotificationSettingsReviewDeletedMutationVariables>;

/**
 * __useUpdateNotificationSettingsReviewDeletedMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationSettingsReviewDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationSettingsReviewDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationSettingsReviewDeletedMutation, { data, loading, error }] = useUpdateNotificationSettingsReviewDeletedMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      reviewDeleted: // value for 'reviewDeleted'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useUpdateNotificationSettingsReviewDeletedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationSettingsReviewDeletedMutation, UpdateNotificationSettingsReviewDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationSettingsReviewDeletedMutation, UpdateNotificationSettingsReviewDeletedMutationVariables>(UpdateNotificationSettingsReviewDeletedDocument, options);
      }
export type UpdateNotificationSettingsReviewDeletedMutationHookResult = ReturnType<typeof useUpdateNotificationSettingsReviewDeletedMutation>;
export type UpdateNotificationSettingsReviewDeletedMutationResult = Apollo.MutationResult<UpdateNotificationSettingsReviewDeletedMutation>;
export type UpdateNotificationSettingsReviewDeletedMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationSettingsReviewDeletedMutation, UpdateNotificationSettingsReviewDeletedMutationVariables>;
export const UpdateNotificationSettingsReviewReceivedDocument = gql`
    mutation updateNotificationSettingsReviewReceived($userId: String!, $reviewReceived: Boolean!, $instanceId: String!) {
  updateNotificationSettingsReviewReceived(
    userId: $userId
    reviewReceived: $reviewReceived
    instanceId: $instanceId
  ) {
    code
    message
  }
}
    `;
export type UpdateNotificationSettingsReviewReceivedMutationFn = Apollo.MutationFunction<UpdateNotificationSettingsReviewReceivedMutation, UpdateNotificationSettingsReviewReceivedMutationVariables>;

/**
 * __useUpdateNotificationSettingsReviewReceivedMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationSettingsReviewReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationSettingsReviewReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationSettingsReviewReceivedMutation, { data, loading, error }] = useUpdateNotificationSettingsReviewReceivedMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      reviewReceived: // value for 'reviewReceived'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useUpdateNotificationSettingsReviewReceivedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationSettingsReviewReceivedMutation, UpdateNotificationSettingsReviewReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationSettingsReviewReceivedMutation, UpdateNotificationSettingsReviewReceivedMutationVariables>(UpdateNotificationSettingsReviewReceivedDocument, options);
      }
export type UpdateNotificationSettingsReviewReceivedMutationHookResult = ReturnType<typeof useUpdateNotificationSettingsReviewReceivedMutation>;
export type UpdateNotificationSettingsReviewReceivedMutationResult = Apollo.MutationResult<UpdateNotificationSettingsReviewReceivedMutation>;
export type UpdateNotificationSettingsReviewReceivedMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationSettingsReviewReceivedMutation, UpdateNotificationSettingsReviewReceivedMutationVariables>;
export const UpdateNotificationSettingsReviewWithAutofailDocument = gql`
    mutation updateNotificationSettingsReviewWithAutofail($userId: String!, $reviewWithAutofail: Boolean!, $instanceId: String!) {
  updateNotificationSettingsReviewWithAutofail(
    userId: $userId
    reviewWithAutofail: $reviewWithAutofail
    instanceId: $instanceId
  ) {
    code
    message
  }
}
    `;
export type UpdateNotificationSettingsReviewWithAutofailMutationFn = Apollo.MutationFunction<UpdateNotificationSettingsReviewWithAutofailMutation, UpdateNotificationSettingsReviewWithAutofailMutationVariables>;

/**
 * __useUpdateNotificationSettingsReviewWithAutofailMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationSettingsReviewWithAutofailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationSettingsReviewWithAutofailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationSettingsReviewWithAutofailMutation, { data, loading, error }] = useUpdateNotificationSettingsReviewWithAutofailMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      reviewWithAutofail: // value for 'reviewWithAutofail'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useUpdateNotificationSettingsReviewWithAutofailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationSettingsReviewWithAutofailMutation, UpdateNotificationSettingsReviewWithAutofailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationSettingsReviewWithAutofailMutation, UpdateNotificationSettingsReviewWithAutofailMutationVariables>(UpdateNotificationSettingsReviewWithAutofailDocument, options);
      }
export type UpdateNotificationSettingsReviewWithAutofailMutationHookResult = ReturnType<typeof useUpdateNotificationSettingsReviewWithAutofailMutation>;
export type UpdateNotificationSettingsReviewWithAutofailMutationResult = Apollo.MutationResult<UpdateNotificationSettingsReviewWithAutofailMutation>;
export type UpdateNotificationSettingsReviewWithAutofailMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationSettingsReviewWithAutofailMutation, UpdateNotificationSettingsReviewWithAutofailMutationVariables>;
export const UpdateOrganizationFieldsDocument = gql`
    mutation updateOrganizationFields($orgName: String!, $updateOrganizationFields: UpdateOrganizationFieldsInput!) {
  updateOrganizationFields(
    orgName: $orgName
    updateOrganizationFields: $updateOrganizationFields
  ) {
    code
  }
}
    `;
export type UpdateOrganizationFieldsMutationFn = Apollo.MutationFunction<UpdateOrganizationFieldsMutation, UpdateOrganizationFieldsMutationVariables>;

/**
 * __useUpdateOrganizationFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationFieldsMutation, { data, loading, error }] = useUpdateOrganizationFieldsMutation({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      updateOrganizationFields: // value for 'updateOrganizationFields'
 *   },
 * });
 */
export function useUpdateOrganizationFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationFieldsMutation, UpdateOrganizationFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationFieldsMutation, UpdateOrganizationFieldsMutationVariables>(UpdateOrganizationFieldsDocument, options);
      }
export type UpdateOrganizationFieldsMutationHookResult = ReturnType<typeof useUpdateOrganizationFieldsMutation>;
export type UpdateOrganizationFieldsMutationResult = Apollo.MutationResult<UpdateOrganizationFieldsMutation>;
export type UpdateOrganizationFieldsMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationFieldsMutation, UpdateOrganizationFieldsMutationVariables>;
export const UpdateOrganizationZendeskCrmurlDocument = gql`
    mutation updateOrganizationZendeskCRMURL($orgName: String!, $newCRMURL: String!) {
  updateOrganizationZendeskCRMURL(orgName: $orgName, newCRMURL: $newCRMURL) {
    code
    message
  }
}
    `;
export type UpdateOrganizationZendeskCrmurlMutationFn = Apollo.MutationFunction<UpdateOrganizationZendeskCrmurlMutation, UpdateOrganizationZendeskCrmurlMutationVariables>;

/**
 * __useUpdateOrganizationZendeskCrmurlMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationZendeskCrmurlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationZendeskCrmurlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationZendeskCrmurlMutation, { data, loading, error }] = useUpdateOrganizationZendeskCrmurlMutation({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      newCRMURL: // value for 'newCRMURL'
 *   },
 * });
 */
export function useUpdateOrganizationZendeskCrmurlMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationZendeskCrmurlMutation, UpdateOrganizationZendeskCrmurlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationZendeskCrmurlMutation, UpdateOrganizationZendeskCrmurlMutationVariables>(UpdateOrganizationZendeskCrmurlDocument, options);
      }
export type UpdateOrganizationZendeskCrmurlMutationHookResult = ReturnType<typeof useUpdateOrganizationZendeskCrmurlMutation>;
export type UpdateOrganizationZendeskCrmurlMutationResult = Apollo.MutationResult<UpdateOrganizationZendeskCrmurlMutation>;
export type UpdateOrganizationZendeskCrmurlMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationZendeskCrmurlMutation, UpdateOrganizationZendeskCrmurlMutationVariables>;
export const UpdateQueueConfigurationDocument = gql`
    mutation UpdateQueueConfiguration($instanceId: String!, $updateQueueConfigurationInput: UpdateQueueConfigurationInput!) {
  updateQueueConfiguration(
    instanceId: $instanceId
    updateQueueConfigurationInput: $updateQueueConfigurationInput
  ) {
    instanceId
    dataConnected
    frequency
    ticketAmount
    countTicketsBy
    exclusions
    lastPullDateTime
    nextPullDateTime
  }
}
    `;
export type UpdateQueueConfigurationMutationFn = Apollo.MutationFunction<UpdateQueueConfigurationMutation, UpdateQueueConfigurationMutationVariables>;

/**
 * __useUpdateQueueConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateQueueConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQueueConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQueueConfigurationMutation, { data, loading, error }] = useUpdateQueueConfigurationMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      updateQueueConfigurationInput: // value for 'updateQueueConfigurationInput'
 *   },
 * });
 */
export function useUpdateQueueConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQueueConfigurationMutation, UpdateQueueConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQueueConfigurationMutation, UpdateQueueConfigurationMutationVariables>(UpdateQueueConfigurationDocument, options);
      }
export type UpdateQueueConfigurationMutationHookResult = ReturnType<typeof useUpdateQueueConfigurationMutation>;
export type UpdateQueueConfigurationMutationResult = Apollo.MutationResult<UpdateQueueConfigurationMutation>;
export type UpdateQueueConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateQueueConfigurationMutation, UpdateQueueConfigurationMutationVariables>;
export const UpdateRubricDocument = gql`
    mutation UpdateRubric($rubricId: String!, $updateRubricInput: UpdateRubricInput!) {
  updateRubric(rubricId: $rubricId, updateRubricInput: $updateRubricInput) {
    id
    createdDate
    instanceId
    status
    name
    nameLowerCase
    categories {
      id
      requiresComments
      orderIndex
      measurementType
      weight
      name
      questions {
        id
        name
        weight
        description
        requiresComments
        orderIndex
      }
      notApplicable
      autoFailEnabled
    }
    teamId
    favorite
    createdBy
  }
}
    `;
export type UpdateRubricMutationFn = Apollo.MutationFunction<UpdateRubricMutation, UpdateRubricMutationVariables>;

/**
 * __useUpdateRubricMutation__
 *
 * To run a mutation, you first call `useUpdateRubricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRubricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRubricMutation, { data, loading, error }] = useUpdateRubricMutation({
 *   variables: {
 *      rubricId: // value for 'rubricId'
 *      updateRubricInput: // value for 'updateRubricInput'
 *   },
 * });
 */
export function useUpdateRubricMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRubricMutation, UpdateRubricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRubricMutation, UpdateRubricMutationVariables>(UpdateRubricDocument, options);
      }
export type UpdateRubricMutationHookResult = ReturnType<typeof useUpdateRubricMutation>;
export type UpdateRubricMutationResult = Apollo.MutationResult<UpdateRubricMutation>;
export type UpdateRubricMutationOptions = Apollo.BaseMutationOptions<UpdateRubricMutation, UpdateRubricMutationVariables>;
export const UpdateRubricCategoriesDocument = gql`
    mutation UpdateRubricCategories($rubricId: String!, $categories: [CreateCategoryInput!]!, $questions: [CreateQuestionsInput!]!, $categoriesIdsToRemove: [String!]!, $removeQuestions: [RemoveQuestionInput!]!, $updateCategories: [UpdateCategoryInput!]!, $updateQuestions: [UpdateQuestionInput!]!, $currentRubricStatus: String!) {
  updateRubricCategories(
    rubricId: $rubricId
    categories: $categories
    questions: $questions
    categoriesIdsToRemove: $categoriesIdsToRemove
    removeQuestions: $removeQuestions
    updateCategories: $updateCategories
    updateQuestions: $updateQuestions
    currentRubricStatus: $currentRubricStatus
  ) {
    code
    message
  }
}
    `;
export type UpdateRubricCategoriesMutationFn = Apollo.MutationFunction<UpdateRubricCategoriesMutation, UpdateRubricCategoriesMutationVariables>;

/**
 * __useUpdateRubricCategoriesMutation__
 *
 * To run a mutation, you first call `useUpdateRubricCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRubricCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRubricCategoriesMutation, { data, loading, error }] = useUpdateRubricCategoriesMutation({
 *   variables: {
 *      rubricId: // value for 'rubricId'
 *      categories: // value for 'categories'
 *      questions: // value for 'questions'
 *      categoriesIdsToRemove: // value for 'categoriesIdsToRemove'
 *      removeQuestions: // value for 'removeQuestions'
 *      updateCategories: // value for 'updateCategories'
 *      updateQuestions: // value for 'updateQuestions'
 *      currentRubricStatus: // value for 'currentRubricStatus'
 *   },
 * });
 */
export function useUpdateRubricCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRubricCategoriesMutation, UpdateRubricCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRubricCategoriesMutation, UpdateRubricCategoriesMutationVariables>(UpdateRubricCategoriesDocument, options);
      }
export type UpdateRubricCategoriesMutationHookResult = ReturnType<typeof useUpdateRubricCategoriesMutation>;
export type UpdateRubricCategoriesMutationResult = Apollo.MutationResult<UpdateRubricCategoriesMutation>;
export type UpdateRubricCategoriesMutationOptions = Apollo.BaseMutationOptions<UpdateRubricCategoriesMutation, UpdateRubricCategoriesMutationVariables>;
export const UpdateTicketQueueDocument = gql`
    mutation UpdateTicketQueue($updateTicketQueueInput: UpdateTicketQueueInput!) {
  updateTicketQueue(updateTicketQueueInput: $updateTicketQueueInput) {
    ticketId
    ticketURL
    assigneeEmail
    assigneeName
    ticketStarted
    ticketClosed
    totalHandleTime
    reviewed
    discarded
    instanceId
  }
}
    `;
export type UpdateTicketQueueMutationFn = Apollo.MutationFunction<UpdateTicketQueueMutation, UpdateTicketQueueMutationVariables>;

/**
 * __useUpdateTicketQueueMutation__
 *
 * To run a mutation, you first call `useUpdateTicketQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTicketQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTicketQueueMutation, { data, loading, error }] = useUpdateTicketQueueMutation({
 *   variables: {
 *      updateTicketQueueInput: // value for 'updateTicketQueueInput'
 *   },
 * });
 */
export function useUpdateTicketQueueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTicketQueueMutation, UpdateTicketQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTicketQueueMutation, UpdateTicketQueueMutationVariables>(UpdateTicketQueueDocument, options);
      }
export type UpdateTicketQueueMutationHookResult = ReturnType<typeof useUpdateTicketQueueMutation>;
export type UpdateTicketQueueMutationResult = Apollo.MutationResult<UpdateTicketQueueMutation>;
export type UpdateTicketQueueMutationOptions = Apollo.BaseMutationOptions<UpdateTicketQueueMutation, UpdateTicketQueueMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($uid: String!, $instanceId: String!, $input: UpdateFirestoreUserInput!) {
  updateUser(uid: $uid, instanceId: $instanceId, input: $input) {
    email
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      instanceId: // value for 'instanceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserRolesDocument = gql`
    mutation UpdateUserRoles($where: FirestoreUserWhereUnique!, $input: FirestoreUserUpdateInput!) {
  updateUserRoles(where: $where, input: $input) {
    id
    uid
    organizationAuthId
    instanceId
    organizationId
    email
    status
    firstName
    lastName
    displayName
    pronouns
    hasTakenTour
    photoURL
    teamId
    roles
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}
    `;
export type UpdateUserRolesMutationFn = Apollo.MutationFunction<UpdateUserRolesMutation, UpdateUserRolesMutationVariables>;

/**
 * __useUpdateUserRolesMutation__
 *
 * To run a mutation, you first call `useUpdateUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRolesMutation, { data, loading, error }] = useUpdateUserRolesMutation({
 *   variables: {
 *      where: // value for 'where'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserRolesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRolesMutation, UpdateUserRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRolesMutation, UpdateUserRolesMutationVariables>(UpdateUserRolesDocument, options);
      }
export type UpdateUserRolesMutationHookResult = ReturnType<typeof useUpdateUserRolesMutation>;
export type UpdateUserRolesMutationResult = Apollo.MutationResult<UpdateUserRolesMutation>;
export type UpdateUserRolesMutationOptions = Apollo.BaseMutationOptions<UpdateUserRolesMutation, UpdateUserRolesMutationVariables>;
export const UpdateUserTeamAndMoveTheirReviewsInFirestoreDocument = gql`
    mutation UpdateUserTeamAndMoveTheirReviewsInFirestore($newTeamId: String!, $oldTeamId: String!, $userEmail: String!, $assigneeUid: String!, $currentUserEmail: String!, $instanceId: String!) {
  updateUserTeamAndMoveTheirReviewsInFirestore(
    newTeamId: $newTeamId
    oldTeamId: $oldTeamId
    userEmail: $userEmail
    assigneeUid: $assigneeUid
    currentUserEmail: $currentUserEmail
    instanceId: $instanceId
  ) {
    code
    message
  }
}
    `;
export type UpdateUserTeamAndMoveTheirReviewsInFirestoreMutationFn = Apollo.MutationFunction<UpdateUserTeamAndMoveTheirReviewsInFirestoreMutation, UpdateUserTeamAndMoveTheirReviewsInFirestoreMutationVariables>;

/**
 * __useUpdateUserTeamAndMoveTheirReviewsInFirestoreMutation__
 *
 * To run a mutation, you first call `useUpdateUserTeamAndMoveTheirReviewsInFirestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTeamAndMoveTheirReviewsInFirestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTeamAndMoveTheirReviewsInFirestoreMutation, { data, loading, error }] = useUpdateUserTeamAndMoveTheirReviewsInFirestoreMutation({
 *   variables: {
 *      newTeamId: // value for 'newTeamId'
 *      oldTeamId: // value for 'oldTeamId'
 *      userEmail: // value for 'userEmail'
 *      assigneeUid: // value for 'assigneeUid'
 *      currentUserEmail: // value for 'currentUserEmail'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useUpdateUserTeamAndMoveTheirReviewsInFirestoreMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserTeamAndMoveTheirReviewsInFirestoreMutation, UpdateUserTeamAndMoveTheirReviewsInFirestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserTeamAndMoveTheirReviewsInFirestoreMutation, UpdateUserTeamAndMoveTheirReviewsInFirestoreMutationVariables>(UpdateUserTeamAndMoveTheirReviewsInFirestoreDocument, options);
      }
export type UpdateUserTeamAndMoveTheirReviewsInFirestoreMutationHookResult = ReturnType<typeof useUpdateUserTeamAndMoveTheirReviewsInFirestoreMutation>;
export type UpdateUserTeamAndMoveTheirReviewsInFirestoreMutationResult = Apollo.MutationResult<UpdateUserTeamAndMoveTheirReviewsInFirestoreMutation>;
export type UpdateUserTeamAndMoveTheirReviewsInFirestoreMutationOptions = Apollo.BaseMutationOptions<UpdateUserTeamAndMoveTheirReviewsInFirestoreMutation, UpdateUserTeamAndMoveTheirReviewsInFirestoreMutationVariables>;
export const IsOrganizationRegisteredCrmurlDocument = gql`
    query isOrganizationRegisteredCRMURL($crmURL: String!) {
  isOrganizationRegisteredCRMURL(crmURL: $crmURL)
}
    `;

/**
 * __useIsOrganizationRegisteredCrmurlQuery__
 *
 * To run a query within a React component, call `useIsOrganizationRegisteredCrmurlQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsOrganizationRegisteredCrmurlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsOrganizationRegisteredCrmurlQuery({
 *   variables: {
 *      crmURL: // value for 'crmURL'
 *   },
 * });
 */
export function useIsOrganizationRegisteredCrmurlQuery(baseOptions: Apollo.QueryHookOptions<IsOrganizationRegisteredCrmurlQuery, IsOrganizationRegisteredCrmurlQueryVariables> & ({ variables: IsOrganizationRegisteredCrmurlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsOrganizationRegisteredCrmurlQuery, IsOrganizationRegisteredCrmurlQueryVariables>(IsOrganizationRegisteredCrmurlDocument, options);
      }
export function useIsOrganizationRegisteredCrmurlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsOrganizationRegisteredCrmurlQuery, IsOrganizationRegisteredCrmurlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsOrganizationRegisteredCrmurlQuery, IsOrganizationRegisteredCrmurlQueryVariables>(IsOrganizationRegisteredCrmurlDocument, options);
        }
export function useIsOrganizationRegisteredCrmurlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsOrganizationRegisteredCrmurlQuery, IsOrganizationRegisteredCrmurlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsOrganizationRegisteredCrmurlQuery, IsOrganizationRegisteredCrmurlQueryVariables>(IsOrganizationRegisteredCrmurlDocument, options);
        }
export type IsOrganizationRegisteredCrmurlQueryHookResult = ReturnType<typeof useIsOrganizationRegisteredCrmurlQuery>;
export type IsOrganizationRegisteredCrmurlLazyQueryHookResult = ReturnType<typeof useIsOrganizationRegisteredCrmurlLazyQuery>;
export type IsOrganizationRegisteredCrmurlSuspenseQueryHookResult = ReturnType<typeof useIsOrganizationRegisteredCrmurlSuspenseQuery>;
export type IsOrganizationRegisteredCrmurlQueryResult = Apollo.QueryResult<IsOrganizationRegisteredCrmurlQuery, IsOrganizationRegisteredCrmurlQueryVariables>;
export const CheckCalibrationsNameDocument = gql`
    query checkCalibrationsName($calibrationName: String!, $instanceId: String!) {
  checkCalibrationsName(
    calibrationName: $calibrationName
    instanceId: $instanceId
  )
}
    `;

/**
 * __useCheckCalibrationsNameQuery__
 *
 * To run a query within a React component, call `useCheckCalibrationsNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCalibrationsNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCalibrationsNameQuery({
 *   variables: {
 *      calibrationName: // value for 'calibrationName'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useCheckCalibrationsNameQuery(baseOptions: Apollo.QueryHookOptions<CheckCalibrationsNameQuery, CheckCalibrationsNameQueryVariables> & ({ variables: CheckCalibrationsNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckCalibrationsNameQuery, CheckCalibrationsNameQueryVariables>(CheckCalibrationsNameDocument, options);
      }
export function useCheckCalibrationsNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckCalibrationsNameQuery, CheckCalibrationsNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckCalibrationsNameQuery, CheckCalibrationsNameQueryVariables>(CheckCalibrationsNameDocument, options);
        }
export function useCheckCalibrationsNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckCalibrationsNameQuery, CheckCalibrationsNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckCalibrationsNameQuery, CheckCalibrationsNameQueryVariables>(CheckCalibrationsNameDocument, options);
        }
export type CheckCalibrationsNameQueryHookResult = ReturnType<typeof useCheckCalibrationsNameQuery>;
export type CheckCalibrationsNameLazyQueryHookResult = ReturnType<typeof useCheckCalibrationsNameLazyQuery>;
export type CheckCalibrationsNameSuspenseQueryHookResult = ReturnType<typeof useCheckCalibrationsNameSuspenseQuery>;
export type CheckCalibrationsNameQueryResult = Apollo.QueryResult<CheckCalibrationsNameQuery, CheckCalibrationsNameQueryVariables>;
export const CheckCalibrationsOnAdminLevelDocument = gql`
    query checkCalibrationsOnAdminLevel($calibratorUid: String!, $instanceId: String!) {
  checkCalibrationsOnAdminLevel(
    calibratorUid: $calibratorUid
    instanceId: $instanceId
  )
}
    `;

/**
 * __useCheckCalibrationsOnAdminLevelQuery__
 *
 * To run a query within a React component, call `useCheckCalibrationsOnAdminLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCalibrationsOnAdminLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCalibrationsOnAdminLevelQuery({
 *   variables: {
 *      calibratorUid: // value for 'calibratorUid'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useCheckCalibrationsOnAdminLevelQuery(baseOptions: Apollo.QueryHookOptions<CheckCalibrationsOnAdminLevelQuery, CheckCalibrationsOnAdminLevelQueryVariables> & ({ variables: CheckCalibrationsOnAdminLevelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckCalibrationsOnAdminLevelQuery, CheckCalibrationsOnAdminLevelQueryVariables>(CheckCalibrationsOnAdminLevelDocument, options);
      }
export function useCheckCalibrationsOnAdminLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckCalibrationsOnAdminLevelQuery, CheckCalibrationsOnAdminLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckCalibrationsOnAdminLevelQuery, CheckCalibrationsOnAdminLevelQueryVariables>(CheckCalibrationsOnAdminLevelDocument, options);
        }
export function useCheckCalibrationsOnAdminLevelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckCalibrationsOnAdminLevelQuery, CheckCalibrationsOnAdminLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckCalibrationsOnAdminLevelQuery, CheckCalibrationsOnAdminLevelQueryVariables>(CheckCalibrationsOnAdminLevelDocument, options);
        }
export type CheckCalibrationsOnAdminLevelQueryHookResult = ReturnType<typeof useCheckCalibrationsOnAdminLevelQuery>;
export type CheckCalibrationsOnAdminLevelLazyQueryHookResult = ReturnType<typeof useCheckCalibrationsOnAdminLevelLazyQuery>;
export type CheckCalibrationsOnAdminLevelSuspenseQueryHookResult = ReturnType<typeof useCheckCalibrationsOnAdminLevelSuspenseQuery>;
export type CheckCalibrationsOnAdminLevelQueryResult = Apollo.QueryResult<CheckCalibrationsOnAdminLevelQuery, CheckCalibrationsOnAdminLevelQueryVariables>;
export const CheckCalibrationsOnPartnerLevelDocument = gql`
    query checkCalibrationsOnPartnerLevel($instanceId: String!) {
  checkCalibrationsOnPartnerLevel(instanceId: $instanceId)
}
    `;

/**
 * __useCheckCalibrationsOnPartnerLevelQuery__
 *
 * To run a query within a React component, call `useCheckCalibrationsOnPartnerLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCalibrationsOnPartnerLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCalibrationsOnPartnerLevelQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useCheckCalibrationsOnPartnerLevelQuery(baseOptions: Apollo.QueryHookOptions<CheckCalibrationsOnPartnerLevelQuery, CheckCalibrationsOnPartnerLevelQueryVariables> & ({ variables: CheckCalibrationsOnPartnerLevelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckCalibrationsOnPartnerLevelQuery, CheckCalibrationsOnPartnerLevelQueryVariables>(CheckCalibrationsOnPartnerLevelDocument, options);
      }
export function useCheckCalibrationsOnPartnerLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckCalibrationsOnPartnerLevelQuery, CheckCalibrationsOnPartnerLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckCalibrationsOnPartnerLevelQuery, CheckCalibrationsOnPartnerLevelQueryVariables>(CheckCalibrationsOnPartnerLevelDocument, options);
        }
export function useCheckCalibrationsOnPartnerLevelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckCalibrationsOnPartnerLevelQuery, CheckCalibrationsOnPartnerLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckCalibrationsOnPartnerLevelQuery, CheckCalibrationsOnPartnerLevelQueryVariables>(CheckCalibrationsOnPartnerLevelDocument, options);
        }
export type CheckCalibrationsOnPartnerLevelQueryHookResult = ReturnType<typeof useCheckCalibrationsOnPartnerLevelQuery>;
export type CheckCalibrationsOnPartnerLevelLazyQueryHookResult = ReturnType<typeof useCheckCalibrationsOnPartnerLevelLazyQuery>;
export type CheckCalibrationsOnPartnerLevelSuspenseQueryHookResult = ReturnType<typeof useCheckCalibrationsOnPartnerLevelSuspenseQuery>;
export type CheckCalibrationsOnPartnerLevelQueryResult = Apollo.QueryResult<CheckCalibrationsOnPartnerLevelQuery, CheckCalibrationsOnPartnerLevelQueryVariables>;
export const CheckDowntimeAnnouncementStatusDocument = gql`
    query checkDowntimeAnnouncementStatus {
  checkDowntimeAnnouncementStatus {
    active
    message
  }
}
    `;

/**
 * __useCheckDowntimeAnnouncementStatusQuery__
 *
 * To run a query within a React component, call `useCheckDowntimeAnnouncementStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDowntimeAnnouncementStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDowntimeAnnouncementStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckDowntimeAnnouncementStatusQuery(baseOptions?: Apollo.QueryHookOptions<CheckDowntimeAnnouncementStatusQuery, CheckDowntimeAnnouncementStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckDowntimeAnnouncementStatusQuery, CheckDowntimeAnnouncementStatusQueryVariables>(CheckDowntimeAnnouncementStatusDocument, options);
      }
export function useCheckDowntimeAnnouncementStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckDowntimeAnnouncementStatusQuery, CheckDowntimeAnnouncementStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckDowntimeAnnouncementStatusQuery, CheckDowntimeAnnouncementStatusQueryVariables>(CheckDowntimeAnnouncementStatusDocument, options);
        }
export function useCheckDowntimeAnnouncementStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckDowntimeAnnouncementStatusQuery, CheckDowntimeAnnouncementStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckDowntimeAnnouncementStatusQuery, CheckDowntimeAnnouncementStatusQueryVariables>(CheckDowntimeAnnouncementStatusDocument, options);
        }
export type CheckDowntimeAnnouncementStatusQueryHookResult = ReturnType<typeof useCheckDowntimeAnnouncementStatusQuery>;
export type CheckDowntimeAnnouncementStatusLazyQueryHookResult = ReturnType<typeof useCheckDowntimeAnnouncementStatusLazyQuery>;
export type CheckDowntimeAnnouncementStatusSuspenseQueryHookResult = ReturnType<typeof useCheckDowntimeAnnouncementStatusSuspenseQuery>;
export type CheckDowntimeAnnouncementStatusQueryResult = Apollo.QueryResult<CheckDowntimeAnnouncementStatusQuery, CheckDowntimeAnnouncementStatusQueryVariables>;
export const CheckIfACalibrationExistsUsingTicketUrlDocument = gql`
    query checkIfACalibrationExistsUsingTicketURL($ticketURL: String!, $instanceId: String!) {
  checkIfACalibrationExistsUsingTicketURL(
    ticketURL: $ticketURL
    instanceId: $instanceId
  )
}
    `;

/**
 * __useCheckIfACalibrationExistsUsingTicketUrlQuery__
 *
 * To run a query within a React component, call `useCheckIfACalibrationExistsUsingTicketUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfACalibrationExistsUsingTicketUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfACalibrationExistsUsingTicketUrlQuery({
 *   variables: {
 *      ticketURL: // value for 'ticketURL'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useCheckIfACalibrationExistsUsingTicketUrlQuery(baseOptions: Apollo.QueryHookOptions<CheckIfACalibrationExistsUsingTicketUrlQuery, CheckIfACalibrationExistsUsingTicketUrlQueryVariables> & ({ variables: CheckIfACalibrationExistsUsingTicketUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIfACalibrationExistsUsingTicketUrlQuery, CheckIfACalibrationExistsUsingTicketUrlQueryVariables>(CheckIfACalibrationExistsUsingTicketUrlDocument, options);
      }
export function useCheckIfACalibrationExistsUsingTicketUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIfACalibrationExistsUsingTicketUrlQuery, CheckIfACalibrationExistsUsingTicketUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIfACalibrationExistsUsingTicketUrlQuery, CheckIfACalibrationExistsUsingTicketUrlQueryVariables>(CheckIfACalibrationExistsUsingTicketUrlDocument, options);
        }
export function useCheckIfACalibrationExistsUsingTicketUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckIfACalibrationExistsUsingTicketUrlQuery, CheckIfACalibrationExistsUsingTicketUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckIfACalibrationExistsUsingTicketUrlQuery, CheckIfACalibrationExistsUsingTicketUrlQueryVariables>(CheckIfACalibrationExistsUsingTicketUrlDocument, options);
        }
export type CheckIfACalibrationExistsUsingTicketUrlQueryHookResult = ReturnType<typeof useCheckIfACalibrationExistsUsingTicketUrlQuery>;
export type CheckIfACalibrationExistsUsingTicketUrlLazyQueryHookResult = ReturnType<typeof useCheckIfACalibrationExistsUsingTicketUrlLazyQuery>;
export type CheckIfACalibrationExistsUsingTicketUrlSuspenseQueryHookResult = ReturnType<typeof useCheckIfACalibrationExistsUsingTicketUrlSuspenseQuery>;
export type CheckIfACalibrationExistsUsingTicketUrlQueryResult = Apollo.QueryResult<CheckIfACalibrationExistsUsingTicketUrlQuery, CheckIfACalibrationExistsUsingTicketUrlQueryVariables>;
export const CheckMaintenanceStatusDocument = gql`
    query CheckMaintenanceStatus {
  checkMaintenanceStatus {
    active
    endTime
    startTime
    message
  }
}
    `;

/**
 * __useCheckMaintenanceStatusQuery__
 *
 * To run a query within a React component, call `useCheckMaintenanceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckMaintenanceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckMaintenanceStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckMaintenanceStatusQuery(baseOptions?: Apollo.QueryHookOptions<CheckMaintenanceStatusQuery, CheckMaintenanceStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckMaintenanceStatusQuery, CheckMaintenanceStatusQueryVariables>(CheckMaintenanceStatusDocument, options);
      }
export function useCheckMaintenanceStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckMaintenanceStatusQuery, CheckMaintenanceStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckMaintenanceStatusQuery, CheckMaintenanceStatusQueryVariables>(CheckMaintenanceStatusDocument, options);
        }
export function useCheckMaintenanceStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckMaintenanceStatusQuery, CheckMaintenanceStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckMaintenanceStatusQuery, CheckMaintenanceStatusQueryVariables>(CheckMaintenanceStatusDocument, options);
        }
export type CheckMaintenanceStatusQueryHookResult = ReturnType<typeof useCheckMaintenanceStatusQuery>;
export type CheckMaintenanceStatusLazyQueryHookResult = ReturnType<typeof useCheckMaintenanceStatusLazyQuery>;
export type CheckMaintenanceStatusSuspenseQueryHookResult = ReturnType<typeof useCheckMaintenanceStatusSuspenseQuery>;
export type CheckMaintenanceStatusQueryResult = Apollo.QueryResult<CheckMaintenanceStatusQuery, CheckMaintenanceStatusQueryVariables>;
export const CreateCsvForReviewsFromFirestoreDocument = gql`
    query createCSVForReviewsFromFirestore($instanceId: String!, $rubricId: String!, $partnerName: String!, $CSVType: CSVType!, $reviewsFilteredInTheDashboard: [ReviewsFilteredInTheDashboard!]) {
  createCSVForReviewsFromFirestore(
    instanceId: $instanceId
    rubricId: $rubricId
    partnerName: $partnerName
    CSVType: $CSVType
    reviewsFilteredInTheDashboard: $reviewsFilteredInTheDashboard
  ) {
    data {
      categories {
        name
        maxScore
        score
        scoreWeight
        subCategories {
          score
          comment
          weight
        }
      }
      assignee
      assigneeEmail
      reviewer
      reviewerEmail
      ticketNumber
      reviewStartedAt
      reviewCompletedAt
      handleTime
      reviewUpdatedAt
      additional_feedback
      auto_fail
      review_acknowledged
      total
      tags
    }
    headers {
      label
      key
      access
    }
    filename
  }
}
    `;

/**
 * __useCreateCsvForReviewsFromFirestoreQuery__
 *
 * To run a query within a React component, call `useCreateCsvForReviewsFromFirestoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateCsvForReviewsFromFirestoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateCsvForReviewsFromFirestoreQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      rubricId: // value for 'rubricId'
 *      partnerName: // value for 'partnerName'
 *      CSVType: // value for 'CSVType'
 *      reviewsFilteredInTheDashboard: // value for 'reviewsFilteredInTheDashboard'
 *   },
 * });
 */
export function useCreateCsvForReviewsFromFirestoreQuery(baseOptions: Apollo.QueryHookOptions<CreateCsvForReviewsFromFirestoreQuery, CreateCsvForReviewsFromFirestoreQueryVariables> & ({ variables: CreateCsvForReviewsFromFirestoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateCsvForReviewsFromFirestoreQuery, CreateCsvForReviewsFromFirestoreQueryVariables>(CreateCsvForReviewsFromFirestoreDocument, options);
      }
export function useCreateCsvForReviewsFromFirestoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateCsvForReviewsFromFirestoreQuery, CreateCsvForReviewsFromFirestoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateCsvForReviewsFromFirestoreQuery, CreateCsvForReviewsFromFirestoreQueryVariables>(CreateCsvForReviewsFromFirestoreDocument, options);
        }
export function useCreateCsvForReviewsFromFirestoreSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateCsvForReviewsFromFirestoreQuery, CreateCsvForReviewsFromFirestoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateCsvForReviewsFromFirestoreQuery, CreateCsvForReviewsFromFirestoreQueryVariables>(CreateCsvForReviewsFromFirestoreDocument, options);
        }
export type CreateCsvForReviewsFromFirestoreQueryHookResult = ReturnType<typeof useCreateCsvForReviewsFromFirestoreQuery>;
export type CreateCsvForReviewsFromFirestoreLazyQueryHookResult = ReturnType<typeof useCreateCsvForReviewsFromFirestoreLazyQuery>;
export type CreateCsvForReviewsFromFirestoreSuspenseQueryHookResult = ReturnType<typeof useCreateCsvForReviewsFromFirestoreSuspenseQuery>;
export type CreateCsvForReviewsFromFirestoreQueryResult = Apollo.QueryResult<CreateCsvForReviewsFromFirestoreQuery, CreateCsvForReviewsFromFirestoreQueryVariables>;
export const FirestoreUserDocument = gql`
    query FirestoreUser($where: FirestoreUserWhere, $order: FirestoreUserOrder) {
  firestoreUser(where: $where, order: $order) {
    id
    uid
    organizationAuthId
    instanceId
    organizationId
    email
    status
    firstName
    lastName
    displayName
    pronouns
    hasTakenTour
    notificationSettings {
      reviewDeleted
      reviewReceived
      reviewWithAutofail
      reviewAcknowledged
    }
    photoURL
    teamId
    roles
    waizenOnboarding {
      connectToApplication
      createRubrics
      setupExtension
      setupTeam
    }
    authIdentities {
      provider
      authId
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useFirestoreUserQuery__
 *
 * To run a query within a React component, call `useFirestoreUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirestoreUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirestoreUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useFirestoreUserQuery(baseOptions?: Apollo.QueryHookOptions<FirestoreUserQuery, FirestoreUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FirestoreUserQuery, FirestoreUserQueryVariables>(FirestoreUserDocument, options);
      }
export function useFirestoreUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FirestoreUserQuery, FirestoreUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FirestoreUserQuery, FirestoreUserQueryVariables>(FirestoreUserDocument, options);
        }
export function useFirestoreUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FirestoreUserQuery, FirestoreUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FirestoreUserQuery, FirestoreUserQueryVariables>(FirestoreUserDocument, options);
        }
export type FirestoreUserQueryHookResult = ReturnType<typeof useFirestoreUserQuery>;
export type FirestoreUserLazyQueryHookResult = ReturnType<typeof useFirestoreUserLazyQuery>;
export type FirestoreUserSuspenseQueryHookResult = ReturnType<typeof useFirestoreUserSuspenseQuery>;
export type FirestoreUserQueryResult = Apollo.QueryResult<FirestoreUserQuery, FirestoreUserQueryVariables>;
export const FirestoreUsersDocument = gql`
    query FirestoreUsers($where: FirestoreUserWhere, $order: FirestoreUserOrder, $limit: Int) {
  firestoreUsers(where: $where, order: $order, limit: $limit) {
    id
    uid
    organizationAuthId
    instanceId
    organizationId
    email
    status
    firstName
    lastName
    displayName
    pronouns
    hasTakenTour
    notificationSettings {
      reviewDeleted
      reviewReceived
      reviewWithAutofail
      reviewAcknowledged
    }
    photoURL
    teamId
    roles
    waizenOnboarding {
      connectToApplication
      createRubrics
      setupExtension
      setupTeam
    }
    authIdentities {
      provider
      authId
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useFirestoreUsersQuery__
 *
 * To run a query within a React component, call `useFirestoreUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirestoreUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirestoreUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFirestoreUsersQuery(baseOptions?: Apollo.QueryHookOptions<FirestoreUsersQuery, FirestoreUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FirestoreUsersQuery, FirestoreUsersQueryVariables>(FirestoreUsersDocument, options);
      }
export function useFirestoreUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FirestoreUsersQuery, FirestoreUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FirestoreUsersQuery, FirestoreUsersQueryVariables>(FirestoreUsersDocument, options);
        }
export function useFirestoreUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FirestoreUsersQuery, FirestoreUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FirestoreUsersQuery, FirestoreUsersQueryVariables>(FirestoreUsersDocument, options);
        }
export type FirestoreUsersQueryHookResult = ReturnType<typeof useFirestoreUsersQuery>;
export type FirestoreUsersLazyQueryHookResult = ReturnType<typeof useFirestoreUsersLazyQuery>;
export type FirestoreUsersSuspenseQueryHookResult = ReturnType<typeof useFirestoreUsersSuspenseQuery>;
export type FirestoreUsersQueryResult = Apollo.QueryResult<FirestoreUsersQuery, FirestoreUsersQueryVariables>;
export const CreateCsvForArchivedReviewsDocument = gql`
    query createCSVForArchivedReviews($instanceId: String!, $rubricId: String!, $partnerName: String!) {
  createCSVForArchivedReviews(
    instanceId: $instanceId
    rubricId: $rubricId
    partnerName: $partnerName
  ) {
    data {
      categories {
        name
        maxScore
        score
        scoreWeight
        subCategories {
          score
          comment
          weight
        }
      }
      assignee
      assigneeEmail
      reviewer
      reviewerEmail
      ticketNumber
      reviewStartedAt
      reviewCompletedAt
      handleTime
      additional_feedback
      total
      auto_fail
      review_acknowledged
    }
    headers {
      label
      key
      access
    }
    filename
  }
}
    `;

/**
 * __useCreateCsvForArchivedReviewsQuery__
 *
 * To run a query within a React component, call `useCreateCsvForArchivedReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateCsvForArchivedReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateCsvForArchivedReviewsQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      rubricId: // value for 'rubricId'
 *      partnerName: // value for 'partnerName'
 *   },
 * });
 */
export function useCreateCsvForArchivedReviewsQuery(baseOptions: Apollo.QueryHookOptions<CreateCsvForArchivedReviewsQuery, CreateCsvForArchivedReviewsQueryVariables> & ({ variables: CreateCsvForArchivedReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateCsvForArchivedReviewsQuery, CreateCsvForArchivedReviewsQueryVariables>(CreateCsvForArchivedReviewsDocument, options);
      }
export function useCreateCsvForArchivedReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateCsvForArchivedReviewsQuery, CreateCsvForArchivedReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateCsvForArchivedReviewsQuery, CreateCsvForArchivedReviewsQueryVariables>(CreateCsvForArchivedReviewsDocument, options);
        }
export function useCreateCsvForArchivedReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateCsvForArchivedReviewsQuery, CreateCsvForArchivedReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateCsvForArchivedReviewsQuery, CreateCsvForArchivedReviewsQueryVariables>(CreateCsvForArchivedReviewsDocument, options);
        }
export type CreateCsvForArchivedReviewsQueryHookResult = ReturnType<typeof useCreateCsvForArchivedReviewsQuery>;
export type CreateCsvForArchivedReviewsLazyQueryHookResult = ReturnType<typeof useCreateCsvForArchivedReviewsLazyQuery>;
export type CreateCsvForArchivedReviewsSuspenseQueryHookResult = ReturnType<typeof useCreateCsvForArchivedReviewsSuspenseQuery>;
export type CreateCsvForArchivedReviewsQueryResult = Apollo.QueryResult<CreateCsvForArchivedReviewsQuery, CreateCsvForArchivedReviewsQueryVariables>;
export const GetCalibrationDocument = gql`
    query getCalibration($calibrationId: String!, $userEmail: String!, $instanceId: String!) {
  getCalibration(
    calibrationId: $calibrationId
    userEmail: $userEmail
    instanceId: $instanceId
  ) {
    calibratorUid
    calibrationId
    calibrationReviewId
    mostAlignedQuestion
    overallAlignmentScore
    leastAlignedQuestion
    alignmentByQuestion {
      selectedScore
      alignmentScore
      questionName
      measurementType
      categoryId
      questionId
    }
    instanceId
    name
    rubricId
    startedAt
    completedAt
    status
    teamId
    url
    calibrationEvaluators {
      evaluatorName
      evaluatorUid
      evaluatorName
      evaluatorEmail
      evaluatorPhotoURL
      calibrationId
      calibrationStatus
      calibrationScoreID
      isCalibrator
      mostAlignedQuestion
      leastAlignedQuestion
      overallAlignmentScore
      alignmentByQuestion {
        selectedScore
        alignmentScore
        questionName
        measurementType
        categoryId
        questionId
      }
    }
  }
}
    `;

/**
 * __useGetCalibrationQuery__
 *
 * To run a query within a React component, call `useGetCalibrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalibrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalibrationQuery({
 *   variables: {
 *      calibrationId: // value for 'calibrationId'
 *      userEmail: // value for 'userEmail'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useGetCalibrationQuery(baseOptions: Apollo.QueryHookOptions<GetCalibrationQuery, GetCalibrationQueryVariables> & ({ variables: GetCalibrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalibrationQuery, GetCalibrationQueryVariables>(GetCalibrationDocument, options);
      }
export function useGetCalibrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalibrationQuery, GetCalibrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalibrationQuery, GetCalibrationQueryVariables>(GetCalibrationDocument, options);
        }
export function useGetCalibrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCalibrationQuery, GetCalibrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalibrationQuery, GetCalibrationQueryVariables>(GetCalibrationDocument, options);
        }
export type GetCalibrationQueryHookResult = ReturnType<typeof useGetCalibrationQuery>;
export type GetCalibrationLazyQueryHookResult = ReturnType<typeof useGetCalibrationLazyQuery>;
export type GetCalibrationSuspenseQueryHookResult = ReturnType<typeof useGetCalibrationSuspenseQuery>;
export type GetCalibrationQueryResult = Apollo.QueryResult<GetCalibrationQuery, GetCalibrationQueryVariables>;
export const GetCalibrationAnalyticsPerEvaluatorDocument = gql`
    query getCalibrationAnalyticsPerEvaluator($startTime: Int!, $endTime: Int!, $rubricId: String!, $userIds: [String!]!, $userEmail: String!, $instanceId: String!) {
  getCalibrationAnalyticsPerEvaluator(
    input: {startTime: $startTime, endTime: $endTime, rubricId: $rubricId, userIds: $userIds, userEmail: $userEmail, instanceId: $instanceId}
  ) {
    mostAlignedQuestion
    overallAlignmentScore
    leastAlignedQuestion
    alignmentByQuestion {
      alignmentScore
      questionName
      categoryId
      questionId
    }
    amountOfCalibrationEvaluated
    arePendingCalibrations
    calibrations {
      calibrationId
      name
      url
    }
  }
}
    `;

/**
 * __useGetCalibrationAnalyticsPerEvaluatorQuery__
 *
 * To run a query within a React component, call `useGetCalibrationAnalyticsPerEvaluatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalibrationAnalyticsPerEvaluatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalibrationAnalyticsPerEvaluatorQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      rubricId: // value for 'rubricId'
 *      userIds: // value for 'userIds'
 *      userEmail: // value for 'userEmail'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useGetCalibrationAnalyticsPerEvaluatorQuery(baseOptions: Apollo.QueryHookOptions<GetCalibrationAnalyticsPerEvaluatorQuery, GetCalibrationAnalyticsPerEvaluatorQueryVariables> & ({ variables: GetCalibrationAnalyticsPerEvaluatorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalibrationAnalyticsPerEvaluatorQuery, GetCalibrationAnalyticsPerEvaluatorQueryVariables>(GetCalibrationAnalyticsPerEvaluatorDocument, options);
      }
export function useGetCalibrationAnalyticsPerEvaluatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalibrationAnalyticsPerEvaluatorQuery, GetCalibrationAnalyticsPerEvaluatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalibrationAnalyticsPerEvaluatorQuery, GetCalibrationAnalyticsPerEvaluatorQueryVariables>(GetCalibrationAnalyticsPerEvaluatorDocument, options);
        }
export function useGetCalibrationAnalyticsPerEvaluatorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCalibrationAnalyticsPerEvaluatorQuery, GetCalibrationAnalyticsPerEvaluatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalibrationAnalyticsPerEvaluatorQuery, GetCalibrationAnalyticsPerEvaluatorQueryVariables>(GetCalibrationAnalyticsPerEvaluatorDocument, options);
        }
export type GetCalibrationAnalyticsPerEvaluatorQueryHookResult = ReturnType<typeof useGetCalibrationAnalyticsPerEvaluatorQuery>;
export type GetCalibrationAnalyticsPerEvaluatorLazyQueryHookResult = ReturnType<typeof useGetCalibrationAnalyticsPerEvaluatorLazyQuery>;
export type GetCalibrationAnalyticsPerEvaluatorSuspenseQueryHookResult = ReturnType<typeof useGetCalibrationAnalyticsPerEvaluatorSuspenseQuery>;
export type GetCalibrationAnalyticsPerEvaluatorQueryResult = Apollo.QueryResult<GetCalibrationAnalyticsPerEvaluatorQuery, GetCalibrationAnalyticsPerEvaluatorQueryVariables>;
export const GetCalibrationHistoryCardsDocument = gql`
    query getCalibrationHistoryCards($startTime: Int!, $endTime: Int!, $userIds: [String!]!, $rubricsId: [String!]!, $instanceId: String!, $userEmail: String!) {
  getCalibrationHistoryCards(
    input: {startTime: $startTime, endTime: $endTime, userIds: $userIds, rubricsId: $rubricsId, instanceId: $instanceId, userEmail: $userEmail}
  ) {
    name
    calibrationId
    startedAt
    status
    rubricId
    mostAlignedQuestion
    leastAlignedQuestion
    overallAlignmentScore
    completedAt
    url
    status
    calibratorUid
    calibratorName
  }
}
    `;

/**
 * __useGetCalibrationHistoryCardsQuery__
 *
 * To run a query within a React component, call `useGetCalibrationHistoryCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalibrationHistoryCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalibrationHistoryCardsQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      userIds: // value for 'userIds'
 *      rubricsId: // value for 'rubricsId'
 *      instanceId: // value for 'instanceId'
 *      userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function useGetCalibrationHistoryCardsQuery(baseOptions: Apollo.QueryHookOptions<GetCalibrationHistoryCardsQuery, GetCalibrationHistoryCardsQueryVariables> & ({ variables: GetCalibrationHistoryCardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalibrationHistoryCardsQuery, GetCalibrationHistoryCardsQueryVariables>(GetCalibrationHistoryCardsDocument, options);
      }
export function useGetCalibrationHistoryCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalibrationHistoryCardsQuery, GetCalibrationHistoryCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalibrationHistoryCardsQuery, GetCalibrationHistoryCardsQueryVariables>(GetCalibrationHistoryCardsDocument, options);
        }
export function useGetCalibrationHistoryCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCalibrationHistoryCardsQuery, GetCalibrationHistoryCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalibrationHistoryCardsQuery, GetCalibrationHistoryCardsQueryVariables>(GetCalibrationHistoryCardsDocument, options);
        }
export type GetCalibrationHistoryCardsQueryHookResult = ReturnType<typeof useGetCalibrationHistoryCardsQuery>;
export type GetCalibrationHistoryCardsLazyQueryHookResult = ReturnType<typeof useGetCalibrationHistoryCardsLazyQuery>;
export type GetCalibrationHistoryCardsSuspenseQueryHookResult = ReturnType<typeof useGetCalibrationHistoryCardsSuspenseQuery>;
export type GetCalibrationHistoryCardsQueryResult = Apollo.QueryResult<GetCalibrationHistoryCardsQuery, GetCalibrationHistoryCardsQueryVariables>;
export const GetCalibrationScoreByIdDocument = gql`
    query GetCalibrationScoreById($instanceId: String!, $calibrationScoreKey: String!) {
  getCalibrationScoreById(
    instanceId: $instanceId
    calibrationScoreKey: $calibrationScoreKey
  ) {
    asigneeUid
    engine
    folderId
    instanceId
    manualAssignment
    objectType
    reviewDate
    rubricId
    status
    teamId
    ticketId
    totalScore
    type
    uid
    url
    scoreByCategory {
      keyId
      binaryLabel
      categoryId
      categoryName
      categoryPoints
      highValue
      lowValue
      measurementType
      orderIndex
      score
      scorePercentage
      requireComments
    }
    scoreBySubCategory {
      keyId
      objectType
      parentCategoryId
      reviewed
      score
      scorePercentage
      subCategoryId
      subCategoryName
      totalPoints
      autofail
      requireComment
      comment {
        categoryId
        comment
        index
        objectType
        subCategoryId
        ticketScoreId
      }
    }
    assigneeData {
      name
      photoURL
      email
      secondaryEmail
    }
    reviewerData {
      name
      photoURL
      email
      secondaryEmail
    }
    autofailPresent
    acknowledged
    acknowledgedAt
    calibrationId
  }
}
    `;

/**
 * __useGetCalibrationScoreByIdQuery__
 *
 * To run a query within a React component, call `useGetCalibrationScoreByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalibrationScoreByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalibrationScoreByIdQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      calibrationScoreKey: // value for 'calibrationScoreKey'
 *   },
 * });
 */
export function useGetCalibrationScoreByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCalibrationScoreByIdQuery, GetCalibrationScoreByIdQueryVariables> & ({ variables: GetCalibrationScoreByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalibrationScoreByIdQuery, GetCalibrationScoreByIdQueryVariables>(GetCalibrationScoreByIdDocument, options);
      }
export function useGetCalibrationScoreByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalibrationScoreByIdQuery, GetCalibrationScoreByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalibrationScoreByIdQuery, GetCalibrationScoreByIdQueryVariables>(GetCalibrationScoreByIdDocument, options);
        }
export function useGetCalibrationScoreByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCalibrationScoreByIdQuery, GetCalibrationScoreByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalibrationScoreByIdQuery, GetCalibrationScoreByIdQueryVariables>(GetCalibrationScoreByIdDocument, options);
        }
export type GetCalibrationScoreByIdQueryHookResult = ReturnType<typeof useGetCalibrationScoreByIdQuery>;
export type GetCalibrationScoreByIdLazyQueryHookResult = ReturnType<typeof useGetCalibrationScoreByIdLazyQuery>;
export type GetCalibrationScoreByIdSuspenseQueryHookResult = ReturnType<typeof useGetCalibrationScoreByIdSuspenseQuery>;
export type GetCalibrationScoreByIdQueryResult = Apollo.QueryResult<GetCalibrationScoreByIdQuery, GetCalibrationScoreByIdQueryVariables>;
export const GetCalibrationScoreWithCommentsDocument = gql`
    query getCalibrationScoreWithComments($input: CalibrationScoreInput!) {
  getCalibrationScoreWithComments(input: $input) {
    asigneeUid
    engine
    folderId
    instanceId
    manualAssignment
    objectType
    reviewDate
    rubricId
    status
    teamId
    ticketId
    totalScore
    type
    uid
    url
    scoreByCategory {
      keyId
      binaryLabel
      categoryId
      categoryName
      categoryPoints
      highValue
      lowValue
      measurementType
      measurementOptions {
        label
        value
      }
      orderIndex
      score
      scorePercentage
      requireComments
    }
    scoreBySubCategory {
      keyId
      objectType
      parentCategoryId
      reviewed
      score
      scorePercentage
      subCategoryId
      subCategoryName
      totalPoints
      autofail
      requireComment
      comment {
        categoryId
        comment
        index
        objectType
        subCategoryId
        ticketScoreId
      }
    }
    assigneeData {
      name
      photoURL
      email
      secondaryEmail
    }
    reviewerData {
      name
      photoURL
      email
      secondaryEmail
    }
    autofailPresent
    acknowledged
    acknowledgedAt
    calibrationId
    isCalibrationKey
  }
}
    `;

/**
 * __useGetCalibrationScoreWithCommentsQuery__
 *
 * To run a query within a React component, call `useGetCalibrationScoreWithCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalibrationScoreWithCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalibrationScoreWithCommentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCalibrationScoreWithCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetCalibrationScoreWithCommentsQuery, GetCalibrationScoreWithCommentsQueryVariables> & ({ variables: GetCalibrationScoreWithCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalibrationScoreWithCommentsQuery, GetCalibrationScoreWithCommentsQueryVariables>(GetCalibrationScoreWithCommentsDocument, options);
      }
export function useGetCalibrationScoreWithCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalibrationScoreWithCommentsQuery, GetCalibrationScoreWithCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalibrationScoreWithCommentsQuery, GetCalibrationScoreWithCommentsQueryVariables>(GetCalibrationScoreWithCommentsDocument, options);
        }
export function useGetCalibrationScoreWithCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCalibrationScoreWithCommentsQuery, GetCalibrationScoreWithCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalibrationScoreWithCommentsQuery, GetCalibrationScoreWithCommentsQueryVariables>(GetCalibrationScoreWithCommentsDocument, options);
        }
export type GetCalibrationScoreWithCommentsQueryHookResult = ReturnType<typeof useGetCalibrationScoreWithCommentsQuery>;
export type GetCalibrationScoreWithCommentsLazyQueryHookResult = ReturnType<typeof useGetCalibrationScoreWithCommentsLazyQuery>;
export type GetCalibrationScoreWithCommentsSuspenseQueryHookResult = ReturnType<typeof useGetCalibrationScoreWithCommentsSuspenseQuery>;
export type GetCalibrationScoreWithCommentsQueryResult = Apollo.QueryResult<GetCalibrationScoreWithCommentsQuery, GetCalibrationScoreWithCommentsQueryVariables>;
export const GetConnectionDocument = gql`
    query getConnection($getConnectionInput: GetConnectionInput!) {
  connection(input: $getConnectionInput) {
    active
    configuration {
      auditData
      eventData
      ticketData
    }
    connectorInstanceId
    credentialId
    initTimestamp
    organizationId
    streams
    subdomain
    system
    metadata
  }
}
    `;

/**
 * __useGetConnectionQuery__
 *
 * To run a query within a React component, call `useGetConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectionQuery({
 *   variables: {
 *      getConnectionInput: // value for 'getConnectionInput'
 *   },
 * });
 */
export function useGetConnectionQuery(baseOptions: Apollo.QueryHookOptions<GetConnectionQuery, GetConnectionQueryVariables> & ({ variables: GetConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectionQuery, GetConnectionQueryVariables>(GetConnectionDocument, options);
      }
export function useGetConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectionQuery, GetConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectionQuery, GetConnectionQueryVariables>(GetConnectionDocument, options);
        }
export function useGetConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConnectionQuery, GetConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConnectionQuery, GetConnectionQueryVariables>(GetConnectionDocument, options);
        }
export type GetConnectionQueryHookResult = ReturnType<typeof useGetConnectionQuery>;
export type GetConnectionLazyQueryHookResult = ReturnType<typeof useGetConnectionLazyQuery>;
export type GetConnectionSuspenseQueryHookResult = ReturnType<typeof useGetConnectionSuspenseQuery>;
export type GetConnectionQueryResult = Apollo.QueryResult<GetConnectionQuery, GetConnectionQueryVariables>;
export const GetConnectionsDocument = gql`
    query getConnections($getConnectionInput: GetConnectionInput!) {
  connections(input: $getConnectionInput) {
    active
    configuration {
      auditData
      eventData
      ticketData
    }
    connectorInstanceId
    credentialId
    initTimestamp
    metadata
    organizationId
    streams
    subdomain
    system
  }
}
    `;

/**
 * __useGetConnectionsQuery__
 *
 * To run a query within a React component, call `useGetConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectionsQuery({
 *   variables: {
 *      getConnectionInput: // value for 'getConnectionInput'
 *   },
 * });
 */
export function useGetConnectionsQuery(baseOptions: Apollo.QueryHookOptions<GetConnectionsQuery, GetConnectionsQueryVariables> & ({ variables: GetConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectionsQuery, GetConnectionsQueryVariables>(GetConnectionsDocument, options);
      }
export function useGetConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectionsQuery, GetConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectionsQuery, GetConnectionsQueryVariables>(GetConnectionsDocument, options);
        }
export function useGetConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConnectionsQuery, GetConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConnectionsQuery, GetConnectionsQueryVariables>(GetConnectionsDocument, options);
        }
export type GetConnectionsQueryHookResult = ReturnType<typeof useGetConnectionsQuery>;
export type GetConnectionsLazyQueryHookResult = ReturnType<typeof useGetConnectionsLazyQuery>;
export type GetConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetConnectionsSuspenseQuery>;
export type GetConnectionsQueryResult = Apollo.QueryResult<GetConnectionsQuery, GetConnectionsQueryVariables>;
export const GetDashboardReviewsDocument = gql`
    query GetDashboardReviews($getReviewsArgs: GetReviewsArgs!) {
  getDashboardReviews(getReviewsArgs: $getReviewsArgs) {
    isAcknowledged
    isArchived
    isAutofailed
    reviewId
    assigneeId
    reviewStartedAt
    reviewURL
    totalScore
    tags
    reviewerPhotoURL
    reviewerName
    reviewerId
    teamId
    assigneeName
    rubricName
    reviewCompletedAt
    handleTime
    status
  }
}
    `;

/**
 * __useGetDashboardReviewsQuery__
 *
 * To run a query within a React component, call `useGetDashboardReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardReviewsQuery({
 *   variables: {
 *      getReviewsArgs: // value for 'getReviewsArgs'
 *   },
 * });
 */
export function useGetDashboardReviewsQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardReviewsQuery, GetDashboardReviewsQueryVariables> & ({ variables: GetDashboardReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardReviewsQuery, GetDashboardReviewsQueryVariables>(GetDashboardReviewsDocument, options);
      }
export function useGetDashboardReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardReviewsQuery, GetDashboardReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardReviewsQuery, GetDashboardReviewsQueryVariables>(GetDashboardReviewsDocument, options);
        }
export function useGetDashboardReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDashboardReviewsQuery, GetDashboardReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardReviewsQuery, GetDashboardReviewsQueryVariables>(GetDashboardReviewsDocument, options);
        }
export type GetDashboardReviewsQueryHookResult = ReturnType<typeof useGetDashboardReviewsQuery>;
export type GetDashboardReviewsLazyQueryHookResult = ReturnType<typeof useGetDashboardReviewsLazyQuery>;
export type GetDashboardReviewsSuspenseQueryHookResult = ReturnType<typeof useGetDashboardReviewsSuspenseQuery>;
export type GetDashboardReviewsQueryResult = Apollo.QueryResult<GetDashboardReviewsQuery, GetDashboardReviewsQueryVariables>;
export const GetDefaultRubricCategoriesDocument = gql`
    query GetDefaultRubricCategories {
  getDefaultRubricCategories
}
    `;

/**
 * __useGetDefaultRubricCategoriesQuery__
 *
 * To run a query within a React component, call `useGetDefaultRubricCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultRubricCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultRubricCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultRubricCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultRubricCategoriesQuery, GetDefaultRubricCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultRubricCategoriesQuery, GetDefaultRubricCategoriesQueryVariables>(GetDefaultRubricCategoriesDocument, options);
      }
export function useGetDefaultRubricCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultRubricCategoriesQuery, GetDefaultRubricCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultRubricCategoriesQuery, GetDefaultRubricCategoriesQueryVariables>(GetDefaultRubricCategoriesDocument, options);
        }
export function useGetDefaultRubricCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDefaultRubricCategoriesQuery, GetDefaultRubricCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDefaultRubricCategoriesQuery, GetDefaultRubricCategoriesQueryVariables>(GetDefaultRubricCategoriesDocument, options);
        }
export type GetDefaultRubricCategoriesQueryHookResult = ReturnType<typeof useGetDefaultRubricCategoriesQuery>;
export type GetDefaultRubricCategoriesLazyQueryHookResult = ReturnType<typeof useGetDefaultRubricCategoriesLazyQuery>;
export type GetDefaultRubricCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetDefaultRubricCategoriesSuspenseQuery>;
export type GetDefaultRubricCategoriesQueryResult = Apollo.QueryResult<GetDefaultRubricCategoriesQuery, GetDefaultRubricCategoriesQueryVariables>;
export const GetInvitesDocument = gql`
    query getInvites($organizationId: String!) {
  invitations(organizationId: $organizationId) {
    id
    organizationId
    organizationAuthId
    email
    inviterId
    createdAt
    expiresAt
    role
    status
  }
}
    `;

/**
 * __useGetInvitesQuery__
 *
 * To run a query within a React component, call `useGetInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetInvitesQuery(baseOptions: Apollo.QueryHookOptions<GetInvitesQuery, GetInvitesQueryVariables> & ({ variables: GetInvitesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvitesQuery, GetInvitesQueryVariables>(GetInvitesDocument, options);
      }
export function useGetInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvitesQuery, GetInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvitesQuery, GetInvitesQueryVariables>(GetInvitesDocument, options);
        }
export function useGetInvitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvitesQuery, GetInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvitesQuery, GetInvitesQueryVariables>(GetInvitesDocument, options);
        }
export type GetInvitesQueryHookResult = ReturnType<typeof useGetInvitesQuery>;
export type GetInvitesLazyQueryHookResult = ReturnType<typeof useGetInvitesLazyQuery>;
export type GetInvitesSuspenseQueryHookResult = ReturnType<typeof useGetInvitesSuspenseQuery>;
export type GetInvitesQueryResult = Apollo.QueryResult<GetInvitesQuery, GetInvitesQueryVariables>;
export const GetInsightDocument = gql`
    query GetInsight($instanceId: String!, $startDate: Int!, $endDate: Int!, $teamId: String, $reviewers: [String!], $assignees: [String!], $tags: [String!], $rubricId: [String!]) {
  getInsight(
    instanceId: $instanceId
    startDate: $startDate
    endDate: $endDate
    teamId: $teamId
    reviewers: $reviewers
    assignees: $assignees
    tags: $tags
    rubricId: $rubricId
  ) {
    sample
    qaScore
    errorFreeRate
    criticalErrorRate
    qaScoreVSample {
      category {
        label
      }
      dataset {
        seriesname
        data {
          value
        }
      }
    }
    performanceByTag {
      data {
        label
        value
      }
    }
    erfAndCre {
      category {
        label
      }
      dataset {
        seriesname
        data {
          value
        }
      }
    }
    rubricsScores {
      dataset {
        seriesname
        data {
          value
        }
      }
      category {
        label
      }
    }
    performanceByCategory {
      data {
        label
        value
      }
    }
    performanceByQuestion {
      data {
        label
        value
      }
    }
    associatesScores {
      header {
        Header
        accessor
      }
      data
    }
    markedDownByTag {
      header {
        accessor
        Header
      }
      data
    }
  }
}
    `;

/**
 * __useGetInsightQuery__
 *
 * To run a query within a React component, call `useGetInsightQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      teamId: // value for 'teamId'
 *      reviewers: // value for 'reviewers'
 *      assignees: // value for 'assignees'
 *      tags: // value for 'tags'
 *      rubricId: // value for 'rubricId'
 *   },
 * });
 */
export function useGetInsightQuery(baseOptions: Apollo.QueryHookOptions<GetInsightQuery, GetInsightQueryVariables> & ({ variables: GetInsightQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightQuery, GetInsightQueryVariables>(GetInsightDocument, options);
      }
export function useGetInsightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightQuery, GetInsightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightQuery, GetInsightQueryVariables>(GetInsightDocument, options);
        }
export function useGetInsightSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInsightQuery, GetInsightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsightQuery, GetInsightQueryVariables>(GetInsightDocument, options);
        }
export type GetInsightQueryHookResult = ReturnType<typeof useGetInsightQuery>;
export type GetInsightLazyQueryHookResult = ReturnType<typeof useGetInsightLazyQuery>;
export type GetInsightSuspenseQueryHookResult = ReturnType<typeof useGetInsightSuspenseQuery>;
export type GetInsightQueryResult = Apollo.QueryResult<GetInsightQuery, GetInsightQueryVariables>;
export const GetOrganizationDocument = gql`
    query GetOrganization($where: OrganizationWhere!) {
  organization(where: $where) {
    instanceId
    organizationAuthId
    name
    CRMURL
    adminEmail
    adminUid
    defaultTeamView
    engine
    rubricId
    privateReviews
    teams {
      key
      name
      teamLeaderUid
    }
    approvedTags {
      tagValue
      tagId
    }
    isExternal
    isTesting
    tenantUrl
    id
    authId
    documentId
    displayName
    description
    timezone
    groups
    status
    billingStatus
    userAmount
    createdAt
    createdBy
    updatedAt
    updatedBy
    customerId
    subscriptionId
    settings {
      extension {
        showScoreInput
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables> & ({ variables: GetOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationSuspenseQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const GetOrganizationByInstanceIdDocument = gql`
    query getOrganizationByInstanceId($instanceId: String!) {
  organization(where: {instanceId: $instanceId}) {
    adminEmail
    adminUid
    CRMURL
    defaultTeamView
    engine
    instanceId
    name
    rubricId
    privateReviews
    teams {
      key
      name
      teamLeaderUid
    }
    approvedTags {
      tagValue
      tagId
    }
    organizationAuthId
    createdAt
    createdBy
    updatedAt
    updatedBy
    userAmount
    settings {
      extension {
        showScoreInput
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationByInstanceIdQuery__
 *
 * To run a query within a React component, call `useGetOrganizationByInstanceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationByInstanceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationByInstanceIdQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useGetOrganizationByInstanceIdQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationByInstanceIdQuery, GetOrganizationByInstanceIdQueryVariables> & ({ variables: GetOrganizationByInstanceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationByInstanceIdQuery, GetOrganizationByInstanceIdQueryVariables>(GetOrganizationByInstanceIdDocument, options);
      }
export function useGetOrganizationByInstanceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationByInstanceIdQuery, GetOrganizationByInstanceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationByInstanceIdQuery, GetOrganizationByInstanceIdQueryVariables>(GetOrganizationByInstanceIdDocument, options);
        }
export function useGetOrganizationByInstanceIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationByInstanceIdQuery, GetOrganizationByInstanceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationByInstanceIdQuery, GetOrganizationByInstanceIdQueryVariables>(GetOrganizationByInstanceIdDocument, options);
        }
export type GetOrganizationByInstanceIdQueryHookResult = ReturnType<typeof useGetOrganizationByInstanceIdQuery>;
export type GetOrganizationByInstanceIdLazyQueryHookResult = ReturnType<typeof useGetOrganizationByInstanceIdLazyQuery>;
export type GetOrganizationByInstanceIdSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationByInstanceIdSuspenseQuery>;
export type GetOrganizationByInstanceIdQueryResult = Apollo.QueryResult<GetOrganizationByInstanceIdQuery, GetOrganizationByInstanceIdQueryVariables>;
export const GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreDocument = gql`
    query getPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestore($startAt: Int!, $endAt: Int!, $instanceId: String!, $rubricsId: [String!]!, $teamsId: [String!]!, $reviewType: ReviewTypeFilterFirestore, $userId: String, $acknowledgmentFilter: AcknowledgmentTypeFilters) {
  getPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestore(
    input: {startAt: $startAt, endAt: $endAt, instanceId: $instanceId, rubricsId: $rubricsId, teamsId: $teamsId, reviewType: $reviewType, userId: $userId, acknowledgmentFilter: $acknowledgmentFilter}
  ) {
    reviews {
      reviewId
      reviewStartedAt
      reviewCompletedAt
      handleTime
      reviewerUUID
      teamId
      reviewURL
      isAutofailed
      assigneeUUID
      rubricName
      isAcknowledged
      assigneeData {
        name
      }
      totalScore
      reviewerData {
        name
        photoURL
      }
      isAcknowledged
      tags
    }
    metadata {
      needFocus
      currentStrength
      completedReviewsCounter
      averageTicketsScore
      acknowledgedReviewsCounter
    }
  }
}
    `;

/**
 * __useGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery__
 *
 * To run a query within a React component, call `useGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery({
 *   variables: {
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *      instanceId: // value for 'instanceId'
 *      rubricsId: // value for 'rubricsId'
 *      teamsId: // value for 'teamsId'
 *      reviewType: // value for 'reviewType'
 *      userId: // value for 'userId'
 *      acknowledgmentFilter: // value for 'acknowledgmentFilter'
 *   },
 * });
 */
export function useGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery, GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables> & ({ variables: GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery, GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables>(GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreDocument, options);
      }
export function useGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery, GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery, GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables>(GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreDocument, options);
        }
export function useGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery, GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery, GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables>(GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreDocument, options);
        }
export type GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryHookResult = ReturnType<typeof useGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery>;
export type GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreLazyQueryHookResult = ReturnType<typeof useGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreLazyQuery>;
export type GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreSuspenseQueryHookResult = ReturnType<typeof useGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreSuspenseQuery>;
export type GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryResult = Apollo.QueryResult<GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery, GetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables>;
export const GetPendingCalibrationsPerEvaluatorDocument = gql`
    query getPendingCalibrationsPerEvaluator($userId: String!, $instanceId: String!) {
  getPendingCalibrationsPerEvaluator(userId: $userId, instanceId: $instanceId) {
    name
    url
    calibrationId
  }
}
    `;

/**
 * __useGetPendingCalibrationsPerEvaluatorQuery__
 *
 * To run a query within a React component, call `useGetPendingCalibrationsPerEvaluatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingCalibrationsPerEvaluatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingCalibrationsPerEvaluatorQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useGetPendingCalibrationsPerEvaluatorQuery(baseOptions: Apollo.QueryHookOptions<GetPendingCalibrationsPerEvaluatorQuery, GetPendingCalibrationsPerEvaluatorQueryVariables> & ({ variables: GetPendingCalibrationsPerEvaluatorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingCalibrationsPerEvaluatorQuery, GetPendingCalibrationsPerEvaluatorQueryVariables>(GetPendingCalibrationsPerEvaluatorDocument, options);
      }
export function useGetPendingCalibrationsPerEvaluatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingCalibrationsPerEvaluatorQuery, GetPendingCalibrationsPerEvaluatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingCalibrationsPerEvaluatorQuery, GetPendingCalibrationsPerEvaluatorQueryVariables>(GetPendingCalibrationsPerEvaluatorDocument, options);
        }
export function useGetPendingCalibrationsPerEvaluatorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPendingCalibrationsPerEvaluatorQuery, GetPendingCalibrationsPerEvaluatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingCalibrationsPerEvaluatorQuery, GetPendingCalibrationsPerEvaluatorQueryVariables>(GetPendingCalibrationsPerEvaluatorDocument, options);
        }
export type GetPendingCalibrationsPerEvaluatorQueryHookResult = ReturnType<typeof useGetPendingCalibrationsPerEvaluatorQuery>;
export type GetPendingCalibrationsPerEvaluatorLazyQueryHookResult = ReturnType<typeof useGetPendingCalibrationsPerEvaluatorLazyQuery>;
export type GetPendingCalibrationsPerEvaluatorSuspenseQueryHookResult = ReturnType<typeof useGetPendingCalibrationsPerEvaluatorSuspenseQuery>;
export type GetPendingCalibrationsPerEvaluatorQueryResult = Apollo.QueryResult<GetPendingCalibrationsPerEvaluatorQuery, GetPendingCalibrationsPerEvaluatorQueryVariables>;
export const GetRestrictedDomainsDocument = gql`
    query GetRestrictedDomains {
  getRestrictedDomains
}
    `;

/**
 * __useGetRestrictedDomainsQuery__
 *
 * To run a query within a React component, call `useGetRestrictedDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestrictedDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestrictedDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRestrictedDomainsQuery(baseOptions?: Apollo.QueryHookOptions<GetRestrictedDomainsQuery, GetRestrictedDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestrictedDomainsQuery, GetRestrictedDomainsQueryVariables>(GetRestrictedDomainsDocument, options);
      }
export function useGetRestrictedDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestrictedDomainsQuery, GetRestrictedDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestrictedDomainsQuery, GetRestrictedDomainsQueryVariables>(GetRestrictedDomainsDocument, options);
        }
export function useGetRestrictedDomainsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRestrictedDomainsQuery, GetRestrictedDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRestrictedDomainsQuery, GetRestrictedDomainsQueryVariables>(GetRestrictedDomainsDocument, options);
        }
export type GetRestrictedDomainsQueryHookResult = ReturnType<typeof useGetRestrictedDomainsQuery>;
export type GetRestrictedDomainsLazyQueryHookResult = ReturnType<typeof useGetRestrictedDomainsLazyQuery>;
export type GetRestrictedDomainsSuspenseQueryHookResult = ReturnType<typeof useGetRestrictedDomainsSuspenseQuery>;
export type GetRestrictedDomainsQueryResult = Apollo.QueryResult<GetRestrictedDomainsQuery, GetRestrictedDomainsQueryVariables>;
export const GetRubricDocument = gql`
    query GetRubric($rubricId: String!) {
  getRubric(rubricId: $rubricId) {
    id
    createdDate
    instanceId
    status
    name
    nameLowerCase
    categories {
      id
      requiresComments
      orderIndex
      measurementType
      weight
      name
      questions {
        id
        name
        weight
        description
        requiresComments
        orderIndex
      }
      measurementOptions {
        label
        value
      }
      notApplicable
      autoFailEnabled
    }
    teamId
    favorite
    createdBy
  }
}
    `;

/**
 * __useGetRubricQuery__
 *
 * To run a query within a React component, call `useGetRubricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRubricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRubricQuery({
 *   variables: {
 *      rubricId: // value for 'rubricId'
 *   },
 * });
 */
export function useGetRubricQuery(baseOptions: Apollo.QueryHookOptions<GetRubricQuery, GetRubricQueryVariables> & ({ variables: GetRubricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRubricQuery, GetRubricQueryVariables>(GetRubricDocument, options);
      }
export function useGetRubricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRubricQuery, GetRubricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRubricQuery, GetRubricQueryVariables>(GetRubricDocument, options);
        }
export function useGetRubricSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRubricQuery, GetRubricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRubricQuery, GetRubricQueryVariables>(GetRubricDocument, options);
        }
export type GetRubricQueryHookResult = ReturnType<typeof useGetRubricQuery>;
export type GetRubricLazyQueryHookResult = ReturnType<typeof useGetRubricLazyQuery>;
export type GetRubricSuspenseQueryHookResult = ReturnType<typeof useGetRubricSuspenseQuery>;
export type GetRubricQueryResult = Apollo.QueryResult<GetRubricQuery, GetRubricQueryVariables>;
export const GetRubricsDocument = gql`
    query GetRubrics($instanceId: String!, $favorite: Boolean, $status: RubricsStatus, $nameLowerCase: String) {
  getRubrics(
    instanceId: $instanceId
    favorite: $favorite
    status: $status
    nameLowerCase: $nameLowerCase
  ) {
    id
    createdDate
    instanceId
    status
    name
    nameLowerCase
    categories {
      id
      requiresComments
      orderIndex
      measurementType
      weight
      name
      questions {
        id
        name
        weight
        description
        requiresComments
        orderIndex
      }
      measurementOptions {
        label
        value
      }
      notApplicable
      autoFailEnabled
    }
    teamId
    favorite
    createdBy
  }
}
    `;

/**
 * __useGetRubricsQuery__
 *
 * To run a query within a React component, call `useGetRubricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRubricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRubricsQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      favorite: // value for 'favorite'
 *      status: // value for 'status'
 *      nameLowerCase: // value for 'nameLowerCase'
 *   },
 * });
 */
export function useGetRubricsQuery(baseOptions: Apollo.QueryHookOptions<GetRubricsQuery, GetRubricsQueryVariables> & ({ variables: GetRubricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRubricsQuery, GetRubricsQueryVariables>(GetRubricsDocument, options);
      }
export function useGetRubricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRubricsQuery, GetRubricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRubricsQuery, GetRubricsQueryVariables>(GetRubricsDocument, options);
        }
export function useGetRubricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRubricsQuery, GetRubricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRubricsQuery, GetRubricsQueryVariables>(GetRubricsDocument, options);
        }
export type GetRubricsQueryHookResult = ReturnType<typeof useGetRubricsQuery>;
export type GetRubricsLazyQueryHookResult = ReturnType<typeof useGetRubricsLazyQuery>;
export type GetRubricsSuspenseQueryHookResult = ReturnType<typeof useGetRubricsSuspenseQuery>;
export type GetRubricsQueryResult = Apollo.QueryResult<GetRubricsQuery, GetRubricsQueryVariables>;
export const GetRubricsStatsDocument = gql`
    query GetRubricsStats($instanceId: String!, $filterBy: filterBy!, $status: RubricsStatus) {
  getRubricsStats(instanceId: $instanceId, filterBy: $filterBy, status: $status) {
    id
    createdDate
    instanceId
    status
    name
    nameLowerCase
    categories {
      id
      requiresComments
      orderIndex
      measurementType
      weight
      name
      questions {
        id
        name
        weight
        description
        requiresComments
        orderIndex
      }
      notApplicable
      autoFailEnabled
    }
    teamId
    favorite
    createdBy
    totalReviewCount
    creatorData {
      displayName
      photoURL
    }
  }
}
    `;

/**
 * __useGetRubricsStatsQuery__
 *
 * To run a query within a React component, call `useGetRubricsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRubricsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRubricsStatsQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      filterBy: // value for 'filterBy'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetRubricsStatsQuery(baseOptions: Apollo.QueryHookOptions<GetRubricsStatsQuery, GetRubricsStatsQueryVariables> & ({ variables: GetRubricsStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRubricsStatsQuery, GetRubricsStatsQueryVariables>(GetRubricsStatsDocument, options);
      }
export function useGetRubricsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRubricsStatsQuery, GetRubricsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRubricsStatsQuery, GetRubricsStatsQueryVariables>(GetRubricsStatsDocument, options);
        }
export function useGetRubricsStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRubricsStatsQuery, GetRubricsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRubricsStatsQuery, GetRubricsStatsQueryVariables>(GetRubricsStatsDocument, options);
        }
export type GetRubricsStatsQueryHookResult = ReturnType<typeof useGetRubricsStatsQuery>;
export type GetRubricsStatsLazyQueryHookResult = ReturnType<typeof useGetRubricsStatsLazyQuery>;
export type GetRubricsStatsSuspenseQueryHookResult = ReturnType<typeof useGetRubricsStatsSuspenseQuery>;
export type GetRubricsStatsQueryResult = Apollo.QueryResult<GetRubricsStatsQuery, GetRubricsStatsQueryVariables>;
export const GetSubscriptionByInstanceIdDocument = gql`
    query GetSubscriptionByInstanceId($instanceId: String!) {
  getSubscriptionByInstanceId(instanceId: $instanceId) {
    customerId
    customerName
    instanceId
    isTrialing
    stripePlanId
    trialEnd
    trialStart
    subscriptionId
  }
}
    `;

/**
 * __useGetSubscriptionByInstanceIdQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionByInstanceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionByInstanceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionByInstanceIdQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useGetSubscriptionByInstanceIdQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionByInstanceIdQuery, GetSubscriptionByInstanceIdQueryVariables> & ({ variables: GetSubscriptionByInstanceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionByInstanceIdQuery, GetSubscriptionByInstanceIdQueryVariables>(GetSubscriptionByInstanceIdDocument, options);
      }
export function useGetSubscriptionByInstanceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionByInstanceIdQuery, GetSubscriptionByInstanceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionByInstanceIdQuery, GetSubscriptionByInstanceIdQueryVariables>(GetSubscriptionByInstanceIdDocument, options);
        }
export function useGetSubscriptionByInstanceIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubscriptionByInstanceIdQuery, GetSubscriptionByInstanceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriptionByInstanceIdQuery, GetSubscriptionByInstanceIdQueryVariables>(GetSubscriptionByInstanceIdDocument, options);
        }
export type GetSubscriptionByInstanceIdQueryHookResult = ReturnType<typeof useGetSubscriptionByInstanceIdQuery>;
export type GetSubscriptionByInstanceIdLazyQueryHookResult = ReturnType<typeof useGetSubscriptionByInstanceIdLazyQuery>;
export type GetSubscriptionByInstanceIdSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionByInstanceIdSuspenseQuery>;
export type GetSubscriptionByInstanceIdQueryResult = Apollo.QueryResult<GetSubscriptionByInstanceIdQuery, GetSubscriptionByInstanceIdQueryVariables>;
export const GetSubscriptionPlanByIdDocument = gql`
    query GetSubscriptionPlanById($stripePlanId: String!) {
  getSubscriptionPlanById(stripePlanId: $stripePlanId) {
    id
    name
    price
    stripePlanId
    permissions {
      advancedRubrics
      analytics
      expressSupport
      featureRequest
      maxUsers
      reports
      subteams
      trialDays
    }
  }
}
    `;

/**
 * __useGetSubscriptionPlanByIdQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionPlanByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionPlanByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionPlanByIdQuery({
 *   variables: {
 *      stripePlanId: // value for 'stripePlanId'
 *   },
 * });
 */
export function useGetSubscriptionPlanByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionPlanByIdQuery, GetSubscriptionPlanByIdQueryVariables> & ({ variables: GetSubscriptionPlanByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionPlanByIdQuery, GetSubscriptionPlanByIdQueryVariables>(GetSubscriptionPlanByIdDocument, options);
      }
export function useGetSubscriptionPlanByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionPlanByIdQuery, GetSubscriptionPlanByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionPlanByIdQuery, GetSubscriptionPlanByIdQueryVariables>(GetSubscriptionPlanByIdDocument, options);
        }
export function useGetSubscriptionPlanByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubscriptionPlanByIdQuery, GetSubscriptionPlanByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriptionPlanByIdQuery, GetSubscriptionPlanByIdQueryVariables>(GetSubscriptionPlanByIdDocument, options);
        }
export type GetSubscriptionPlanByIdQueryHookResult = ReturnType<typeof useGetSubscriptionPlanByIdQuery>;
export type GetSubscriptionPlanByIdLazyQueryHookResult = ReturnType<typeof useGetSubscriptionPlanByIdLazyQuery>;
export type GetSubscriptionPlanByIdSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionPlanByIdSuspenseQuery>;
export type GetSubscriptionPlanByIdQueryResult = Apollo.QueryResult<GetSubscriptionPlanByIdQuery, GetSubscriptionPlanByIdQueryVariables>;
export const GetTeamMembersDocument = gql`
    query getTeamMembers($instanceId: String, $teamId: String) {
  users(instanceId: $instanceId, teamId: $teamId) {
    displayName
    roles
    email
    id
    displayName
    uid
    teamId
    status
    photoURL
  }
}
    `;

/**
 * __useGetTeamMembersQuery__
 *
 * To run a query within a React component, call `useGetTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamMembersQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamMembersQuery, GetTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamMembersQuery, GetTeamMembersQueryVariables>(GetTeamMembersDocument, options);
      }
export function useGetTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamMembersQuery, GetTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamMembersQuery, GetTeamMembersQueryVariables>(GetTeamMembersDocument, options);
        }
export function useGetTeamMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeamMembersQuery, GetTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamMembersQuery, GetTeamMembersQueryVariables>(GetTeamMembersDocument, options);
        }
export type GetTeamMembersQueryHookResult = ReturnType<typeof useGetTeamMembersQuery>;
export type GetTeamMembersLazyQueryHookResult = ReturnType<typeof useGetTeamMembersLazyQuery>;
export type GetTeamMembersSuspenseQueryHookResult = ReturnType<typeof useGetTeamMembersSuspenseQuery>;
export type GetTeamMembersQueryResult = Apollo.QueryResult<GetTeamMembersQuery, GetTeamMembersQueryVariables>;
export const GetUserOrgsDocument = gql`
    query GetUserOrgs($email: String!) {
  userOrganizations(email: $email) {
    name
    displayName
    tenantUrl
    instanceId
  }
}
    `;

/**
 * __useGetUserOrgsQuery__
 *
 * To run a query within a React component, call `useGetUserOrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOrgsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserOrgsQuery(baseOptions: Apollo.QueryHookOptions<GetUserOrgsQuery, GetUserOrgsQueryVariables> & ({ variables: GetUserOrgsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserOrgsQuery, GetUserOrgsQueryVariables>(GetUserOrgsDocument, options);
      }
export function useGetUserOrgsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserOrgsQuery, GetUserOrgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserOrgsQuery, GetUserOrgsQueryVariables>(GetUserOrgsDocument, options);
        }
export function useGetUserOrgsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserOrgsQuery, GetUserOrgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserOrgsQuery, GetUserOrgsQueryVariables>(GetUserOrgsDocument, options);
        }
export type GetUserOrgsQueryHookResult = ReturnType<typeof useGetUserOrgsQuery>;
export type GetUserOrgsLazyQueryHookResult = ReturnType<typeof useGetUserOrgsLazyQuery>;
export type GetUserOrgsSuspenseQueryHookResult = ReturnType<typeof useGetUserOrgsSuspenseQuery>;
export type GetUserOrgsQueryResult = Apollo.QueryResult<GetUserOrgsQuery, GetUserOrgsQueryVariables>;
export const GetUsersDocument = gql`
    query getUsers($instanceId: String) {
  users(instanceId: $instanceId) {
    firstName
    lastName
    roles
    email
    id
    displayName
    uid
    teamId
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetWhiteListedDomainsDocument = gql`
    query getWhiteListedDomains($instanceId: String!) {
  getWhiteListedDomains(instanceId: $instanceId)
}
    `;

/**
 * __useGetWhiteListedDomainsQuery__
 *
 * To run a query within a React component, call `useGetWhiteListedDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWhiteListedDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWhiteListedDomainsQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useGetWhiteListedDomainsQuery(baseOptions: Apollo.QueryHookOptions<GetWhiteListedDomainsQuery, GetWhiteListedDomainsQueryVariables> & ({ variables: GetWhiteListedDomainsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWhiteListedDomainsQuery, GetWhiteListedDomainsQueryVariables>(GetWhiteListedDomainsDocument, options);
      }
export function useGetWhiteListedDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWhiteListedDomainsQuery, GetWhiteListedDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWhiteListedDomainsQuery, GetWhiteListedDomainsQueryVariables>(GetWhiteListedDomainsDocument, options);
        }
export function useGetWhiteListedDomainsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWhiteListedDomainsQuery, GetWhiteListedDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWhiteListedDomainsQuery, GetWhiteListedDomainsQueryVariables>(GetWhiteListedDomainsDocument, options);
        }
export type GetWhiteListedDomainsQueryHookResult = ReturnType<typeof useGetWhiteListedDomainsQuery>;
export type GetWhiteListedDomainsLazyQueryHookResult = ReturnType<typeof useGetWhiteListedDomainsLazyQuery>;
export type GetWhiteListedDomainsSuspenseQueryHookResult = ReturnType<typeof useGetWhiteListedDomainsSuspenseQuery>;
export type GetWhiteListedDomainsQueryResult = Apollo.QueryResult<GetWhiteListedDomainsQuery, GetWhiteListedDomainsQueryVariables>;
export const GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreDocument = gql`
    query getstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestore($startAt: Int!, $endAt: Int!, $instanceId: String!, $rubricsId: [String!]!, $teamsId: [String!]!, $reviewType: ReviewTypeFilterFirestore, $userId: String, $acknowledgmentFilter: AcknowledgmentTypeFilters) {
  structuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestore(
    input: {startAt: $startAt, endAt: $endAt, instanceId: $instanceId, rubricsId: $rubricsId, teamsId: $teamsId, reviewType: $reviewType, userId: $userId, acknowledgmentFilter: $acknowledgmentFilter}
  ) {
    reviews {
      reviewId
      reviewStartedAt
      reviewCompletedAt
      handleTime
      reviewUpdatedAt
      reviewerUUID
      teamId
      reviewURL
      assigneeUUID
      rubricName
      isAcknowledged
      assigneeData {
        name
      }
      totalScore
      reviewerData {
        name
        photoURL
      }
      isAcknowledged
      tags
    }
    metadata {
      needFocus
      currentStrength
      completedReviewsCounter
      averageTicketsScore
      acknowledgedReviewsCounter
    }
  }
}
    `;

/**
 * __useGetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery__
 *
 * To run a query within a React component, call `useGetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery({
 *   variables: {
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *      instanceId: // value for 'instanceId'
 *      rubricsId: // value for 'rubricsId'
 *      teamsId: // value for 'teamsId'
 *      reviewType: // value for 'reviewType'
 *      userId: // value for 'userId'
 *      acknowledgmentFilter: // value for 'acknowledgmentFilter'
 *   },
 * });
 */
export function useGetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery(baseOptions: Apollo.QueryHookOptions<GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery, GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables> & ({ variables: GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery, GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables>(GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreDocument, options);
      }
export function useGetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery, GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery, GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables>(GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreDocument, options);
        }
export function useGetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery, GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery, GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables>(GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreDocument, options);
        }
export type GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryHookResult = ReturnType<typeof useGetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery>;
export type GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreLazyQueryHookResult = ReturnType<typeof useGetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreLazyQuery>;
export type GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreSuspenseQueryHookResult = ReturnType<typeof useGetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreSuspenseQuery>;
export type GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryResult = Apollo.QueryResult<GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQuery, GetstructuredGetPartnerReviewsFilteredByTimeRangeAndRubricsFromFirestoreQueryVariables>;
export const GoalsDocument = gql`
    query Goals($instanceId: String!) {
  goals(instanceId: $instanceId) {
    sample
    qaScore
    errorFreeRate
    criticalErrorRate
    instanceId
  }
}
    `;

/**
 * __useGoalsQuery__
 *
 * To run a query within a React component, call `useGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalsQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useGoalsQuery(baseOptions: Apollo.QueryHookOptions<GoalsQuery, GoalsQueryVariables> & ({ variables: GoalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalsQuery, GoalsQueryVariables>(GoalsDocument, options);
      }
export function useGoalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalsQuery, GoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalsQuery, GoalsQueryVariables>(GoalsDocument, options);
        }
export function useGoalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalsQuery, GoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalsQuery, GoalsQueryVariables>(GoalsDocument, options);
        }
export type GoalsQueryHookResult = ReturnType<typeof useGoalsQuery>;
export type GoalsLazyQueryHookResult = ReturnType<typeof useGoalsLazyQuery>;
export type GoalsSuspenseQueryHookResult = ReturnType<typeof useGoalsSuspenseQuery>;
export type GoalsQueryResult = Apollo.QueryResult<GoalsQuery, GoalsQueryVariables>;
export const OrganizationByTenantDocument = gql`
    query OrganizationByTenant($tenant: String!) {
  organizationByTenant(tenant: $tenant) {
    id
  }
}
    `;

/**
 * __useOrganizationByTenantQuery__
 *
 * To run a query within a React component, call `useOrganizationByTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationByTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationByTenantQuery({
 *   variables: {
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useOrganizationByTenantQuery(baseOptions: Apollo.QueryHookOptions<OrganizationByTenantQuery, OrganizationByTenantQueryVariables> & ({ variables: OrganizationByTenantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationByTenantQuery, OrganizationByTenantQueryVariables>(OrganizationByTenantDocument, options);
      }
export function useOrganizationByTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationByTenantQuery, OrganizationByTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationByTenantQuery, OrganizationByTenantQueryVariables>(OrganizationByTenantDocument, options);
        }
export function useOrganizationByTenantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationByTenantQuery, OrganizationByTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationByTenantQuery, OrganizationByTenantQueryVariables>(OrganizationByTenantDocument, options);
        }
export type OrganizationByTenantQueryHookResult = ReturnType<typeof useOrganizationByTenantQuery>;
export type OrganizationByTenantLazyQueryHookResult = ReturnType<typeof useOrganizationByTenantLazyQuery>;
export type OrganizationByTenantSuspenseQueryHookResult = ReturnType<typeof useOrganizationByTenantSuspenseQuery>;
export type OrganizationByTenantQueryResult = Apollo.QueryResult<OrganizationByTenantQuery, OrganizationByTenantQueryVariables>;
export const QueueConfigurationDocument = gql`
    query QueueConfiguration($instanceId: String!) {
  queueConfiguration(instanceId: $instanceId) {
    instanceId
    dataConnected
    frequency
    ticketAmount
    countTicketsBy
    exclusions
    lastPullDateTime
    nextPullDateTime
  }
}
    `;

/**
 * __useQueueConfigurationQuery__
 *
 * To run a query within a React component, call `useQueueConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueueConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueueConfigurationQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useQueueConfigurationQuery(baseOptions: Apollo.QueryHookOptions<QueueConfigurationQuery, QueueConfigurationQueryVariables> & ({ variables: QueueConfigurationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueueConfigurationQuery, QueueConfigurationQueryVariables>(QueueConfigurationDocument, options);
      }
export function useQueueConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueueConfigurationQuery, QueueConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueueConfigurationQuery, QueueConfigurationQueryVariables>(QueueConfigurationDocument, options);
        }
export function useQueueConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueueConfigurationQuery, QueueConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueueConfigurationQuery, QueueConfigurationQueryVariables>(QueueConfigurationDocument, options);
        }
export type QueueConfigurationQueryHookResult = ReturnType<typeof useQueueConfigurationQuery>;
export type QueueConfigurationLazyQueryHookResult = ReturnType<typeof useQueueConfigurationLazyQuery>;
export type QueueConfigurationSuspenseQueryHookResult = ReturnType<typeof useQueueConfigurationSuspenseQuery>;
export type QueueConfigurationQueryResult = Apollo.QueryResult<QueueConfigurationQuery, QueueConfigurationQueryVariables>;
export const GetReviewWithCommentsDocument = gql`
    query getReviewWithComments($instanceId: String!, $reviewId: String!, $reviewerUUID: String!) {
  getReviewWithComments(
    input: {instanceId: $instanceId, reviewId: $reviewId, reviewerUUID: $reviewerUUID}
  ) {
    reviewId
    additionalFeedback
    assigneeUUID
    instanceId
    isAcknowledged
    isArchived
    isAutofailed
    isManuallyAssigned
    isCommentAvailable
    reviewAcknowledgedAt
    reviewStartedAt
    reviewCompletedAt
    handleTime
    reviewUpdatedAt
    reviewURL
    reviewerUUID
    rubricId
    rubricName
    status
    tags
    teamId
    totalScore
    scoreByQuestion {
      awardedQuestionPoints
      categoryId
      isAutofailed
      isRequiredComments
      isReviewed
      questionId
      questionName
      questionScore
      totalQuestionPoints
      comment {
        categoryId
        questionId
        comment
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
    scoreByCategory {
      awardedCategoryPoints
      binaryLabel
      categoryId
      categoryName
      categoryScore
      isRequiredComments
      measurementType
      measurementOptions {
        label
        value
      }
      orderIndex
      totalCategoryPoints
    }
    assigneeData {
      uid
      email
      name
      photoURL
    }
    reviewerData {
      uid
      email
      name
      photoURL
    }
  }
}
    `;

/**
 * __useGetReviewWithCommentsQuery__
 *
 * To run a query within a React component, call `useGetReviewWithCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewWithCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewWithCommentsQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      reviewId: // value for 'reviewId'
 *      reviewerUUID: // value for 'reviewerUUID'
 *   },
 * });
 */
export function useGetReviewWithCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetReviewWithCommentsQuery, GetReviewWithCommentsQueryVariables> & ({ variables: GetReviewWithCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewWithCommentsQuery, GetReviewWithCommentsQueryVariables>(GetReviewWithCommentsDocument, options);
      }
export function useGetReviewWithCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewWithCommentsQuery, GetReviewWithCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewWithCommentsQuery, GetReviewWithCommentsQueryVariables>(GetReviewWithCommentsDocument, options);
        }
export function useGetReviewWithCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReviewWithCommentsQuery, GetReviewWithCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReviewWithCommentsQuery, GetReviewWithCommentsQueryVariables>(GetReviewWithCommentsDocument, options);
        }
export type GetReviewWithCommentsQueryHookResult = ReturnType<typeof useGetReviewWithCommentsQuery>;
export type GetReviewWithCommentsLazyQueryHookResult = ReturnType<typeof useGetReviewWithCommentsLazyQuery>;
export type GetReviewWithCommentsSuspenseQueryHookResult = ReturnType<typeof useGetReviewWithCommentsSuspenseQuery>;
export type GetReviewWithCommentsQueryResult = Apollo.QueryResult<GetReviewWithCommentsQuery, GetReviewWithCommentsQueryVariables>;
export const SendRemainderForCalibrationRequestDocument = gql`
    query sendRemainderForCalibrationRequest($evaluatorName: String!, $evaluatorEmail: String!, $calibratorName: String!, $calibrationName: String!, $calibrationStartedAt: Int!, $calibratorPhotoURL: String!, $calibrationId: String!, $instanceId: String!) {
  sendRemainderForCalibrationRequest(
    evaluatorName: $evaluatorName
    evaluatorEmail: $evaluatorEmail
    calibratorName: $calibratorName
    calibrationName: $calibrationName
    calibrationStartedAt: $calibrationStartedAt
    calibratorPhotoURL: $calibratorPhotoURL
    instanceId: $instanceId
    calibrationId: $calibrationId
  ) {
    code
    message
  }
}
    `;

/**
 * __useSendRemainderForCalibrationRequestQuery__
 *
 * To run a query within a React component, call `useSendRemainderForCalibrationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendRemainderForCalibrationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendRemainderForCalibrationRequestQuery({
 *   variables: {
 *      evaluatorName: // value for 'evaluatorName'
 *      evaluatorEmail: // value for 'evaluatorEmail'
 *      calibratorName: // value for 'calibratorName'
 *      calibrationName: // value for 'calibrationName'
 *      calibrationStartedAt: // value for 'calibrationStartedAt'
 *      calibratorPhotoURL: // value for 'calibratorPhotoURL'
 *      calibrationId: // value for 'calibrationId'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useSendRemainderForCalibrationRequestQuery(baseOptions: Apollo.QueryHookOptions<SendRemainderForCalibrationRequestQuery, SendRemainderForCalibrationRequestQueryVariables> & ({ variables: SendRemainderForCalibrationRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendRemainderForCalibrationRequestQuery, SendRemainderForCalibrationRequestQueryVariables>(SendRemainderForCalibrationRequestDocument, options);
      }
export function useSendRemainderForCalibrationRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendRemainderForCalibrationRequestQuery, SendRemainderForCalibrationRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendRemainderForCalibrationRequestQuery, SendRemainderForCalibrationRequestQueryVariables>(SendRemainderForCalibrationRequestDocument, options);
        }
export function useSendRemainderForCalibrationRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SendRemainderForCalibrationRequestQuery, SendRemainderForCalibrationRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SendRemainderForCalibrationRequestQuery, SendRemainderForCalibrationRequestQueryVariables>(SendRemainderForCalibrationRequestDocument, options);
        }
export type SendRemainderForCalibrationRequestQueryHookResult = ReturnType<typeof useSendRemainderForCalibrationRequestQuery>;
export type SendRemainderForCalibrationRequestLazyQueryHookResult = ReturnType<typeof useSendRemainderForCalibrationRequestLazyQuery>;
export type SendRemainderForCalibrationRequestSuspenseQueryHookResult = ReturnType<typeof useSendRemainderForCalibrationRequestSuspenseQuery>;
export type SendRemainderForCalibrationRequestQueryResult = Apollo.QueryResult<SendRemainderForCalibrationRequestQuery, SendRemainderForCalibrationRequestQueryVariables>;
export const GetTeamRosterDetailsDocument = gql`
    query getTeamRosterDetails($instanceId: String!, $teamId: String!, $teamLeaderId: String!) {
  getTeamRosterDetails(
    instanceId: $instanceId
    teamId: $teamId
    teamLeaderId: $teamLeaderId
  ) {
    uid
    email
    totalReviewsGiven
    totalReviewsReceived
    firstName
    lastName
    displayName
    photoURL
    instanceId
    teamId
    roles
  }
}
    `;

/**
 * __useGetTeamRosterDetailsQuery__
 *
 * To run a query within a React component, call `useGetTeamRosterDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamRosterDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamRosterDetailsQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      teamId: // value for 'teamId'
 *      teamLeaderId: // value for 'teamLeaderId'
 *   },
 * });
 */
export function useGetTeamRosterDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamRosterDetailsQuery, GetTeamRosterDetailsQueryVariables> & ({ variables: GetTeamRosterDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamRosterDetailsQuery, GetTeamRosterDetailsQueryVariables>(GetTeamRosterDetailsDocument, options);
      }
export function useGetTeamRosterDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamRosterDetailsQuery, GetTeamRosterDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamRosterDetailsQuery, GetTeamRosterDetailsQueryVariables>(GetTeamRosterDetailsDocument, options);
        }
export function useGetTeamRosterDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeamRosterDetailsQuery, GetTeamRosterDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamRosterDetailsQuery, GetTeamRosterDetailsQueryVariables>(GetTeamRosterDetailsDocument, options);
        }
export type GetTeamRosterDetailsQueryHookResult = ReturnType<typeof useGetTeamRosterDetailsQuery>;
export type GetTeamRosterDetailsLazyQueryHookResult = ReturnType<typeof useGetTeamRosterDetailsLazyQuery>;
export type GetTeamRosterDetailsSuspenseQueryHookResult = ReturnType<typeof useGetTeamRosterDetailsSuspenseQuery>;
export type GetTeamRosterDetailsQueryResult = Apollo.QueryResult<GetTeamRosterDetailsQuery, GetTeamRosterDetailsQueryVariables>;
export const TicketQueuesDocument = gql`
    query TicketQueues($filters: GetTicketQueuesInput!) {
  ticketQueues(filters: $filters) {
    ticketQueueId
    instanceId
    ticketId
    ticketURL
    ticketChannel
    assigneeEmail
    assigneeName
    ticketStarted
    ticketClosed
    totalHandleTime
    reviewed
    discarded
    CRM
    userId
    queueBatchInfoId
  }
}
    `;

/**
 * __useTicketQueuesQuery__
 *
 * To run a query within a React component, call `useTicketQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketQueuesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTicketQueuesQuery(baseOptions: Apollo.QueryHookOptions<TicketQueuesQuery, TicketQueuesQueryVariables> & ({ variables: TicketQueuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketQueuesQuery, TicketQueuesQueryVariables>(TicketQueuesDocument, options);
      }
export function useTicketQueuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketQueuesQuery, TicketQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketQueuesQuery, TicketQueuesQueryVariables>(TicketQueuesDocument, options);
        }
export function useTicketQueuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TicketQueuesQuery, TicketQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TicketQueuesQuery, TicketQueuesQueryVariables>(TicketQueuesDocument, options);
        }
export type TicketQueuesQueryHookResult = ReturnType<typeof useTicketQueuesQuery>;
export type TicketQueuesLazyQueryHookResult = ReturnType<typeof useTicketQueuesLazyQuery>;
export type TicketQueuesSuspenseQueryHookResult = ReturnType<typeof useTicketQueuesSuspenseQuery>;
export type TicketQueuesQueryResult = Apollo.QueryResult<TicketQueuesQuery, TicketQueuesQueryVariables>;